(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/rellax/rellax.js
  var require_rellax = __commonJS({
    "node_modules/rellax/rellax.js"(exports, module) {
      (function(root, factory) {
        if (typeof define === "function" && define.amd) {
          define([], factory);
        } else if (typeof module === "object" && module.exports) {
          module.exports = factory();
        } else {
          root.Rellax = factory();
        }
      })(typeof window !== "undefined" ? window : global, function() {
        var Rellax2 = function(el, options) {
          "use strict";
          var self2 = Object.create(Rellax2.prototype);
          var posY = 0;
          var screenY = 0;
          var posX = 0;
          var screenX = 0;
          var blocks = [];
          var pause = true;
          var loop = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || function(callback) {
            return setTimeout(callback, 1e3 / 60);
          };
          var loopId = null;
          var supportsPassive = false;
          try {
            var opts = Object.defineProperty({}, "passive", {
              get: function() {
                supportsPassive = true;
              }
            });
            window.addEventListener("testPassive", null, opts);
            window.removeEventListener("testPassive", null, opts);
          } catch (e2) {
          }
          var clearLoop = window.cancelAnimationFrame || window.mozCancelAnimationFrame || clearTimeout;
          var transformProp = window.transformProp || function() {
            var testEl = document.createElement("div");
            if (testEl.style.transform === null) {
              var vendors = ["Webkit", "Moz", "ms"];
              for (var vendor in vendors) {
                if (testEl.style[vendors[vendor] + "Transform"] !== void 0) {
                  return vendors[vendor] + "Transform";
                }
              }
            }
            return "transform";
          }();
          self2.options = {
            speed: -2,
            verticalSpeed: null,
            horizontalSpeed: null,
            breakpoints: [576, 768, 1201],
            center: false,
            wrapper: null,
            relativeToWrapper: false,
            round: true,
            vertical: true,
            horizontal: false,
            verticalScrollAxis: "y",
            horizontalScrollAxis: "x",
            callback: function() {
            }
          };
          if (options) {
            Object.keys(options).forEach(function(key) {
              self2.options[key] = options[key];
            });
          }
          function validateCustomBreakpoints() {
            if (self2.options.breakpoints.length === 3 && Array.isArray(self2.options.breakpoints)) {
              var isAscending = true;
              var isNumerical = true;
              var lastVal;
              self2.options.breakpoints.forEach(function(i2) {
                if (typeof i2 !== "number")
                  isNumerical = false;
                if (lastVal !== null) {
                  if (i2 < lastVal)
                    isAscending = false;
                }
                lastVal = i2;
              });
              if (isAscending && isNumerical)
                return;
            }
            self2.options.breakpoints = [576, 768, 1201];
            console.warn("Rellax: You must pass an array of 3 numbers in ascending order to the breakpoints option. Defaults reverted");
          }
          if (options && options.breakpoints) {
            validateCustomBreakpoints();
          }
          if (!el) {
            el = ".rellax";
          }
          var elements = typeof el === "string" ? document.querySelectorAll(el) : [el];
          if (elements.length > 0) {
            self2.elems = elements;
          } else {
            console.warn("Rellax: The elements you're trying to select don't exist.");
            return;
          }
          if (self2.options.wrapper) {
            if (!self2.options.wrapper.nodeType) {
              var wrapper = document.querySelector(self2.options.wrapper);
              if (wrapper) {
                self2.options.wrapper = wrapper;
              } else {
                console.warn("Rellax: The wrapper you're trying to use doesn't exist.");
                return;
              }
            }
          }
          var currentBreakpoint;
          var getCurrentBreakpoint = function(w2) {
            var bp = self2.options.breakpoints;
            if (w2 < bp[0])
              return "xs";
            if (w2 >= bp[0] && w2 < bp[1])
              return "sm";
            if (w2 >= bp[1] && w2 < bp[2])
              return "md";
            return "lg";
          };
          var cacheBlocks = function() {
            for (var i2 = 0; i2 < self2.elems.length; i2++) {
              var block = createBlock(self2.elems[i2]);
              blocks.push(block);
            }
          };
          var init = function() {
            for (var i2 = 0; i2 < blocks.length; i2++) {
              self2.elems[i2].style.cssText = blocks[i2].style;
            }
            blocks = [];
            screenY = window.innerHeight;
            screenX = window.innerWidth;
            currentBreakpoint = getCurrentBreakpoint(screenX);
            setPosition();
            cacheBlocks();
            animate();
            if (pause) {
              window.addEventListener("resize", init);
              pause = false;
              update();
            }
          };
          var createBlock = function(el2) {
            var dataPercentage = el2.getAttribute("data-rellax-percentage");
            var dataSpeed = el2.getAttribute("data-rellax-speed");
            var dataXsSpeed = el2.getAttribute("data-rellax-xs-speed");
            var dataMobileSpeed = el2.getAttribute("data-rellax-mobile-speed");
            var dataTabletSpeed = el2.getAttribute("data-rellax-tablet-speed");
            var dataDesktopSpeed = el2.getAttribute("data-rellax-desktop-speed");
            var dataVerticalSpeed = el2.getAttribute("data-rellax-vertical-speed");
            var dataHorizontalSpeed = el2.getAttribute("data-rellax-horizontal-speed");
            var dataVericalScrollAxis = el2.getAttribute("data-rellax-vertical-scroll-axis");
            var dataHorizontalScrollAxis = el2.getAttribute("data-rellax-horizontal-scroll-axis");
            var dataZindex = el2.getAttribute("data-rellax-zindex") || 0;
            var dataMin = el2.getAttribute("data-rellax-min");
            var dataMax = el2.getAttribute("data-rellax-max");
            var dataMinX = el2.getAttribute("data-rellax-min-x");
            var dataMaxX = el2.getAttribute("data-rellax-max-x");
            var dataMinY = el2.getAttribute("data-rellax-min-y");
            var dataMaxY = el2.getAttribute("data-rellax-max-y");
            var mapBreakpoints;
            var breakpoints = true;
            if (!dataXsSpeed && !dataMobileSpeed && !dataTabletSpeed && !dataDesktopSpeed) {
              breakpoints = false;
            } else {
              mapBreakpoints = {
                "xs": dataXsSpeed,
                "sm": dataMobileSpeed,
                "md": dataTabletSpeed,
                "lg": dataDesktopSpeed
              };
            }
            var wrapperPosY = self2.options.wrapper ? self2.options.wrapper.scrollTop : window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (self2.options.relativeToWrapper) {
              var scrollPosY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
              wrapperPosY = scrollPosY - self2.options.wrapper.offsetTop;
            }
            var posY2 = self2.options.vertical ? dataPercentage || self2.options.center ? wrapperPosY : 0 : 0;
            var posX2 = self2.options.horizontal ? dataPercentage || self2.options.center ? self2.options.wrapper ? self2.options.wrapper.scrollLeft : window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft : 0 : 0;
            var blockTop = posY2 + el2.getBoundingClientRect().top;
            var blockHeight = el2.clientHeight || el2.offsetHeight || el2.scrollHeight;
            var blockLeft = posX2 + el2.getBoundingClientRect().left;
            var blockWidth = el2.clientWidth || el2.offsetWidth || el2.scrollWidth;
            var percentageY = dataPercentage ? dataPercentage : (posY2 - blockTop + screenY) / (blockHeight + screenY);
            var percentageX = dataPercentage ? dataPercentage : (posX2 - blockLeft + screenX) / (blockWidth + screenX);
            if (self2.options.center) {
              percentageX = 0.5;
              percentageY = 0.5;
            }
            var speed = breakpoints && mapBreakpoints[currentBreakpoint] !== null ? Number(mapBreakpoints[currentBreakpoint]) : dataSpeed ? dataSpeed : self2.options.speed;
            var verticalSpeed = dataVerticalSpeed ? dataVerticalSpeed : self2.options.verticalSpeed;
            var horizontalSpeed = dataHorizontalSpeed ? dataHorizontalSpeed : self2.options.horizontalSpeed;
            var verticalScrollAxis = dataVericalScrollAxis ? dataVericalScrollAxis : self2.options.verticalScrollAxis;
            var horizontalScrollAxis = dataHorizontalScrollAxis ? dataHorizontalScrollAxis : self2.options.horizontalScrollAxis;
            var bases = updatePosition(percentageX, percentageY, speed, verticalSpeed, horizontalSpeed);
            var style2 = el2.style.cssText;
            var transform = "";
            var searchResult = /transform\s*:/i.exec(style2);
            if (searchResult) {
              var index = searchResult.index;
              var trimmedStyle = style2.slice(index);
              var delimiter = trimmedStyle.indexOf(";");
              if (delimiter) {
                transform = " " + trimmedStyle.slice(11, delimiter).replace(/\s/g, "");
              } else {
                transform = " " + trimmedStyle.slice(11).replace(/\s/g, "");
              }
            }
            return {
              baseX: bases.x,
              baseY: bases.y,
              top: blockTop,
              left: blockLeft,
              height: blockHeight,
              width: blockWidth,
              speed,
              verticalSpeed,
              horizontalSpeed,
              verticalScrollAxis,
              horizontalScrollAxis,
              style: style2,
              transform,
              zindex: dataZindex,
              min: dataMin,
              max: dataMax,
              minX: dataMinX,
              maxX: dataMaxX,
              minY: dataMinY,
              maxY: dataMaxY
            };
          };
          var setPosition = function() {
            var oldY = posY;
            var oldX = posX;
            posY = self2.options.wrapper ? self2.options.wrapper.scrollTop : (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset;
            posX = self2.options.wrapper ? self2.options.wrapper.scrollLeft : (document.documentElement || document.body.parentNode || document.body).scrollLeft || window.pageXOffset;
            if (self2.options.relativeToWrapper) {
              var scrollPosY = (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset;
              posY = scrollPosY - self2.options.wrapper.offsetTop;
            }
            if (oldY != posY && self2.options.vertical) {
              return true;
            }
            if (oldX != posX && self2.options.horizontal) {
              return true;
            }
            return false;
          };
          var updatePosition = function(percentageX, percentageY, speed, verticalSpeed, horizontalSpeed) {
            var result = {};
            var valueX = (horizontalSpeed ? horizontalSpeed : speed) * (100 * (1 - percentageX));
            var valueY = (verticalSpeed ? verticalSpeed : speed) * (100 * (1 - percentageY));
            result.x = self2.options.round ? Math.round(valueX) : Math.round(valueX * 100) / 100;
            result.y = self2.options.round ? Math.round(valueY) : Math.round(valueY * 100) / 100;
            return result;
          };
          var deferredUpdate = function() {
            window.removeEventListener("resize", deferredUpdate);
            window.removeEventListener("orientationchange", deferredUpdate);
            (self2.options.wrapper ? self2.options.wrapper : window).removeEventListener("scroll", deferredUpdate);
            (self2.options.wrapper ? self2.options.wrapper : document).removeEventListener("touchmove", deferredUpdate);
            loopId = loop(update);
          };
          var update = function() {
            if (setPosition() && pause === false) {
              animate();
              loopId = loop(update);
            } else {
              loopId = null;
              window.addEventListener("resize", deferredUpdate);
              window.addEventListener("orientationchange", deferredUpdate);
              (self2.options.wrapper ? self2.options.wrapper : window).addEventListener("scroll", deferredUpdate, supportsPassive ? { passive: true } : false);
              (self2.options.wrapper ? self2.options.wrapper : document).addEventListener("touchmove", deferredUpdate, supportsPassive ? { passive: true } : false);
            }
          };
          var animate = function() {
            var positions;
            for (var i2 = 0; i2 < self2.elems.length; i2++) {
              var verticalScrollAxis = blocks[i2].verticalScrollAxis.toLowerCase();
              var horizontalScrollAxis = blocks[i2].horizontalScrollAxis.toLowerCase();
              var verticalScrollX = verticalScrollAxis.indexOf("x") != -1 ? posY : 0;
              var verticalScrollY = verticalScrollAxis.indexOf("y") != -1 ? posY : 0;
              var horizontalScrollX = horizontalScrollAxis.indexOf("x") != -1 ? posX : 0;
              var horizontalScrollY = horizontalScrollAxis.indexOf("y") != -1 ? posX : 0;
              var percentageY = (verticalScrollY + horizontalScrollY - blocks[i2].top + screenY) / (blocks[i2].height + screenY);
              var percentageX = (verticalScrollX + horizontalScrollX - blocks[i2].left + screenX) / (blocks[i2].width + screenX);
              positions = updatePosition(percentageX, percentageY, blocks[i2].speed, blocks[i2].verticalSpeed, blocks[i2].horizontalSpeed);
              var positionY = positions.y - blocks[i2].baseY;
              var positionX = positions.x - blocks[i2].baseX;
              if (blocks[i2].min !== null) {
                if (self2.options.vertical && !self2.options.horizontal) {
                  positionY = positionY <= blocks[i2].min ? blocks[i2].min : positionY;
                }
                if (self2.options.horizontal && !self2.options.vertical) {
                  positionX = positionX <= blocks[i2].min ? blocks[i2].min : positionX;
                }
              }
              if (blocks[i2].minY != null) {
                positionY = positionY <= blocks[i2].minY ? blocks[i2].minY : positionY;
              }
              if (blocks[i2].minX != null) {
                positionX = positionX <= blocks[i2].minX ? blocks[i2].minX : positionX;
              }
              if (blocks[i2].max !== null) {
                if (self2.options.vertical && !self2.options.horizontal) {
                  positionY = positionY >= blocks[i2].max ? blocks[i2].max : positionY;
                }
                if (self2.options.horizontal && !self2.options.vertical) {
                  positionX = positionX >= blocks[i2].max ? blocks[i2].max : positionX;
                }
              }
              if (blocks[i2].maxY != null) {
                positionY = positionY >= blocks[i2].maxY ? blocks[i2].maxY : positionY;
              }
              if (blocks[i2].maxX != null) {
                positionX = positionX >= blocks[i2].maxX ? blocks[i2].maxX : positionX;
              }
              var zindex = blocks[i2].zindex;
              var translate = "translate3d(" + (self2.options.horizontal ? positionX : "0") + "px," + (self2.options.vertical ? positionY : "0") + "px," + zindex + "px) " + blocks[i2].transform;
              self2.elems[i2].style[transformProp] = translate;
            }
            self2.options.callback(positions);
          };
          self2.destroy = function() {
            for (var i2 = 0; i2 < self2.elems.length; i2++) {
              self2.elems[i2].style.cssText = blocks[i2].style;
            }
            if (!pause) {
              window.removeEventListener("resize", init);
              pause = true;
            }
            clearLoop(loopId);
            loopId = null;
          };
          init();
          self2.refresh = init;
          return self2;
        };
        return Rellax2;
      });
    }
  });

  // node_modules/@splidejs/splide/dist/js/splide.esm.js
  function _defineProperties(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
      _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
  }
  var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
  var CREATED = 1;
  var MOUNTED = 2;
  var IDLE = 3;
  var MOVING = 4;
  var SCROLLING = 5;
  var DRAGGING = 6;
  var DESTROYED = 7;
  var STATES = {
    CREATED,
    MOUNTED,
    IDLE,
    MOVING,
    SCROLLING,
    DRAGGING,
    DESTROYED
  };
  function empty(array) {
    array.length = 0;
  }
  function slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
  }
  function apply(func) {
    return func.bind.apply(func, [null].concat(slice(arguments, 1)));
  }
  var nextTick = setTimeout;
  var noop = function noop2() {
  };
  function raf(func) {
    return requestAnimationFrame(func);
  }
  function typeOf(type, subject) {
    return typeof subject === type;
  }
  function isObject(subject) {
    return !isNull(subject) && typeOf("object", subject);
  }
  var isArray = Array.isArray;
  var isFunction = apply(typeOf, "function");
  var isString = apply(typeOf, "string");
  var isUndefined = apply(typeOf, "undefined");
  function isNull(subject) {
    return subject === null;
  }
  function isHTMLElement(subject) {
    try {
      return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e2) {
      return false;
    }
  }
  function toArray(value) {
    return isArray(value) ? value : [value];
  }
  function forEach(values, iteratee) {
    toArray(values).forEach(iteratee);
  }
  function includes(array, value) {
    return array.indexOf(value) > -1;
  }
  function push(array, items) {
    array.push.apply(array, toArray(items));
    return array;
  }
  function toggleClass(elm, classes, add) {
    if (elm) {
      forEach(classes, function(name) {
        if (name) {
          elm.classList[add ? "add" : "remove"](name);
        }
      });
    }
  }
  function addClass(elm, classes) {
    toggleClass(elm, isString(classes) ? classes.split(" ") : classes, true);
  }
  function append(parent, children2) {
    forEach(children2, parent.appendChild.bind(parent));
  }
  function before(nodes, ref) {
    forEach(nodes, function(node) {
      var parent = (ref || node).parentNode;
      if (parent) {
        parent.insertBefore(node, ref);
      }
    });
  }
  function matches(elm, selector) {
    return isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
  }
  function children(parent, selector) {
    var children2 = parent ? slice(parent.children) : [];
    return selector ? children2.filter(function(child2) {
      return matches(child2, selector);
    }) : children2;
  }
  function child(parent, selector) {
    return selector ? children(parent, selector)[0] : parent.firstElementChild;
  }
  var ownKeys = Object.keys;
  function forOwn(object, iteratee, right) {
    if (object) {
      (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
      });
    }
    return object;
  }
  function assign(object) {
    slice(arguments, 1).forEach(function(source) {
      forOwn(source, function(value, key) {
        object[key] = source[key];
      });
    });
    return object;
  }
  function merge(object) {
    slice(arguments, 1).forEach(function(source) {
      forOwn(source, function(value, key) {
        if (isArray(value)) {
          object[key] = value.slice();
        } else if (isObject(value)) {
          object[key] = merge({}, isObject(object[key]) ? object[key] : {}, value);
        } else {
          object[key] = value;
        }
      });
    });
    return object;
  }
  function omit(object, keys) {
    forEach(keys || ownKeys(object), function(key) {
      delete object[key];
    });
  }
  function removeAttribute(elms, attrs) {
    forEach(elms, function(elm) {
      forEach(attrs, function(attr) {
        elm && elm.removeAttribute(attr);
      });
    });
  }
  function setAttribute(elms, attrs, value) {
    if (isObject(attrs)) {
      forOwn(attrs, function(value2, name) {
        setAttribute(elms, name, value2);
      });
    } else {
      forEach(elms, function(elm) {
        isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
      });
    }
  }
  function create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) {
      isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
    }
    parent && append(parent, elm);
    return elm;
  }
  function style(elm, prop, value) {
    if (isUndefined(value)) {
      return getComputedStyle(elm)[prop];
    }
    if (!isNull(value)) {
      elm.style[prop] = "" + value;
    }
  }
  function display(elm, display2) {
    style(elm, "display", display2);
  }
  function focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
      preventScroll: true
    });
  }
  function getAttribute(elm, attr) {
    return elm.getAttribute(attr);
  }
  function hasClass(elm, className) {
    return elm && elm.classList.contains(className);
  }
  function rect(target) {
    return target.getBoundingClientRect();
  }
  function remove(nodes) {
    forEach(nodes, function(node) {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });
  }
  function parseHtml(html) {
    return child(new DOMParser().parseFromString(html, "text/html").body);
  }
  function prevent(e2, stopPropagation) {
    e2.preventDefault();
    if (stopPropagation) {
      e2.stopPropagation();
      e2.stopImmediatePropagation();
    }
  }
  function query(parent, selector) {
    return parent && parent.querySelector(selector);
  }
  function queryAll(parent, selector) {
    return selector ? slice(parent.querySelectorAll(selector)) : [];
  }
  function removeClass(elm, classes) {
    toggleClass(elm, classes, false);
  }
  function timeOf(e2) {
    return e2.timeStamp;
  }
  function unit(value) {
    return isString(value) ? value : value ? value + "px" : "";
  }
  var PROJECT_CODE = "splide";
  var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;
  function assert(condition, message) {
    if (!condition) {
      throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
    }
  }
  var min = Math.min;
  var max = Math.max;
  var floor = Math.floor;
  var ceil = Math.ceil;
  var abs = Math.abs;
  function approximatelyEqual(x2, y2, epsilon) {
    return abs(x2 - y2) < epsilon;
  }
  function between(number, x2, y2, exclusive) {
    var minimum = min(x2, y2);
    var maximum = max(x2, y2);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
  }
  function clamp(number, x2, y2) {
    var minimum = min(x2, y2);
    var maximum = max(x2, y2);
    return min(max(minimum, number), maximum);
  }
  function sign(x2) {
    return +(x2 > 0) - +(x2 < 0);
  }
  function format(string, replacements) {
    forEach(replacements, function(replacement) {
      string = string.replace("%s", "" + replacement);
    });
    return string;
  }
  function pad(number) {
    return number < 10 ? "0" + number : "" + number;
  }
  var ids = {};
  function uniqueId(prefix) {
    return "" + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
  }
  function EventBinder() {
    var listeners = [];
    function bind(targets, events, callback, options) {
      forEachEvent(targets, events, function(target, event2, namespace) {
        var isEventTarget = "addEventListener" in target;
        var remover = isEventTarget ? target.removeEventListener.bind(target, event2, callback, options) : target["removeListener"].bind(target, callback);
        isEventTarget ? target.addEventListener(event2, callback, options) : target["addListener"](callback);
        listeners.push([target, event2, namespace, callback, remover]);
      });
    }
    function unbind(targets, events, callback) {
      forEachEvent(targets, events, function(target, event2, namespace) {
        listeners = listeners.filter(function(listener) {
          if (listener[0] === target && listener[1] === event2 && listener[2] === namespace && (!callback || listener[3] === callback)) {
            listener[4]();
            return false;
          }
          return true;
        });
      });
    }
    function dispatch(target, type, detail) {
      var e2;
      var bubbles = true;
      if (typeof CustomEvent === "function") {
        e2 = new CustomEvent(type, {
          bubbles,
          detail
        });
      } else {
        e2 = document.createEvent("CustomEvent");
        e2.initCustomEvent(type, bubbles, false, detail);
      }
      target.dispatchEvent(e2);
      return e2;
    }
    function forEachEvent(targets, events, iteratee) {
      forEach(targets, function(target) {
        target && forEach(events, function(events2) {
          events2.split(" ").forEach(function(eventNS) {
            var fragment = eventNS.split(".");
            iteratee(target, fragment[0], fragment[1]);
          });
        });
      });
    }
    function destroy() {
      listeners.forEach(function(data) {
        data[4]();
      });
      empty(listeners);
    }
    return {
      bind,
      unbind,
      dispatch,
      destroy
    };
  }
  var EVENT_MOUNTED = "mounted";
  var EVENT_READY = "ready";
  var EVENT_MOVE = "move";
  var EVENT_MOVED = "moved";
  var EVENT_CLICK = "click";
  var EVENT_ACTIVE = "active";
  var EVENT_INACTIVE = "inactive";
  var EVENT_VISIBLE = "visible";
  var EVENT_HIDDEN = "hidden";
  var EVENT_REFRESH = "refresh";
  var EVENT_UPDATED = "updated";
  var EVENT_RESIZE = "resize";
  var EVENT_RESIZED = "resized";
  var EVENT_DRAG = "drag";
  var EVENT_DRAGGING = "dragging";
  var EVENT_DRAGGED = "dragged";
  var EVENT_SCROLL = "scroll";
  var EVENT_SCROLLED = "scrolled";
  var EVENT_OVERFLOW = "overflow";
  var EVENT_DESTROY = "destroy";
  var EVENT_ARROWS_MOUNTED = "arrows:mounted";
  var EVENT_ARROWS_UPDATED = "arrows:updated";
  var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
  var EVENT_PAGINATION_UPDATED = "pagination:updated";
  var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
  var EVENT_AUTOPLAY_PLAY = "autoplay:play";
  var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
  var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
  var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
  var EVENT_SLIDE_KEYDOWN = "sk";
  var EVENT_SHIFTED = "sh";
  var EVENT_END_INDEX_CHANGED = "ei";
  function EventInterface(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = EventBinder();
    function on(events, callback) {
      binder.bind(bus, toArray(events).join(" "), function(e2) {
        callback.apply(callback, isArray(e2.detail) ? e2.detail : []);
      });
    }
    function emit(event2) {
      binder.dispatch(bus, event2, slice(arguments, 1));
    }
    if (Splide2) {
      Splide2.event.on(EVENT_DESTROY, binder.destroy);
    }
    return assign(binder, {
      bus,
      on,
      off: apply(binder.unbind, bus),
      emit
    });
  }
  function RequestInterval(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
      if (!paused) {
        rate = interval ? min((now() - startTime) / interval, 1) : 1;
        onUpdate && onUpdate(rate);
        if (rate >= 1) {
          onInterval();
          startTime = now();
          if (limit && ++count >= limit) {
            return pause();
          }
        }
        id = raf(update);
      }
    }
    function start(resume) {
      resume || cancel();
      startTime = now() - (resume ? rate * interval : 0);
      paused = false;
      id = raf(update);
    }
    function pause() {
      paused = true;
    }
    function rewind() {
      startTime = now();
      rate = 0;
      if (onUpdate) {
        onUpdate(rate);
      }
    }
    function cancel() {
      id && cancelAnimationFrame(id);
      rate = 0;
      id = 0;
      paused = true;
    }
    function set(time) {
      interval = time;
    }
    function isPaused() {
      return paused;
    }
    return {
      start,
      rewind,
      pause,
      cancel,
      set,
      isPaused
    };
  }
  function State(initialState) {
    var state = initialState;
    function set(value) {
      state = value;
    }
    function is(states) {
      return includes(toArray(states), state);
    }
    return {
      set,
      is
    };
  }
  function Throttle(func, duration) {
    var interval = RequestInterval(duration || 0, func, null, 1);
    return function() {
      interval.isPaused() && interval.start();
    };
  }
  function Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = EventBinder();
    var queries = [];
    function setup() {
      var isMin = options.mediaQuery === "min";
      ownKeys(breakpoints).sort(function(n2, m2) {
        return isMin ? +n2 - +m2 : +m2 - +n2;
      }).forEach(function(key) {
        register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
      });
      register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
      update();
    }
    function destroy(completely) {
      if (completely) {
        binder.destroy();
      }
    }
    function register(options2, query2) {
      var queryList = matchMedia(query2);
      binder.bind(queryList, "change", update);
      queries.push([options2, queryList]);
    }
    function update() {
      var destroyed = state.is(DESTROYED);
      var direction = options.direction;
      var merged = queries.reduce(function(merged2, entry) {
        return merge(merged2, entry[1].matches ? entry[0] : {});
      }, {});
      omit(options);
      set(merged);
      if (options.destroy) {
        Splide2.destroy(options.destroy === "completely");
      } else if (destroyed) {
        destroy(true);
        Splide2.mount();
      } else {
        direction !== options.direction && Splide2.refresh();
      }
    }
    function reduce(enable) {
      if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
        enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
      }
    }
    function set(opts, base, notify) {
      merge(options, opts);
      base && merge(Object.getPrototypeOf(options), opts);
      if (notify || !state.is(CREATED)) {
        Splide2.emit(EVENT_UPDATED, options);
      }
    }
    return {
      setup,
      destroy,
      reduce,
      set
    };
  }
  var ARROW = "Arrow";
  var ARROW_LEFT = ARROW + "Left";
  var ARROW_RIGHT = ARROW + "Right";
  var ARROW_UP = ARROW + "Up";
  var ARROW_DOWN = ARROW + "Down";
  var RTL = "rtl";
  var TTB = "ttb";
  var ORIENTATION_MAP = {
    width: ["height"],
    left: ["top", "right"],
    right: ["bottom", "left"],
    x: ["y"],
    X: ["Y"],
    Y: ["X"],
    ArrowLeft: [ARROW_UP, ARROW_RIGHT],
    ArrowRight: [ARROW_DOWN, ARROW_LEFT]
  };
  function Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
      direction = direction || options.direction;
      var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
      return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
        var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
        return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
      });
    }
    function orient(value) {
      return value * (options.direction === RTL ? 1 : -1);
    }
    return {
      resolve,
      orient
    };
  }
  var ROLE = "role";
  var TAB_INDEX = "tabindex";
  var DISABLED = "disabled";
  var ARIA_PREFIX = "aria-";
  var ARIA_CONTROLS = ARIA_PREFIX + "controls";
  var ARIA_CURRENT = ARIA_PREFIX + "current";
  var ARIA_SELECTED = ARIA_PREFIX + "selected";
  var ARIA_LABEL = ARIA_PREFIX + "label";
  var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
  var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
  var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
  var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
  var ARIA_LIVE = ARIA_PREFIX + "live";
  var ARIA_BUSY = ARIA_PREFIX + "busy";
  var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
  var ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION];
  var CLASS_PREFIX = PROJECT_CODE + "__";
  var STATUS_CLASS_PREFIX = "is-";
  var CLASS_ROOT = PROJECT_CODE;
  var CLASS_TRACK = CLASS_PREFIX + "track";
  var CLASS_LIST = CLASS_PREFIX + "list";
  var CLASS_SLIDE = CLASS_PREFIX + "slide";
  var CLASS_CLONE = CLASS_SLIDE + "--clone";
  var CLASS_CONTAINER = CLASS_SLIDE + "__container";
  var CLASS_ARROWS = CLASS_PREFIX + "arrows";
  var CLASS_ARROW = CLASS_PREFIX + "arrow";
  var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
  var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
  var CLASS_PAGINATION = CLASS_PREFIX + "pagination";
  var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
  var CLASS_PROGRESS = CLASS_PREFIX + "progress";
  var CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar";
  var CLASS_TOGGLE = CLASS_PREFIX + "toggle";
  var CLASS_TOGGLE_PLAY = CLASS_TOGGLE + "__play";
  var CLASS_TOGGLE_PAUSE = CLASS_TOGGLE + "__pause";
  var CLASS_SPINNER = CLASS_PREFIX + "spinner";
  var CLASS_SR = CLASS_PREFIX + "sr";
  var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized";
  var CLASS_ACTIVE = STATUS_CLASS_PREFIX + "active";
  var CLASS_PREV = STATUS_CLASS_PREFIX + "prev";
  var CLASS_NEXT = STATUS_CLASS_PREFIX + "next";
  var CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible";
  var CLASS_LOADING = STATUS_CLASS_PREFIX + "loading";
  var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in";
  var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow";
  var STATUS_CLASSES = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN, CLASS_OVERFLOW];
  var CLASSES = {
    slide: CLASS_SLIDE,
    clone: CLASS_CLONE,
    arrows: CLASS_ARROWS,
    arrow: CLASS_ARROW,
    prev: CLASS_ARROW_PREV,
    next: CLASS_ARROW_NEXT,
    pagination: CLASS_PAGINATION,
    page: CLASS_PAGINATION_PAGE,
    spinner: CLASS_SPINNER
  };
  function closest(from, selector) {
    if (isFunction(from.closest)) {
      return from.closest(selector);
    }
    var elm = from;
    while (elm && elm.nodeType === 1) {
      if (matches(elm, selector)) {
        break;
      }
      elm = elm.parentElement;
    }
    return elm;
  }
  var FRICTION = 5;
  var LOG_INTERVAL = 200;
  var POINTER_DOWN_EVENTS = "touchstart mousedown";
  var POINTER_MOVE_EVENTS = "touchmove mousemove";
  var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
  function Elements(Splide2, Components2, options) {
    var _EventInterface = EventInterface(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
      collect();
      init();
      update();
    }
    function mount() {
      on(EVENT_REFRESH, destroy);
      on(EVENT_REFRESH, setup);
      on(EVENT_UPDATED, update);
      bind(document, POINTER_DOWN_EVENTS + " keydown", function(e2) {
        isUsingKey = e2.type === "keydown";
      }, {
        capture: true
      });
      bind(root, "focusin", function() {
        toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
      });
    }
    function destroy(completely) {
      var attrs = ALL_ATTRIBUTES.concat("style");
      empty(slides);
      removeClass(root, rootClasses);
      removeClass(track, trackClasses);
      removeAttribute([track, list], attrs);
      removeAttribute(root, completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]);
    }
    function update() {
      removeClass(root, rootClasses);
      removeClass(track, trackClasses);
      rootClasses = getClasses(CLASS_ROOT);
      trackClasses = getClasses(CLASS_TRACK);
      addClass(root, rootClasses);
      addClass(track, trackClasses);
      setAttribute(root, ARIA_LABEL, options.label);
      setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
      track = find("." + CLASS_TRACK);
      list = child(track, "." + CLASS_LIST);
      assert(track && list, "A track/list element is missing.");
      push(slides, children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")"));
      forOwn({
        arrows: CLASS_ARROWS,
        pagination: CLASS_PAGINATION,
        prev: CLASS_ARROW_PREV,
        next: CLASS_ARROW_NEXT,
        bar: CLASS_PROGRESS_BAR,
        toggle: CLASS_TOGGLE
      }, function(className, key) {
        elements[key] = find("." + className);
      });
      assign(elements, {
        root,
        track,
        list,
        slides
      });
    }
    function init() {
      var id = root.id || uniqueId(PROJECT_CODE);
      var role = options.role;
      root.id = id;
      track.id = track.id || id + "-track";
      list.id = list.id || id + "-list";
      if (!getAttribute(root, ROLE) && root.tagName !== "SECTION" && role) {
        setAttribute(root, ROLE, role);
      }
      setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
      setAttribute(list, ROLE, "presentation");
    }
    function find(selector) {
      var elm = query(root, selector);
      return elm && closest(elm, "." + CLASS_ROOT) === root ? elm : void 0;
    }
    function getClasses(base) {
      return [base + "--" + options.type, base + "--" + options.direction, options.drag && base + "--draggable", options.isNavigation && base + "--nav", base === CLASS_ROOT && CLASS_ACTIVE];
    }
    return assign(elements, {
      setup,
      mount,
      destroy
    });
  }
  var SLIDE = "slide";
  var LOOP = "loop";
  var FADE = "fade";
  function Slide$1(Splide2, index, slideIndex, slide) {
    var event2 = EventInterface(Splide2);
    var on = event2.on, emit = event2.emit, bind = event2.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = getAttribute(slide, "style");
    var label = getAttribute(slide, ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = child(slide, "." + CLASS_CONTAINER);
    var destroyed;
    function mount() {
      if (!isClone) {
        slide.id = root.id + "-slide" + pad(index + 1);
        setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
        setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
        setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
      }
      listen();
    }
    function listen() {
      bind(slide, "click", apply(emit, EVENT_CLICK, self2));
      bind(slide, "keydown", apply(emit, EVENT_SLIDE_KEYDOWN, self2));
      on([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
      on(EVENT_NAVIGATION_MOUNTED, initNavigation);
      if (updateOnMove) {
        on(EVENT_MOVE, onMove);
      }
    }
    function destroy() {
      destroyed = true;
      event2.destroy();
      removeClass(slide, STATUS_CLASSES);
      removeAttribute(slide, ALL_ATTRIBUTES);
      setAttribute(slide, "style", styles);
      setAttribute(slide, ARIA_LABEL, label || "");
    }
    function initNavigation() {
      var controls = Splide2.splides.map(function(target) {
        var Slide2 = target.splide.Components.Slides.getAt(index);
        return Slide2 ? Slide2.slide.id : "";
      }).join(" ");
      setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
      setAttribute(slide, ARIA_CONTROLS, controls);
      setAttribute(slide, ROLE, slideFocus ? "button" : "");
      slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
      if (!destroyed) {
        update();
      }
    }
    function update() {
      if (!destroyed) {
        var curr = Splide2.index;
        updateActivity();
        updateVisibility();
        toggleClass(slide, CLASS_PREV, index === curr - 1);
        toggleClass(slide, CLASS_NEXT, index === curr + 1);
      }
    }
    function updateActivity() {
      var active = isActive();
      if (active !== hasClass(slide, CLASS_ACTIVE)) {
        toggleClass(slide, CLASS_ACTIVE, active);
        setAttribute(slide, ARIA_CURRENT, isNavigation && active || "");
        emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self2);
      }
    }
    function updateVisibility() {
      var visible = isVisible();
      var hidden = !visible && (!isActive() || isClone);
      if (!Splide2.state.is([MOVING, SCROLLING])) {
        setAttribute(slide, ARIA_HIDDEN, hidden || "");
      }
      setAttribute(queryAll(slide, options.focusableNodes || ""), TAB_INDEX, hidden ? -1 : "");
      if (slideFocus) {
        setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
      }
      if (visible !== hasClass(slide, CLASS_VISIBLE)) {
        toggleClass(slide, CLASS_VISIBLE, visible);
        emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self2);
      }
      if (!visible && document.activeElement === slide) {
        var Slide2 = Components.Slides.getAt(Splide2.index);
        Slide2 && focus(Slide2.slide);
      }
    }
    function style$1(prop, value, useContainer) {
      style(useContainer && container || slide, prop, value);
    }
    function isActive() {
      var curr = Splide2.index;
      return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
      if (Splide2.is(FADE)) {
        return isActive();
      }
      var trackRect = rect(Components.Elements.track);
      var slideRect = rect(slide);
      var left = resolve("left", true);
      var right = resolve("right", true);
      return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
      var diff = abs(from - index);
      if (!isClone && (options.rewind || Splide2.is(LOOP))) {
        diff = min(diff, Splide2.length - diff);
      }
      return diff <= distance;
    }
    var self2 = {
      index,
      slideIndex,
      slide,
      container,
      isClone,
      mount,
      destroy,
      update,
      style: style$1,
      isWithin
    };
    return self2;
  }
  function Slides(Splide2, Components2, options) {
    var _EventInterface2 = EventInterface(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
      init();
      on(EVENT_REFRESH, destroy);
      on(EVENT_REFRESH, init);
    }
    function init() {
      slides.forEach(function(slide, index) {
        register(slide, index, -1);
      });
    }
    function destroy() {
      forEach$1(function(Slide2) {
        Slide2.destroy();
      });
      empty(Slides2);
    }
    function update() {
      forEach$1(function(Slide2) {
        Slide2.update();
      });
    }
    function register(slide, index, slideIndex) {
      var object = Slide$1(Splide2, index, slideIndex, slide);
      object.mount();
      Slides2.push(object);
      Slides2.sort(function(Slide1, Slide2) {
        return Slide1.index - Slide2.index;
      });
    }
    function get(excludeClones) {
      return excludeClones ? filter(function(Slide2) {
        return !Slide2.isClone;
      }) : Slides2;
    }
    function getIn(page) {
      var Controller2 = Components2.Controller;
      var index = Controller2.toIndex(page);
      var max2 = Controller2.hasFocus() ? 1 : options.perPage;
      return filter(function(Slide2) {
        return between(Slide2.index, index, index + max2 - 1);
      });
    }
    function getAt(index) {
      return filter(index)[0];
    }
    function add(items, index) {
      forEach(items, function(slide) {
        if (isString(slide)) {
          slide = parseHtml(slide);
        }
        if (isHTMLElement(slide)) {
          var ref = slides[index];
          ref ? before(slide, ref) : append(list, slide);
          addClass(slide, options.classes.slide);
          observeImages(slide, apply(emit, EVENT_RESIZE));
        }
      });
      emit(EVENT_REFRESH);
    }
    function remove$1(matcher) {
      remove(filter(matcher).map(function(Slide2) {
        return Slide2.slide;
      }));
      emit(EVENT_REFRESH);
    }
    function forEach$1(iteratee, excludeClones) {
      get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
      return Slides2.filter(isFunction(matcher) ? matcher : function(Slide2) {
        return isString(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
      });
    }
    function style2(prop, value, useContainer) {
      forEach$1(function(Slide2) {
        Slide2.style(prop, value, useContainer);
      });
    }
    function observeImages(elm, callback) {
      var images = queryAll(elm, "img");
      var length = images.length;
      if (length) {
        images.forEach(function(img) {
          bind(img, "load error", function() {
            if (!--length) {
              callback();
            }
          });
        });
      } else {
        callback();
      }
    }
    function getLength(excludeClones) {
      return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
      return Slides2.length > options.perPage;
    }
    return {
      mount,
      destroy,
      update,
      register,
      get,
      getIn,
      getAt,
      add,
      remove: remove$1,
      forEach: forEach$1,
      filter,
      style: style2,
      getLength,
      isEnough
    };
  }
  function Layout(Splide2, Components2, options) {
    var _EventInterface3 = EventInterface(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides2 = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides2.getAt, styleSlides = Slides2.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
      init();
      bind(window, "resize load", Throttle(apply(emit, EVENT_RESIZE)));
      on([EVENT_UPDATED, EVENT_REFRESH], init);
      on(EVENT_RESIZE, resize);
    }
    function init() {
      vertical = options.direction === TTB;
      style(root, "maxWidth", unit(options.width));
      style(track, resolve("paddingLeft"), cssPadding(false));
      style(track, resolve("paddingRight"), cssPadding(true));
      resize(true);
    }
    function resize(force) {
      var newRect = rect(root);
      if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
        style(track, "height", cssTrackHeight());
        styleSlides(resolve("marginRight"), unit(options.gap));
        styleSlides("width", cssSlideWidth());
        styleSlides("height", cssSlideHeight(), true);
        rootRect = newRect;
        emit(EVENT_RESIZED);
        if (overflow !== (overflow = isOverflow())) {
          toggleClass(root, CLASS_OVERFLOW, overflow);
          emit(EVENT_OVERFLOW, overflow);
        }
      }
    }
    function cssPadding(right) {
      var padding = options.padding;
      var prop = resolve(right ? "right" : "left");
      return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
      var height = "";
      if (vertical) {
        height = cssHeight();
        assert(height, "height or heightRatio is missing.");
        height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
      }
      return height;
    }
    function cssHeight() {
      return unit(options.height || rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
      return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
      return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
      var gap = unit(options.gap);
      return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
      return rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
      var Slide2 = getAt(index || 0);
      return Slide2 ? rect(Slide2.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
      var Slide2 = getAt(index);
      if (Slide2) {
        var right = rect(Slide2.slide)[resolve("right")];
        var left = rect(list)[resolve("left")];
        return abs(right - left) + (withoutGap ? 0 : getGap());
      }
      return 0;
    }
    function sliderSize(withoutGap) {
      return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
      var Slide2 = getAt(0);
      return Slide2 && parseFloat(style(Slide2.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
      return parseFloat(style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
      return Splide2.is(FADE) || sliderSize(true) > listSize();
    }
    return {
      mount,
      resize,
      listSize,
      slideSize,
      sliderSize,
      totalSize,
      getPadding,
      isOverflow
    };
  }
  var MULTIPLIER = 2;
  function Clones(Splide2, Components2, options) {
    var event2 = EventInterface(Splide2);
    var on = event2.on;
    var Elements2 = Components2.Elements, Slides2 = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
      on(EVENT_REFRESH, remount);
      on([EVENT_UPDATED, EVENT_RESIZE], observe);
      if (cloneCount = computeCloneCount()) {
        generate(cloneCount);
        Components2.Layout.resize(true);
      }
    }
    function remount() {
      destroy();
      mount();
    }
    function destroy() {
      remove(clones);
      empty(clones);
      event2.destroy();
    }
    function observe() {
      var count = computeCloneCount();
      if (cloneCount !== count) {
        if (cloneCount < count || !count) {
          event2.emit(EVENT_REFRESH);
        }
      }
    }
    function generate(count) {
      var slides = Slides2.get().slice();
      var length = slides.length;
      if (length) {
        while (slides.length < count) {
          push(slides, slides);
        }
        push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide2, index) {
          var isHead = index < count;
          var clone = cloneDeep(Slide2.slide, index);
          isHead ? before(clone, slides[0].slide) : append(Elements2.list, clone);
          push(clones, clone);
          Slides2.register(clone, index - count + (isHead ? 0 : length), Slide2.index);
        });
      }
    }
    function cloneDeep(elm, index) {
      var clone = elm.cloneNode(true);
      addClass(clone, options.classes.clone);
      clone.id = Splide2.root.id + "-clone" + pad(index + 1);
      return clone;
    }
    function computeCloneCount() {
      var clones2 = options.clones;
      if (!Splide2.is(LOOP)) {
        clones2 = 0;
      } else if (isUndefined(clones2)) {
        var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
        var fixedCount = fixedSize && ceil(rect(Elements2.track)[resolve("width")] / fixedSize);
        clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * MULTIPLIER;
      }
      return clones2;
    }
    return {
      mount,
      destroy
    };
  }
  function Move(Splide2, Components2, options) {
    var _EventInterface4 = EventInterface(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
      Transition = Components2.Transition;
      on([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
    }
    function reposition() {
      if (!Components2.Controller.isBusy()) {
        Components2.Scroll.cancel();
        jump(Splide2.index);
        Components2.Slides.update();
      }
    }
    function move(dest, index, prev, callback) {
      if (dest !== index && canShift(dest > prev)) {
        cancel();
        translate(shift(getPosition(), dest > prev), true);
      }
      set(MOVING);
      emit(EVENT_MOVE, index, prev, dest);
      Transition.start(index, function() {
        set(IDLE);
        emit(EVENT_MOVED, index, prev, dest);
        callback && callback();
      });
    }
    function jump(index) {
      translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
      if (!Splide2.is(FADE)) {
        var destination = preventLoop ? position : loop(position);
        style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
        position !== destination && emit(EVENT_SHIFTED);
      }
    }
    function loop(position) {
      if (Splide2.is(LOOP)) {
        var index = toIndex(position);
        var exceededMax = index > Components2.Controller.getEnd();
        var exceededMin = index < 0;
        if (exceededMin || exceededMax) {
          position = shift(position, exceededMax);
        }
      }
      return position;
    }
    function shift(position, backwards) {
      var excess = position - getLimit(backwards);
      var size = sliderSize();
      position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
      return position;
    }
    function cancel() {
      translate(getPosition(), true);
      Transition.cancel();
    }
    function toIndex(position) {
      var Slides2 = Components2.Slides.get();
      var index = 0;
      var minDistance = Infinity;
      for (var i2 = 0; i2 < Slides2.length; i2++) {
        var slideIndex = Slides2[i2].index;
        var distance = abs(toPosition(slideIndex, true) - position);
        if (distance <= minDistance) {
          minDistance = distance;
          index = slideIndex;
        } else {
          break;
        }
      }
      return index;
    }
    function toPosition(index, trimming) {
      var position = orient(totalSize(index - 1) - offset(index));
      return trimming ? trim(position) : position;
    }
    function getPosition() {
      var left = resolve("left");
      return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
      if (options.trimSpace && Splide2.is(SLIDE)) {
        position = clamp(position, 0, orient(sliderSize(true) - listSize()));
      }
      return position;
    }
    function offset(index) {
      var focus2 = options.focus;
      return focus2 === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus2 * slideSize(index) || 0;
    }
    function getLimit(max2) {
      return toPosition(max2 ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
      var shifted = orient(shift(getPosition(), backwards));
      return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - rect(track)[resolve("width")];
    }
    function exceededLimit(max2, position) {
      position = isUndefined(position) ? getPosition() : position;
      var exceededMin = max2 !== true && orient(position) < orient(getLimit(false));
      var exceededMax = max2 !== false && orient(position) > orient(getLimit(true));
      return exceededMin || exceededMax;
    }
    return {
      mount,
      move,
      jump,
      translate,
      shift,
      cancel,
      toIndex,
      toPosition,
      getPosition,
      getLimit,
      exceededLimit,
      reposition
    };
  }
  function Controller(Splide2, Components2, options) {
    var _EventInterface5 = EventInterface(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move2 = Components2.Move;
    var getPosition = Move2.getPosition, getLimit = Move2.getLimit, toPosition = Move2.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is(LOOP);
    var isSlide = Splide2.is(SLIDE);
    var getNext = apply(getAdjacent, false);
    var getPrev = apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
      init();
      on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], init);
      on(EVENT_RESIZED, onResized);
    }
    function init() {
      slideCount = getLength(true);
      perMove = options.perMove;
      perPage = options.perPage;
      endIndex = getEnd();
      var index = clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
      if (index !== currIndex) {
        currIndex = index;
        Move2.reposition();
      }
    }
    function onResized() {
      if (endIndex !== getEnd()) {
        emit(EVENT_END_INDEX_CHANGED);
      }
    }
    function go(control, allowSameIndex, callback) {
      if (!isBusy()) {
        var dest = parse(control);
        var index = loop(dest);
        if (index > -1 && (allowSameIndex || index !== currIndex)) {
          setIndex(index);
          Move2.move(dest, index, prevIndex, callback);
        }
      }
    }
    function scroll(destination, duration, snap, callback) {
      Components2.Scroll.scroll(destination, duration, snap, function() {
        var index = loop(Move2.toIndex(getPosition()));
        setIndex(omitEnd ? min(index, endIndex) : index);
        callback && callback();
      });
    }
    function parse(control) {
      var index = currIndex;
      if (isString(control)) {
        var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
        if (indicator === "+" || indicator === "-") {
          index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
        } else if (indicator === ">") {
          index = number ? toIndex(+number) : getNext(true);
        } else if (indicator === "<") {
          index = getPrev(true);
        }
      } else {
        index = isLoop ? control : clamp(control, 0, endIndex);
      }
      return index;
    }
    function getAdjacent(prev, destination) {
      var number = perMove || (hasFocus() ? 1 : perPage);
      var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
      if (dest === -1 && isSlide) {
        if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
          return prev ? 0 : endIndex;
        }
      }
      return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
      if (isEnough() || hasFocus()) {
        var index = computeMovableDestIndex(dest);
        if (index !== dest) {
          from = dest;
          dest = index;
          snapPage = false;
        }
        if (dest < 0 || dest > endIndex) {
          if (!perMove && (between(0, dest, from, true) || between(endIndex, from, dest, true))) {
            dest = toIndex(toPage(dest));
          } else {
            if (isLoop) {
              dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
            } else if (options.rewind) {
              dest = dest < 0 ? endIndex : 0;
            } else {
              dest = -1;
            }
          }
        } else {
          if (snapPage && dest !== from) {
            dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
          }
        }
      } else {
        dest = -1;
      }
      return dest;
    }
    function computeMovableDestIndex(dest) {
      if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
        var position = getPosition();
        while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) {
          dest < currIndex ? --dest : ++dest;
        }
      }
      return dest;
    }
    function loop(index) {
      return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
      var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
      while (omitEnd && end-- > 0) {
        if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
          end++;
          break;
        }
      }
      return clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
      return clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
      return hasFocus() ? min(index, endIndex) : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
      var closest2 = Move2.toIndex(destination);
      return isSlide ? clamp(closest2, 0, endIndex) : closest2;
    }
    function setIndex(index) {
      if (index !== currIndex) {
        prevIndex = currIndex;
        currIndex = index;
      }
    }
    function getIndex(prev) {
      return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
      return !isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
      return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
    }
    return {
      mount,
      go,
      scroll,
      getNext,
      getPrev,
      getAdjacent,
      getEnd,
      setIndex,
      getIndex,
      toIndex,
      toPage,
      toDest,
      hasFocus,
      isBusy
    };
  }
  var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
  var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
  var SIZE = 40;
  function Arrows(Splide2, Components2, options) {
    var event2 = EventInterface(Splide2);
    var on = event2.on, bind = event2.bind, emit = event2.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements2 = Components2.Elements, Controller2 = Components2.Controller;
    var placeholder = Elements2.arrows, track = Elements2.track;
    var wrapper = placeholder;
    var prev = Elements2.prev;
    var next = Elements2.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
      init();
      on(EVENT_UPDATED, remount);
    }
    function remount() {
      destroy();
      mount();
    }
    function init() {
      var enabled = options.arrows;
      if (enabled && !(prev && next)) {
        createArrows();
      }
      if (prev && next) {
        assign(arrows, {
          prev,
          next
        });
        display(wrapper, enabled ? "" : "none");
        addClass(wrapper, wrapperClasses = CLASS_ARROWS + "--" + options.direction);
        if (enabled) {
          listen();
          update();
          setAttribute([prev, next], ARIA_CONTROLS, track.id);
          emit(EVENT_ARROWS_MOUNTED, prev, next);
        }
      }
    }
    function destroy() {
      event2.destroy();
      removeClass(wrapper, wrapperClasses);
      if (created) {
        remove(placeholder ? [prev, next] : wrapper);
        prev = next = null;
      } else {
        removeAttribute([prev, next], ALL_ATTRIBUTES);
      }
    }
    function listen() {
      on([EVENT_MOUNTED, EVENT_MOVED, EVENT_REFRESH, EVENT_SCROLLED, EVENT_END_INDEX_CHANGED], update);
      bind(next, "click", apply(go, ">"));
      bind(prev, "click", apply(go, "<"));
    }
    function go(control) {
      Controller2.go(control, true);
    }
    function createArrows() {
      wrapper = placeholder || create("div", classes.arrows);
      prev = createArrow(true);
      next = createArrow(false);
      created = true;
      append(wrapper, [prev, next]);
      !placeholder && before(wrapper, track);
    }
    function createArrow(prev2) {
      var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + XML_NAME_SPACE + '" viewBox="0 0 ' + SIZE + " " + SIZE + '" width="' + SIZE + '" height="' + SIZE + '" focusable="false"><path d="' + (options.arrowPath || PATH) + '" />';
      return parseHtml(arrow);
    }
    function update() {
      if (prev && next) {
        var index = Splide2.index;
        var prevIndex = Controller2.getPrev();
        var nextIndex = Controller2.getNext();
        var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
        var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
        prev.disabled = prevIndex < 0;
        next.disabled = nextIndex < 0;
        setAttribute(prev, ARIA_LABEL, prevLabel);
        setAttribute(next, ARIA_LABEL, nextLabel);
        emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
      }
    }
    return {
      arrows,
      mount,
      destroy,
      update
    };
  }
  var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";
  function Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = EventInterface(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements2 = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
      if (autoplay) {
        listen();
        toggle && setAttribute(toggle, ARIA_CONTROLS, Elements2.track.id);
        stopped || play();
        update();
      }
    }
    function listen() {
      if (options.pauseOnHover) {
        bind(root, "mouseenter mouseleave", function(e2) {
          hovered = e2.type === "mouseenter";
          autoToggle();
        });
      }
      if (options.pauseOnFocus) {
        bind(root, "focusin focusout", function(e2) {
          focused = e2.type === "focusin";
          autoToggle();
        });
      }
      if (toggle) {
        bind(toggle, "click", function() {
          stopped ? play() : pause(true);
        });
      }
      on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
      on(EVENT_MOVE, onMove);
    }
    function play() {
      if (isPaused() && Components2.Slides.isEnough()) {
        interval.start(!options.resetProgress);
        focused = hovered = stopped = false;
        update();
        emit(EVENT_AUTOPLAY_PLAY);
      }
    }
    function pause(stop) {
      if (stop === void 0) {
        stop = true;
      }
      stopped = !!stop;
      update();
      if (!isPaused()) {
        interval.pause();
        emit(EVENT_AUTOPLAY_PAUSE);
      }
    }
    function autoToggle() {
      if (!stopped) {
        hovered || focused ? pause(false) : play();
      }
    }
    function update() {
      if (toggle) {
        toggleClass(toggle, CLASS_ACTIVE, !stopped);
        setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
      }
    }
    function onAnimationFrame(rate) {
      var bar = Elements2.bar;
      bar && style(bar, "width", rate * 100 + "%");
      emit(EVENT_AUTOPLAY_PLAYING, rate);
    }
    function onMove(index) {
      var Slide2 = Components2.Slides.getAt(index);
      interval.set(Slide2 && +getAttribute(Slide2.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
      mount,
      destroy: interval.cancel,
      play,
      pause,
      isPaused
    };
  }
  function Cover(Splide2, Components2, options) {
    var _EventInterface7 = EventInterface(Splide2), on = _EventInterface7.on;
    function mount() {
      if (options.cover) {
        on(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
        on([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply(cover, true));
      }
    }
    function cover(cover2) {
      Components2.Slides.forEach(function(Slide2) {
        var img = child(Slide2.container || Slide2.slide, "img");
        if (img && img.src) {
          toggle(cover2, img, Slide2);
        }
      });
    }
    function toggle(cover2, img, Slide2) {
      Slide2.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
      display(img, cover2 ? "none" : "");
    }
    return {
      mount,
      destroy: apply(cover, false)
    };
  }
  var BOUNCE_DIFF_THRESHOLD = 10;
  var BOUNCE_DURATION = 600;
  var FRICTION_FACTOR = 0.6;
  var BASE_VELOCITY = 1.5;
  var MIN_DURATION = 800;
  function Scroll(Splide2, Components2, options) {
    var _EventInterface8 = EventInterface(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move2 = Components2.Move;
    var getPosition = Move2.getPosition, getLimit = Move2.getLimit, exceededLimit = Move2.exceededLimit, translate = Move2.translate;
    var isSlide = Splide2.is(SLIDE);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
      on(EVENT_MOVE, clear);
      on([EVENT_UPDATED, EVENT_REFRESH], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
      var from = getPosition();
      clear();
      if (snap && (!isSlide || !exceededLimit())) {
        var size = Components2.Layout.sliderSize();
        var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
        destination = Move2.toPosition(Components2.Controller.toDest(destination % size)) + offset;
      }
      var noDistance = approximatelyEqual(from, destination, 1);
      friction = 1;
      duration = noDistance ? 0 : duration || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
      callback = onScrolled;
      interval = RequestInterval(duration, onEnd, apply(update, from, destination, noConstrain), 1);
      set(SCROLLING);
      emit(EVENT_SCROLL);
      interval.start();
    }
    function onEnd() {
      set(IDLE);
      callback && callback();
      emit(EVENT_SCROLLED);
    }
    function update(from, to, noConstrain, rate) {
      var position = getPosition();
      var target = from + (to - from) * easing(rate);
      var diff = (target - position) * friction;
      translate(position + diff);
      if (isSlide && !noConstrain && exceededLimit()) {
        friction *= FRICTION_FACTOR;
        if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
          scroll(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
        }
      }
    }
    function clear() {
      if (interval) {
        interval.cancel();
      }
    }
    function cancel() {
      if (interval && !interval.isPaused()) {
        clear();
        onEnd();
      }
    }
    function easing(t2) {
      var easingFunc = options.easingFunc;
      return easingFunc ? easingFunc(t2) : 1 - Math.pow(1 - t2, 4);
    }
    return {
      mount,
      destroy: clear,
      scroll,
      cancel
    };
  }
  var SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
  };
  function Drag(Splide2, Components2, options) {
    var _EventInterface9 = EventInterface(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move2 = Components2.Move, Scroll2 = Components2.Scroll, Controller2 = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move2.getPosition, exceededLimit = Move2.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
      bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
      bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
      bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
      bind(track, "click", onClick, {
        capture: true
      });
      bind(track, "dragstart", prevent);
      on([EVENT_MOUNTED, EVENT_UPDATED], init);
    }
    function init() {
      var drag = options.drag;
      disable(!drag);
      isFree = drag === "free";
    }
    function onPointerDown(e2) {
      clickPrevented = false;
      if (!disabled) {
        var isTouch = isTouchEvent(e2);
        if (isDraggable(e2.target) && (isTouch || !e2.button)) {
          if (!Controller2.isBusy()) {
            target = isTouch ? track : window;
            dragging = state.is([MOVING, SCROLLING]);
            prevBaseEvent = null;
            bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
            bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
            Move2.cancel();
            Scroll2.cancel();
            save(e2);
          } else {
            prevent(e2, true);
          }
        }
      }
    }
    function onPointerMove(e2) {
      if (!state.is(DRAGGING)) {
        state.set(DRAGGING);
        emit(EVENT_DRAG);
      }
      if (e2.cancelable) {
        if (dragging) {
          Move2.translate(basePosition + constrain(diffCoord(e2)));
          var expired = diffTime(e2) > LOG_INTERVAL;
          var hasExceeded = exceeded !== (exceeded = exceededLimit());
          if (expired || hasExceeded) {
            save(e2);
          }
          clickPrevented = true;
          emit(EVENT_DRAGGING);
          prevent(e2);
        } else if (isSliderDirection(e2)) {
          dragging = shouldStart(e2);
          prevent(e2);
        }
      }
    }
    function onPointerUp(e2) {
      if (state.is(DRAGGING)) {
        state.set(IDLE);
        emit(EVENT_DRAGGED);
      }
      if (dragging) {
        move(e2);
        prevent(e2);
      }
      unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
      unbind(target, POINTER_UP_EVENTS, onPointerUp);
      dragging = false;
    }
    function onClick(e2) {
      if (!disabled && clickPrevented) {
        prevent(e2, true);
      }
    }
    function save(e2) {
      prevBaseEvent = baseEvent;
      baseEvent = e2;
      basePosition = getPosition();
    }
    function move(e2) {
      var velocity = computeVelocity(e2);
      var destination = computeDestination(velocity);
      var rewind = options.rewind && options.rewindByDrag;
      reduce(false);
      if (isFree) {
        Controller2.scroll(destination, 0, options.snap);
      } else if (Splide2.is(FADE)) {
        Controller2.go(orient(sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
      } else if (Splide2.is(SLIDE) && exceeded && rewind) {
        Controller2.go(exceededLimit(true) ? ">" : "<");
      } else {
        Controller2.go(Controller2.toDest(destination), true);
      }
      reduce(true);
    }
    function shouldStart(e2) {
      var thresholds = options.dragMinThreshold;
      var isObj = isObject(thresholds);
      var mouse = isObj && thresholds.mouse || 0;
      var touch = (isObj ? thresholds.touch : +thresholds) || 10;
      return abs(diffCoord(e2)) > (isTouchEvent(e2) ? touch : mouse);
    }
    function isSliderDirection(e2) {
      return abs(diffCoord(e2)) > abs(diffCoord(e2, true));
    }
    function computeVelocity(e2) {
      if (Splide2.is(LOOP) || !exceeded) {
        var time = diffTime(e2);
        if (time && time < LOG_INTERVAL) {
          return diffCoord(e2) / time;
        }
      }
      return 0;
    }
    function computeDestination(velocity) {
      return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e2, orthogonal) {
      return coordOf(e2, orthogonal) - coordOf(getBaseEvent(e2), orthogonal);
    }
    function diffTime(e2) {
      return timeOf(e2) - timeOf(getBaseEvent(e2));
    }
    function getBaseEvent(e2) {
      return baseEvent === e2 && prevBaseEvent || baseEvent;
    }
    function coordOf(e2, orthogonal) {
      return (isTouchEvent(e2) ? e2.changedTouches[0] : e2)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
      return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
    }
    function isDraggable(target2) {
      var noDrag = options.noDrag;
      return !matches(target2, "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW) && (!noDrag || !matches(target2, noDrag));
    }
    function isTouchEvent(e2) {
      return typeof TouchEvent !== "undefined" && e2 instanceof TouchEvent;
    }
    function isDragging() {
      return dragging;
    }
    function disable(value) {
      disabled = value;
    }
    return {
      mount,
      disable,
      isDragging
    };
  }
  var NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: ARROW_RIGHT,
    Left: ARROW_LEFT,
    Up: ARROW_UP,
    Down: ARROW_DOWN
  };
  function normalizeKey(key) {
    key = isString(key) ? key : key.key;
    return NORMALIZATION_MAP[key] || key;
  }
  var KEYBOARD_EVENT = "keydown";
  function Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = EventInterface(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
      init();
      on(EVENT_UPDATED, destroy);
      on(EVENT_UPDATED, init);
      on(EVENT_MOVE, onMove);
    }
    function init() {
      var keyboard = options.keyboard;
      if (keyboard) {
        target = keyboard === "global" ? window : root;
        bind(target, KEYBOARD_EVENT, onKeydown);
      }
    }
    function destroy() {
      unbind(target, KEYBOARD_EVENT);
    }
    function disable(value) {
      disabled = value;
    }
    function onMove() {
      var _disabled = disabled;
      disabled = true;
      nextTick(function() {
        disabled = _disabled;
      });
    }
    function onKeydown(e2) {
      if (!disabled) {
        var key = normalizeKey(e2);
        if (key === resolve(ARROW_LEFT)) {
          Splide2.go("<");
        } else if (key === resolve(ARROW_RIGHT)) {
          Splide2.go(">");
        }
      }
    }
    return {
      mount,
      destroy,
      disable
    };
  }
  var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
  var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
  var IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";
  function LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = EventInterface(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [EVENT_MOVED, EVENT_SCROLLED];
    var entries = [];
    function mount() {
      if (options.lazyLoad) {
        init();
        on(EVENT_REFRESH, init);
      }
    }
    function init() {
      empty(entries);
      register();
      if (isSequential) {
        loadNext();
      } else {
        off(events);
        on(events, check);
        check();
      }
    }
    function register() {
      Components2.Slides.forEach(function(Slide2) {
        queryAll(Slide2.slide, IMAGE_SELECTOR).forEach(function(img) {
          var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
          var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);
          if (src !== img.src || srcset !== img.srcset) {
            var className = options.classes.spinner;
            var parent = img.parentElement;
            var spinner = child(parent, "." + className) || create("span", className, parent);
            entries.push([img, Slide2, spinner]);
            img.src || display(img, "none");
          }
        });
      });
    }
    function check() {
      entries = entries.filter(function(data) {
        var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
        return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
      });
      entries.length || off(events);
    }
    function load(data) {
      var img = data[0];
      addClass(data[1].slide, CLASS_LOADING);
      bind(img, "load error", apply(onLoad, data));
      setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
      setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_ATTRIBUTE));
      removeAttribute(img, SRC_DATA_ATTRIBUTE);
      removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e2) {
      var img = data[0], Slide2 = data[1];
      removeClass(Slide2.slide, CLASS_LOADING);
      if (e2.type !== "error") {
        remove(data[2]);
        display(img, "");
        emit(EVENT_LAZYLOAD_LOADED, img, Slide2);
        emit(EVENT_RESIZE);
      }
      isSequential && loadNext();
    }
    function loadNext() {
      entries.length && load(entries.shift());
    }
    return {
      mount,
      destroy: apply(empty, entries),
      check
    };
  }
  function Pagination(Splide2, Components2, options) {
    var event2 = EventInterface(Splide2);
    var on = event2.on, emit = event2.emit, bind = event2.bind;
    var Slides2 = Components2.Slides, Elements2 = Components2.Elements, Controller2 = Components2.Controller;
    var hasFocus = Controller2.hasFocus, getIndex = Controller2.getIndex, go = Controller2.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements2.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
      destroy();
      on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], mount);
      var enabled = options.pagination;
      placeholder && display(placeholder, enabled ? "" : "none");
      if (enabled) {
        on([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
        createPagination();
        update();
        emit(EVENT_PAGINATION_MOUNTED, {
          list,
          items
        }, getAt(Splide2.index));
      }
    }
    function destroy() {
      if (list) {
        remove(placeholder ? slice(list.children) : list);
        removeClass(list, paginationClasses);
        empty(items);
        list = null;
      }
      event2.destroy();
    }
    function createPagination() {
      var length = Splide2.length;
      var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
      var max2 = hasFocus() ? Controller2.getEnd() + 1 : ceil(length / perPage);
      list = placeholder || create("ul", classes.pagination, Elements2.track.parentElement);
      addClass(list, paginationClasses = CLASS_PAGINATION + "--" + getDirection());
      setAttribute(list, ROLE, "tablist");
      setAttribute(list, ARIA_LABEL, i18n.select);
      setAttribute(list, ARIA_ORIENTATION, getDirection() === TTB ? "vertical" : "");
      for (var i2 = 0; i2 < max2; i2++) {
        var li = create("li", null, list);
        var button = create("button", {
          class: classes.page,
          type: "button"
        }, li);
        var controls = Slides2.getIn(i2).map(function(Slide2) {
          return Slide2.slide.id;
        });
        var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
        bind(button, "click", apply(onClick, i2));
        if (options.paginationKeyboard) {
          bind(button, "keydown", apply(onKeydown, i2));
        }
        setAttribute(li, ROLE, "presentation");
        setAttribute(button, ROLE, "tab");
        setAttribute(button, ARIA_CONTROLS, controls.join(" "));
        setAttribute(button, ARIA_LABEL, format(text, i2 + 1));
        setAttribute(button, TAB_INDEX, -1);
        items.push({
          li,
          button,
          page: i2
        });
      }
    }
    function onClick(page) {
      go(">" + page, true);
    }
    function onKeydown(page, e2) {
      var length = items.length;
      var key = normalizeKey(e2);
      var dir = getDirection();
      var nextPage = -1;
      if (key === resolve(ARROW_RIGHT, false, dir)) {
        nextPage = ++page % length;
      } else if (key === resolve(ARROW_LEFT, false, dir)) {
        nextPage = (--page + length) % length;
      } else if (key === "Home") {
        nextPage = 0;
      } else if (key === "End") {
        nextPage = length - 1;
      }
      var item = items[nextPage];
      if (item) {
        focus(item.button);
        go(">" + nextPage);
        prevent(e2, true);
      }
    }
    function getDirection() {
      return options.paginationDirection || options.direction;
    }
    function getAt(index) {
      return items[Controller2.toPage(index)];
    }
    function update() {
      var prev = getAt(getIndex(true));
      var curr = getAt(getIndex());
      if (prev) {
        var button = prev.button;
        removeClass(button, CLASS_ACTIVE);
        removeAttribute(button, ARIA_SELECTED);
        setAttribute(button, TAB_INDEX, -1);
      }
      if (curr) {
        var _button = curr.button;
        addClass(_button, CLASS_ACTIVE);
        setAttribute(_button, ARIA_SELECTED, true);
        setAttribute(_button, TAB_INDEX, "");
      }
      emit(EVENT_PAGINATION_UPDATED, {
        list,
        items
      }, prev, curr);
    }
    return {
      items,
      mount,
      destroy,
      getAt,
      update
    };
  }
  var TRIGGER_KEYS = [" ", "Enter"];
  function Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
      Splide2.splides.forEach(function(target) {
        if (!target.isParent) {
          sync(Splide2, target.splide);
          sync(target.splide, Splide2);
        }
      });
      if (isNavigation) {
        navigate();
      }
    }
    function destroy() {
      events.forEach(function(event2) {
        event2.destroy();
      });
      empty(events);
    }
    function remount() {
      destroy();
      mount();
    }
    function sync(splide, target) {
      var event2 = EventInterface(splide);
      event2.on(EVENT_MOVE, function(index, prev, dest) {
        target.go(target.is(LOOP) ? dest : index);
      });
      events.push(event2);
    }
    function navigate() {
      var event2 = EventInterface(Splide2);
      var on = event2.on;
      on(EVENT_CLICK, onClick);
      on(EVENT_SLIDE_KEYDOWN, onKeydown);
      on([EVENT_MOUNTED, EVENT_UPDATED], update);
      events.push(event2);
      event2.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
    }
    function update() {
      setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === TTB ? "vertical" : "");
    }
    function onClick(Slide2) {
      Splide2.go(Slide2.index);
    }
    function onKeydown(Slide2, e2) {
      if (includes(TRIGGER_KEYS, normalizeKey(e2))) {
        onClick(Slide2);
        prevent(e2);
      }
    }
    return {
      setup: apply(Components2.Media.set, {
        slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus
      }, true),
      mount,
      destroy,
      remount
    };
  }
  function Wheel(Splide2, Components2, options) {
    var _EventInterface12 = EventInterface(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
      if (options.wheel) {
        bind(Components2.Elements.track, "wheel", onWheel, SCROLL_LISTENER_OPTIONS);
      }
    }
    function onWheel(e2) {
      if (e2.cancelable) {
        var deltaY = e2.deltaY;
        var backwards = deltaY < 0;
        var timeStamp = timeOf(e2);
        var _min = options.wheelMinThreshold || 0;
        var sleep = options.wheelSleep || 0;
        if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
          Splide2.go(backwards ? "<" : ">");
          lastTime = timeStamp;
        }
        shouldPrevent(backwards) && prevent(e2);
      }
    }
    function shouldPrevent(backwards) {
      return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
      mount
    };
  }
  var SR_REMOVAL_DELAY = 90;
  function Live(Splide2, Components2, options) {
    var _EventInterface13 = EventInterface(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = create("span", CLASS_SR);
    var interval = RequestInterval(SR_REMOVAL_DELAY, apply(toggle, false));
    function mount() {
      if (enabled) {
        disable(!Components2.Autoplay.isPaused());
        setAttribute(track, ARIA_ATOMIC, true);
        sr.textContent = "\u2026";
        on(EVENT_AUTOPLAY_PLAY, apply(disable, true));
        on(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
        on([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
      }
    }
    function toggle(active) {
      setAttribute(track, ARIA_BUSY, active);
      if (active) {
        append(track, sr);
        interval.start();
      } else {
        remove(sr);
        interval.cancel();
      }
    }
    function destroy() {
      removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
      remove(sr);
    }
    function disable(disabled) {
      if (enabled) {
        setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
      }
    }
    return {
      mount,
      disable,
      destroy
    };
  }
  var ComponentConstructors = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    Media,
    Direction,
    Elements,
    Slides,
    Layout,
    Clones,
    Move,
    Controller,
    Arrows,
    Autoplay,
    Cover,
    Scroll,
    Drag,
    Keyboard,
    LazyLoad,
    Pagination,
    Sync,
    Wheel,
    Live
  });
  var I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
  };
  var DEFAULTS = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: CLASSES,
    i18n: I18N,
    reducedMotion: {
      speed: 0,
      rewindSpeed: 0,
      autoplay: "pause"
    }
  };
  function Fade(Splide2, Components2, options) {
    var Slides2 = Components2.Slides;
    function mount() {
      EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
    }
    function init() {
      Slides2.forEach(function(Slide2) {
        Slide2.style("transform", "translateX(-" + 100 * Slide2.index + "%)");
      });
    }
    function start(index, done) {
      Slides2.style("transition", "opacity " + options.speed + "ms " + options.easing);
      nextTick(done);
    }
    return {
      mount,
      start,
      cancel: noop
    };
  }
  function Slide(Splide2, Components2, options) {
    var Move2 = Components2.Move, Controller2 = Components2.Controller, Scroll2 = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = apply(style, list, "transition");
    var endCallback;
    function mount() {
      EventInterface(Splide2).bind(list, "transitionend", function(e2) {
        if (e2.target === list && endCallback) {
          cancel();
          endCallback();
        }
      });
    }
    function start(index, done) {
      var destination = Move2.toPosition(index, true);
      var position = Move2.getPosition();
      var speed = getSpeed(index);
      if (abs(destination - position) >= 1 && speed >= 1) {
        if (options.useScroll) {
          Scroll2.scroll(destination, speed, false, done);
        } else {
          transition("transform " + speed + "ms " + options.easing);
          Move2.translate(destination, true);
          endCallback = done;
        }
      } else {
        Move2.jump(index);
        done();
      }
    }
    function cancel() {
      transition("");
      Scroll2.cancel();
    }
    function getSpeed(index) {
      var rewindSpeed = options.rewindSpeed;
      if (Splide2.is(SLIDE) && rewindSpeed) {
        var prev = Controller2.getIndex(true);
        var end = Controller2.getEnd();
        if (prev === 0 && index >= end || prev >= end && index === 0) {
          return rewindSpeed;
        }
      }
      return options.speed;
    }
    return {
      mount,
      start,
      cancel
    };
  }
  var _Splide = /* @__PURE__ */ function() {
    function _Splide2(target, options) {
      this.event = EventInterface();
      this.Components = {};
      this.state = State(CREATED);
      this.splides = [];
      this._o = {};
      this._E = {};
      var root = isString(target) ? query(document, target) : target;
      assert(root, root + " is invalid.");
      this.root = root;
      options = merge({
        label: getAttribute(root, ARIA_LABEL) || "",
        labelledby: getAttribute(root, ARIA_LABELLEDBY) || ""
      }, DEFAULTS, _Splide2.defaults, options || {});
      try {
        merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
      } catch (e2) {
        assert(false, "Invalid JSON");
      }
      this._o = Object.create(merge({}, options));
    }
    var _proto = _Splide2.prototype;
    _proto.mount = function mount(Extensions, Transition) {
      var _this = this;
      var state = this.state, Components2 = this.Components;
      assert(state.is([CREATED, DESTROYED]), "Already mounted!");
      state.set(CREATED);
      this._C = Components2;
      this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
      this._E = Extensions || this._E;
      var Constructors = assign({}, ComponentConstructors, this._E, {
        Transition: this._T
      });
      forOwn(Constructors, function(Component, key) {
        var component = Component(_this, Components2, _this._o);
        Components2[key] = component;
        component.setup && component.setup();
      });
      forOwn(Components2, function(component) {
        component.mount && component.mount();
      });
      this.emit(EVENT_MOUNTED);
      addClass(this.root, CLASS_INITIALIZED);
      state.set(IDLE);
      this.emit(EVENT_READY);
      return this;
    };
    _proto.sync = function sync(splide) {
      this.splides.push({
        splide
      });
      splide.splides.push({
        splide: this,
        isParent: true
      });
      if (this.state.is(IDLE)) {
        this._C.Sync.remount();
        splide.Components.Sync.remount();
      }
      return this;
    };
    _proto.go = function go(control) {
      this._C.Controller.go(control);
      return this;
    };
    _proto.on = function on(events, callback) {
      this.event.on(events, callback);
      return this;
    };
    _proto.off = function off(events) {
      this.event.off(events);
      return this;
    };
    _proto.emit = function emit(event2) {
      var _this$event;
      (_this$event = this.event).emit.apply(_this$event, [event2].concat(slice(arguments, 1)));
      return this;
    };
    _proto.add = function add(slides, index) {
      this._C.Slides.add(slides, index);
      return this;
    };
    _proto.remove = function remove2(matcher) {
      this._C.Slides.remove(matcher);
      return this;
    };
    _proto.is = function is(type) {
      return this._o.type === type;
    };
    _proto.refresh = function refresh() {
      this.emit(EVENT_REFRESH);
      return this;
    };
    _proto.destroy = function destroy(completely) {
      if (completely === void 0) {
        completely = true;
      }
      var event2 = this.event, state = this.state;
      if (state.is(CREATED)) {
        EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
      } else {
        forOwn(this._C, function(component) {
          component.destroy && component.destroy(completely);
        }, true);
        event2.emit(EVENT_DESTROY);
        event2.destroy();
        completely && empty(this.splides);
        state.set(DESTROYED);
      }
      return this;
    };
    _createClass(_Splide2, [{
      key: "options",
      get: function get() {
        return this._o;
      },
      set: function set(options) {
        this._C.Media.set(options, true, true);
      }
    }, {
      key: "length",
      get: function get() {
        return this._C.Slides.getLength(true);
      }
    }, {
      key: "index",
      get: function get() {
        return this._C.Controller.getIndex();
      }
    }]);
    return _Splide2;
  }();
  var Splide = _Splide;
  Splide.defaults = {};
  Splide.STATES = STATES;

  // node_modules/@fancyapps/ui/dist/fancybox/fancybox.esm.js
  var t = (t2) => "object" == typeof t2 && null !== t2 && t2.constructor === Object && "[object Object]" === Object.prototype.toString.call(t2);
  var e = (i2, ...n2) => {
    const s2 = n2.length;
    for (let o2 = 0; o2 < s2; o2++) {
      const s3 = n2[o2] || {};
      Object.entries(s3).forEach(([n3, s4]) => {
        const o3 = Array.isArray(s4) ? [] : {};
        i2[n3] || Object.assign(i2, { [n3]: o3 }), t(s4) ? Object.assign(i2[n3], e(o3, s4)) : Array.isArray(s4) ? Object.assign(i2, { [n3]: [...s4] }) : Object.assign(i2, { [n3]: s4 });
      });
    }
    return i2;
  };
  var i = function(t2) {
    return new DOMParser().parseFromString(t2, "text/html").body.firstChild;
  };
  var n = (t2) => t2 && null !== t2 && t2 instanceof Element && "nodeType" in t2;
  var s = function(t2) {
    const e2 = window.pageYOffset, i2 = window.pageYOffset + window.innerHeight;
    if (!n(t2))
      return 0;
    const s2 = t2.getBoundingClientRect(), o2 = s2.y + window.pageYOffset, a2 = s2.y + s2.height + window.pageYOffset;
    if (e2 > a2 || i2 < o2)
      return 0;
    if (e2 < o2 && i2 > a2)
      return 100;
    if (o2 < e2 && a2 > i2)
      return 100;
    let r2 = s2.height;
    o2 < e2 && (r2 -= window.pageYOffset - o2), a2 > i2 && (r2 -= a2 - i2);
    const l2 = r2 / window.innerHeight * 100;
    return Math.round(l2);
  };
  var o = !("undefined" == typeof window || !window.document || !window.document.createElement);
  var a;
  var r = ["a[href]", "area[href]", 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', "select:not([disabled]):not([aria-hidden])", "textarea:not([disabled]):not([aria-hidden])", "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)", "iframe", "object", "embed", "video", "audio", "[contenteditable]", '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'].join(",");
  var l = (t2) => {
    if (t2 && o) {
      void 0 === a && document.createElement("div").focus({ get preventScroll() {
        return a = true, false;
      } });
      try {
        if (a)
          t2.focus({ preventScroll: true });
        else {
          const e2 = window.pageXOffset || document.body.scrollTop, i2 = window.pageYOffset || document.body.scrollLeft;
          t2.focus(), document.body.scrollTo({ top: e2, left: i2, behavior: "auto" });
        }
      } catch (t3) {
      }
    }
  };
  var c = '<div class="f-spinner"><svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20"></circle><circle cx="25" cy="25" r="20"></circle></svg></div>';
  var h = { PANUP: "Move up", PANDOWN: "Move down", PANLEFT: "Move left", PANRIGHT: "Move right", ZOOMIN: "Zoom in", ZOOMOUT: "Zoom out", TOGGLEZOOM: "Toggle zoom level", TOGGLE1TO1: "Toggle zoom level", ITERATEZOOM: "Toggle zoom level", ROTATECCW: "Rotate counterclockwise", ROTATECW: "Rotate clockwise", FLIPX: "Flip horizontally", FLIPY: "Flip vertically", FITX: "Fit horizontally", FITY: "Fit vertically", RESET: "Reset", TOGGLEFS: "Toggle fullscreen" };
  var d = { dragToClose: true, hideScrollbar: true, Carousel: { classes: { container: "fancybox__carousel", viewport: "fancybox__viewport", track: "fancybox__track", slide: "fancybox__slide" } }, contentClick: "toggleZoom", contentDblClick: false, backdropClick: "close", animated: true, idle: 3500, showClass: "f-zoomInUp", hideClass: "f-fadeOut", commonCaption: false, parentEl: null, startIndex: 0, l10n: Object.assign(Object.assign({}, h), { CLOSE: "Close", NEXT: "Next", PREV: "Previous", MODAL: "You can close this modal content with the ESC key", ERROR: "Something Went Wrong, Please Try Again Later", IMAGE_ERROR: "Image Not Found", ELEMENT_NOT_FOUND: "HTML Element Not Found", AJAX_NOT_FOUND: "Error Loading AJAX : Not Found", AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden", IFRAME_ERROR: "Error Loading Page", TOGGLE_ZOOM: "Toggle zoom level", TOGGLE_THUMBS: "Toggle thumbnails", TOGGLE_SLIDESHOW: "Toggle slideshow", TOGGLE_FULLSCREEN: "Toggle full-screen mode", DOWNLOAD: "Download" }), tpl: { closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>', main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>' }, groupAll: false, groupAttr: "data-fancybox", defaultType: "image", defaultDisplay: "block", autoFocus: true, trapFocus: true, placeFocusBack: true, closeButton: "auto", keyboard: { Escape: "close", Delete: "close", Backspace: "close", PageUp: "next", PageDown: "prev", ArrowUp: "prev", ArrowDown: "next", ArrowRight: "next", ArrowLeft: "prev" }, Fullscreen: { autoStart: false }, compact: () => window.matchMedia("(max-width: 578px), (max-height: 578px)").matches, wheel: "zoom" };
  var u;
  var p;
  !function(t2) {
    t2[t2.Init = 0] = "Init", t2[t2.Ready = 1] = "Ready", t2[t2.Closing = 2] = "Closing", t2[t2.CustomClosing = 3] = "CustomClosing", t2[t2.Destroy = 4] = "Destroy";
  }(u || (u = {})), function(t2) {
    t2[t2.Loading = 0] = "Loading", t2[t2.Opening = 1] = "Opening", t2[t2.Ready = 2] = "Ready", t2[t2.Closing = 3] = "Closing";
  }(p || (p = {}));
  var m = function(t2, e2) {
    return t2.split(".").reduce((t3, e3) => "object" == typeof t3 ? t3[e3] : void 0, e2);
  };
  var f = class {
    constructor(t2 = {}) {
      Object.defineProperty(this, "options", { enumerable: true, configurable: true, writable: true, value: t2 }), Object.defineProperty(this, "events", { enumerable: true, configurable: true, writable: true, value: /* @__PURE__ */ new Map() }), this.setOptions(t2);
      for (const t3 of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))
        t3.startsWith("on") && "function" == typeof this[t3] && (this[t3] = this[t3].bind(this));
    }
    setOptions(t2) {
      this.options = t2 ? e({}, this.constructor.defaults, t2) : {};
      for (const [t3, e2] of Object.entries(this.option("on") || {}))
        this.on(t3, e2);
    }
    option(t2, ...e2) {
      let i2 = m(t2, this.options);
      return i2 && "function" == typeof i2 && (i2 = i2.call(this, this, ...e2)), i2;
    }
    optionFor(t2, e2, i2, ...n2) {
      let s2 = m(e2, t2);
      var o2;
      "string" != typeof (o2 = s2) || isNaN(o2) || isNaN(parseFloat(o2)) || (s2 = parseFloat(s2)), "true" === s2 && (s2 = true), "false" === s2 && (s2 = false), s2 && "function" == typeof s2 && (s2 = s2.call(this, this, t2, ...n2));
      let a2 = m(e2, this.options);
      return a2 && "function" == typeof a2 ? s2 = a2.call(this, this, t2, ...n2, s2) : void 0 === s2 && (s2 = a2), void 0 === s2 ? i2 : s2;
    }
    cn(t2) {
      const e2 = this.options.classes;
      return e2 && e2[t2] || "";
    }
    localize(t2, e2 = []) {
      t2 = String(t2).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t3, e3, i2) => {
        let n2 = "";
        return i2 ? n2 = this.option(`${e3[0] + e3.toLowerCase().substring(1)}.l10n.${i2}`) : e3 && (n2 = this.option(`l10n.${e3}`)), n2 || (n2 = t3), n2;
      });
      for (let i2 = 0; i2 < e2.length; i2++)
        t2 = t2.split(e2[i2][0]).join(e2[i2][1]);
      return t2 = t2.replace(/\{\{(.*?)\}\}/g, (t3, e3) => e3);
    }
    on(t2, e2) {
      let i2 = [];
      "string" == typeof t2 ? i2 = t2.split(" ") : Array.isArray(t2) && (i2 = t2), this.events || (this.events = /* @__PURE__ */ new Map()), i2.forEach((t3) => {
        let i3 = this.events.get(t3);
        i3 || (this.events.set(t3, []), i3 = []), i3.includes(e2) || i3.push(e2), this.events.set(t3, i3);
      });
    }
    off(t2, e2) {
      let i2 = [];
      "string" == typeof t2 ? i2 = t2.split(" ") : Array.isArray(t2) && (i2 = t2), i2.forEach((t3) => {
        const i3 = this.events.get(t3);
        if (Array.isArray(i3)) {
          const t4 = i3.indexOf(e2);
          t4 > -1 && i3.splice(t4, 1);
        }
      });
    }
    emit(t2, ...e2) {
      [...this.events.get(t2) || []].forEach((t3) => t3(this, ...e2)), "*" !== t2 && this.emit("*", t2, ...e2);
    }
  };
  Object.defineProperty(f, "version", { enumerable: true, configurable: true, writable: true, value: "5.0.13" }), Object.defineProperty(f, "defaults", { enumerable: true, configurable: true, writable: true, value: {} });
  var g = class extends f {
    constructor(t2 = {}) {
      super(t2), Object.defineProperty(this, "plugins", { enumerable: true, configurable: true, writable: true, value: {} });
    }
    attachPlugins(t2 = {}) {
      const e2 = /* @__PURE__ */ new Map();
      for (const [i2, n2] of Object.entries(t2)) {
        const t3 = this.option(i2), s2 = this.plugins[i2];
        s2 || false === t3 ? s2 && false === t3 && (s2.detach(), delete this.plugins[i2]) : e2.set(i2, new n2(this, t3 || {}));
      }
      for (const [t3, i2] of e2)
        this.plugins[t3] = i2, i2.attach();
      this.emit("attachPlugins");
    }
    detachPlugins() {
      for (const t2 of Object.values(this.plugins))
        t2.detach();
      return this.plugins = {}, this.emit("detachPlugins"), this;
    }
  };
  var b = class extends f {
    constructor(t2, e2) {
      super(e2), Object.defineProperty(this, "instance", { enumerable: true, configurable: true, writable: true, value: t2 });
    }
    attach() {
    }
    detach() {
    }
  };
  var v = () => {
    queueMicrotask(() => {
      (() => {
        const { slug: t2, index: e2 } = y.parseURL(), i2 = xt.getInstance();
        if (i2 && false !== i2.option("Hash")) {
          const n2 = i2.carousel;
          if (t2 && n2) {
            for (let e3 of n2.slides)
              if (e3.slug && e3.slug === t2)
                return n2.slideTo(e3.index);
            if (t2 === i2.option("slug"))
              return n2.slideTo(e2 - 1);
            const s2 = i2.getSlide(), o2 = s2 && s2.triggerEl && s2.triggerEl.dataset;
            if (o2 && o2.fancybox === t2)
              return n2.slideTo(e2 - 1);
          }
          y.hasSilentClose = true, i2.close();
        }
        y.startFromUrl();
      })();
    });
  };
  var y = class extends b {
    constructor() {
      super(...arguments), Object.defineProperty(this, "origHash", { enumerable: true, configurable: true, writable: true, value: "" }), Object.defineProperty(this, "timer", { enumerable: true, configurable: true, writable: true, value: null });
    }
    onChange() {
      const t2 = this.instance, e2 = t2.carousel;
      this.timer && clearTimeout(this.timer);
      const i2 = t2.getSlide();
      if (!e2 || !i2)
        return;
      const n2 = t2.isOpeningSlide(i2), s2 = new URL(document.URL).hash;
      let o2, a2 = i2.slug || void 0;
      o2 = a2 || this.instance.option("slug"), !o2 && i2.triggerEl && i2.triggerEl.dataset && (o2 = i2.triggerEl.dataset.fancybox);
      let r2 = "";
      o2 && "true" !== o2 && (r2 = "#" + o2 + (!a2 && e2.slides.length > 1 ? "-" + (i2.index + 1) : "")), n2 && (this.origHash = s2 !== r2 ? s2 : ""), r2 && s2 !== r2 && (this.timer = setTimeout(() => {
        try {
          window.history[n2 ? "pushState" : "replaceState"]({}, document.title, window.location.pathname + window.location.search + r2);
        } catch (t3) {
        }
      }, 300));
    }
    onClose() {
      if (this.timer && clearTimeout(this.timer), true !== y.hasSilentClose)
        try {
          window.history.replaceState({}, document.title, window.location.pathname + window.location.search + (this.origHash || ""));
        } catch (t2) {
        }
    }
    attach() {
      this.instance.on("Carousel.ready", this.onChange), this.instance.on("Carousel.change", this.onChange), this.instance.on("close", this.onClose);
    }
    detach() {
      this.instance.off("Carousel.ready", this.onChange), this.instance.off("Carousel.change", this.onChange), this.instance.off("close", this.onClose);
    }
    static parseURL() {
      const t2 = window.location.hash.slice(1), e2 = t2.split("-"), i2 = e2[e2.length - 1], n2 = i2 && /^\+?\d+$/.test(i2) && parseInt(e2.pop() || "1", 10) || 1;
      return { hash: t2, slug: e2.join("-"), index: n2 };
    }
    static startFromUrl() {
      if (y.hasSilentClose = false, xt.getInstance() || false === xt.defaults.Hash)
        return;
      const { hash: t2, slug: e2, index: i2 } = y.parseURL();
      if (!e2)
        return;
      let n2 = document.querySelector(`[data-slug="${t2}"]`);
      if (n2 && n2.dispatchEvent(new CustomEvent("click", { bubbles: true, cancelable: true })), xt.getInstance())
        return;
      const s2 = document.querySelectorAll(`[data-fancybox="${e2}"]`);
      s2.length && (n2 = s2[i2 - 1], n2 && n2.dispatchEvent(new CustomEvent("click", { bubbles: true, cancelable: true })));
    }
    static destroy() {
      window.removeEventListener("hashchange", v, false);
    }
  };
  function w() {
    window.addEventListener("hashchange", v, false), setTimeout(() => {
      y.startFromUrl();
    }, 500);
  }
  Object.defineProperty(y, "defaults", { enumerable: true, configurable: true, writable: true, value: {} }), Object.defineProperty(y, "hasSilentClose", { enumerable: true, configurable: true, writable: true, value: false }), o && (/complete|interactive|loaded/.test(document.readyState) ? w() : document.addEventListener("DOMContentLoaded", w));
  var x = (t2, e2 = 1e4) => (t2 = parseFloat(t2 + "") || 0, Math.round((t2 + Number.EPSILON) * e2) / e2);
  var E = function(t2) {
    if (!(t2 && t2 instanceof Element && t2.offsetParent))
      return false;
    const e2 = t2.scrollHeight > t2.clientHeight, i2 = window.getComputedStyle(t2).overflowY, n2 = -1 !== i2.indexOf("hidden"), s2 = -1 !== i2.indexOf("visible");
    return e2 && !n2 && !s2;
  };
  var S = function(t2, e2) {
    return !(!t2 || t2 === document.body || e2 && t2 === e2) && (E(t2) ? t2 : S(t2.parentElement, e2));
  };
  var P = (t2) => `${t2 || ""}`.split(" ").filter((t3) => !!t3);
  var C = (t2, e2, i2) => {
    P(e2).forEach((e3) => {
      t2 && t2.classList.toggle(e3, i2 || false);
    });
  };
  var M = class {
    constructor(t2) {
      Object.defineProperty(this, "pageX", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "pageY", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "clientX", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "clientY", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "id", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "time", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "nativePointer", { enumerable: true, configurable: true, writable: true, value: void 0 }), this.nativePointer = t2, this.pageX = t2.pageX, this.pageY = t2.pageY, this.clientX = t2.clientX, this.clientY = t2.clientY, this.id = self.Touch && t2 instanceof Touch ? t2.identifier : -1, this.time = Date.now();
    }
  };
  var T = { passive: false };
  var O = class {
    constructor(t2, { start: e2 = () => true, move: i2 = () => {
    }, end: n2 = () => {
    } }) {
      Object.defineProperty(this, "element", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "startCallback", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "moveCallback", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "endCallback", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "currentPointers", { enumerable: true, configurable: true, writable: true, value: [] }), Object.defineProperty(this, "startPointers", { enumerable: true, configurable: true, writable: true, value: [] }), this.element = t2, this.startCallback = e2, this.moveCallback = i2, this.endCallback = n2;
      for (const t3 of ["onPointerStart", "onTouchStart", "onMove", "onTouchEnd", "onPointerEnd", "onWindowBlur"])
        this[t3] = this[t3].bind(this);
      this.element.addEventListener("mousedown", this.onPointerStart, T), this.element.addEventListener("touchstart", this.onTouchStart, T), this.element.addEventListener("touchmove", this.onMove, T), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t2) {
      if (!t2.buttons || 0 !== t2.button)
        return;
      const e2 = new M(t2);
      this.currentPointers.some((t3) => t3.id === e2.id) || this.triggerPointerStart(e2, t2) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t2) {
      for (const e2 of Array.from(t2.changedTouches || []))
        this.triggerPointerStart(new M(e2), t2);
      window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t2) {
      const e2 = this.currentPointers.slice(), i2 = "changedTouches" in t2 ? Array.from(t2.changedTouches || []).map((t3) => new M(t3)) : [new M(t2)], n2 = [];
      for (const t3 of i2) {
        const e3 = this.currentPointers.findIndex((e4) => e4.id === t3.id);
        e3 < 0 || (n2.push(t3), this.currentPointers[e3] = t3);
      }
      n2.length && this.moveCallback(t2, this.currentPointers.slice(), e2);
    }
    onPointerEnd(t2) {
      t2.buttons > 0 && 0 !== t2.button || (this.triggerPointerEnd(t2, new M(t2)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t2) {
      for (const e2 of Array.from(t2.changedTouches || []))
        this.triggerPointerEnd(t2, new M(e2));
    }
    triggerPointerStart(t2, e2) {
      return !!this.startCallback(e2, t2, this.currentPointers.slice()) && (this.currentPointers.push(t2), this.startPointers.push(t2), true);
    }
    triggerPointerEnd(t2, e2) {
      const i2 = this.currentPointers.findIndex((t3) => t3.id === e2.id);
      i2 < 0 || (this.currentPointers.splice(i2, 1), this.startPointers.splice(i2, 1), this.endCallback(t2, e2, this.currentPointers.slice()));
    }
    onWindowBlur() {
      this.clear();
    }
    clear() {
      for (; this.currentPointers.length; ) {
        const t2 = this.currentPointers[this.currentPointers.length - 1];
        this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", { bubbles: true, cancelable: true, clientX: t2.clientX, clientY: t2.clientY }), t2, this.currentPointers.slice());
      }
    }
    stop() {
      this.element.removeEventListener("mousedown", this.onPointerStart, T), this.element.removeEventListener("touchstart", this.onTouchStart, T), this.element.removeEventListener("touchmove", this.onMove, T), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
  };
  function A(t2, e2) {
    return e2 ? Math.sqrt(Math.pow(e2.clientX - t2.clientX, 2) + Math.pow(e2.clientY - t2.clientY, 2)) : 0;
  }
  function z(t2, e2) {
    return e2 ? { clientX: (t2.clientX + e2.clientX) / 2, clientY: (t2.clientY + e2.clientY) / 2 } : t2;
  }
  var L;
  !function(t2) {
    t2[t2.Init = 0] = "Init", t2[t2.Error = 1] = "Error", t2[t2.Ready = 2] = "Ready", t2[t2.Panning = 3] = "Panning", t2[t2.Mousemove = 4] = "Mousemove", t2[t2.Destroy = 5] = "Destroy";
  }(L || (L = {}));
  var R = ["a", "b", "c", "d", "e", "f"];
  var k = { content: null, width: "auto", height: "auto", panMode: "drag", touch: true, dragMinThreshold: 3, lockAxis: false, mouseMoveFactor: 1, mouseMoveFriction: 0.12, zoom: true, pinchToZoom: true, panOnlyZoomed: "auto", minScale: 1, maxScale: 2, friction: 0.25, dragFriction: 0.35, decelFriction: 0.05, click: "toggleZoom", dblClick: false, wheel: "zoom", wheelLimit: 7, spinner: true, bounds: "auto", infinite: false, rubberband: true, bounce: true, maxVelocity: 75, transformParent: false, classes: { content: "f-panzoom__content", isLoading: "is-loading", canZoomIn: "can-zoom_in", canZoomOut: "can-zoom_out", isDraggable: "is-draggable", isDragging: "is-dragging", inFullscreen: "in-fullscreen", htmlHasFullscreen: "with-panzoom-in-fullscreen" }, l10n: h };
  var I = (t2, e2) => {
    t2 && P(e2).forEach((e3) => {
      t2.classList.remove(e3);
    });
  };
  var D = (t2, e2) => {
    t2 && P(e2).forEach((e3) => {
      t2.classList.add(e3);
    });
  };
  var F = { a: 1, b: 0, c: 0, d: 1, e: 0, f: 0 };
  var j = null;
  var H = null;
  var B = class extends g {
    get isTouchDevice() {
      return null === H && (H = window.matchMedia("(hover: none)").matches), H;
    }
    get isMobile() {
      return null === j && (j = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), j;
    }
    get panMode() {
      return "mousemove" !== this.options.panMode || this.isTouchDevice ? "drag" : "mousemove";
    }
    get panOnlyZoomed() {
      const t2 = this.options.panOnlyZoomed;
      return "auto" === t2 ? this.isTouchDevice : t2;
    }
    get isInfinite() {
      return this.option("infinite");
    }
    get angle() {
      return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
      return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
      const { a: t2, b: e2 } = this.current;
      return Math.sqrt(t2 * t2 + e2 * e2) || 1;
    }
    get targetScale() {
      const { a: t2, b: e2 } = this.target;
      return Math.sqrt(t2 * t2 + e2 * e2) || 1;
    }
    get minScale() {
      return this.option("minScale") || 1;
    }
    get fullScale() {
      const { contentRect: t2 } = this;
      return t2.fullWidth / t2.fitWidth || 1;
    }
    get maxScale() {
      return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
      const { containerRect: t2, contentRect: e2 } = this, i2 = Math.max(t2.height / e2.fitHeight, t2.width / e2.fitWidth) || 1;
      return Math.min(this.fullScale, i2);
    }
    get isScaling() {
      return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
      const t2 = this.content;
      return !!(t2 && t2 instanceof HTMLImageElement) && !t2.complete;
    }
    get isResting() {
      if (this.isBouncingX || this.isBouncingY)
        return false;
      for (const t2 of R) {
        const e2 = "e" == t2 || "f" === t2 ? 1e-3 : 1e-5;
        if (Math.abs(this.target[t2] - this.current[t2]) > e2)
          return false;
      }
      return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t2, e2 = {}, n2 = {}) {
      var s2;
      if (super(e2), Object.defineProperty(this, "pointerTracker", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "resizeObserver", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "updateTimer", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "clickTimer", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "rAF", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "isTicking", { enumerable: true, configurable: true, writable: true, value: false }), Object.defineProperty(this, "friction", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "ignoreBounds", { enumerable: true, configurable: true, writable: true, value: false }), Object.defineProperty(this, "isBouncingX", { enumerable: true, configurable: true, writable: true, value: false }), Object.defineProperty(this, "isBouncingY", { enumerable: true, configurable: true, writable: true, value: false }), Object.defineProperty(this, "clicks", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "trackingPoints", { enumerable: true, configurable: true, writable: true, value: [] }), Object.defineProperty(this, "pwt", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "cwd", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "pmme", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "state", { enumerable: true, configurable: true, writable: true, value: L.Init }), Object.defineProperty(this, "isDragging", { enumerable: true, configurable: true, writable: true, value: false }), Object.defineProperty(this, "container", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "content", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "spinner", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "containerRect", { enumerable: true, configurable: true, writable: true, value: { width: 0, height: 0, innerWidth: 0, innerHeight: 0 } }), Object.defineProperty(this, "contentRect", { enumerable: true, configurable: true, writable: true, value: { top: 0, right: 0, bottom: 0, left: 0, fullWidth: 0, fullHeight: 0, fitWidth: 0, fitHeight: 0, width: 0, height: 0 } }), Object.defineProperty(this, "dragStart", { enumerable: true, configurable: true, writable: true, value: { x: 0, y: 0, top: 0, left: 0, time: 0 } }), Object.defineProperty(this, "dragOffset", { enumerable: true, configurable: true, writable: true, value: { x: 0, y: 0, time: 0 } }), Object.defineProperty(this, "current", { enumerable: true, configurable: true, writable: true, value: Object.assign({}, F) }), Object.defineProperty(this, "target", { enumerable: true, configurable: true, writable: true, value: Object.assign({}, F) }), Object.defineProperty(this, "velocity", { enumerable: true, configurable: true, writable: true, value: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0 } }), Object.defineProperty(this, "lockedAxis", { enumerable: true, configurable: true, writable: true, value: false }), !t2)
        throw new Error("Container Element Not Found");
      this.container = t2, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, B.Plugins), n2)), this.emit("init");
      const o2 = this.content;
      if (o2.addEventListener("load", this.onLoad), o2.addEventListener("error", this.onError), this.isContentLoading) {
        if (this.option("spinner")) {
          t2.classList.add(this.cn("isLoading"));
          const e3 = i(c);
          !t2.contains(o2) || o2.parentElement instanceof HTMLPictureElement ? this.spinner = t2.appendChild(e3) : this.spinner = (null === (s2 = o2.parentElement) || void 0 === s2 ? void 0 : s2.insertBefore(e3, o2)) || null;
        }
        this.emit("beforeLoad");
      } else
        queueMicrotask(() => {
          this.enable();
        });
    }
    initContent() {
      const { container: t2 } = this, e2 = this.cn("content");
      let i2 = this.option("content") || t2.querySelector(`.${e2}`);
      if (i2 || (i2 = t2.querySelector("img,picture") || t2.firstElementChild, i2 && D(i2, e2)), i2 instanceof HTMLPictureElement && (i2 = i2.querySelector("img")), !i2)
        throw new Error("No content found");
      this.content = i2;
    }
    onLoad() {
      this.spinner && (this.spinner.remove(), this.spinner = null), this.option("spinner") && this.container.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), this.state === L.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
      this.state !== L.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = L.Error, this.emit("error"));
    }
    attachObserver() {
      var t2;
      const e2 = () => Math.abs(this.containerRect.width - this.container.getBoundingClientRect().width) > 0.1 || Math.abs(this.containerRect.height - this.container.getBoundingClientRect().height) > 0.1;
      this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(() => {
        this.updateTimer || (e2() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(() => {
          e2() && this.onResize(), this.updateTimer = null;
        }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
      })), null === (t2 = this.resizeObserver) || void 0 === t2 || t2.observe(this.container);
    }
    detachObserver() {
      var t2;
      null === (t2 = this.resizeObserver) || void 0 === t2 || t2.disconnect();
    }
    attachEvents() {
      const { container: t2 } = this;
      t2.addEventListener("click", this.onClick, { passive: false, capture: false }), t2.addEventListener("wheel", this.onWheel, { passive: false }), this.pointerTracker = new O(t2, { start: this.onPointerDown, move: this.onPointerMove, end: this.onPointerUp }), document.addEventListener("mousemove", this.onMouseMove);
    }
    detachEvents() {
      var t2;
      const { container: e2 } = this;
      e2.removeEventListener("click", this.onClick, { passive: false, capture: false }), e2.removeEventListener("wheel", this.onWheel, { passive: false }), null === (t2 = this.pointerTracker) || void 0 === t2 || t2.stop(), this.pointerTracker = null, document.removeEventListener("mousemove", this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, true), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
      this.setTargetForce();
      const t2 = this.option("maxVelocity");
      for (const e2 of R)
        this.friction ? (this.velocity[e2] *= 1 - this.friction, t2 && !this.isScaling && (this.velocity[e2] = Math.max(Math.min(this.velocity[e2], t2), -1 * t2)), this.current[e2] += this.velocity[e2]) : this.current[e2] = this.target[e2];
      this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(() => this.animate()) : this.stop("current");
    }
    setTargetForce() {
      for (const t2 of R)
        "e" === t2 && this.isBouncingX || "f" === t2 && this.isBouncingY || (this.velocity[t2] = (1 / (1 - this.friction) - 1) * (this.target[t2] - this.current[t2]));
    }
    checkBounds(t2 = 0, e2 = 0) {
      const { current: i2 } = this, n2 = i2.e + t2, s2 = i2.f + e2, o2 = this.getBounds(), { x: a2, y: r2 } = o2, l2 = a2.min, c2 = a2.max, h2 = r2.min, d2 = r2.max;
      let u2 = 0, p2 = 0;
      return l2 !== 1 / 0 && n2 < l2 ? u2 = l2 - n2 : c2 !== 1 / 0 && n2 > c2 && (u2 = c2 - n2), h2 !== 1 / 0 && s2 < h2 ? p2 = h2 - s2 : d2 !== 1 / 0 && s2 > d2 && (p2 = d2 - s2), Math.abs(u2) < 1e-3 && (u2 = 0), Math.abs(p2) < 1e-3 && (p2 = 0), Object.assign(Object.assign({}, o2), { xDiff: u2, yDiff: p2, inBounds: !u2 && !p2 });
    }
    clampTargetBounds() {
      const { target: t2 } = this, { x: e2, y: i2 } = this.getBounds();
      e2.min !== 1 / 0 && (t2.e = Math.max(t2.e, e2.min)), e2.max !== 1 / 0 && (t2.e = Math.min(t2.e, e2.max)), i2.min !== 1 / 0 && (t2.f = Math.max(t2.f, i2.min)), i2.max !== 1 / 0 && (t2.f = Math.min(t2.f, i2.max));
    }
    calculateContentDim(t2 = this.current) {
      const { content: e2, contentRect: i2 } = this, { fitWidth: n2, fitHeight: s2, fullWidth: o2, fullHeight: a2 } = i2;
      let r2 = o2, l2 = a2;
      if (this.option("zoom") || 0 !== this.angle) {
        const i3 = !(e2 instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e2).maxWidth || "none" === window.getComputedStyle(e2).maxHeight), c2 = i3 ? o2 : n2, h2 = i3 ? a2 : s2, d2 = this.getMatrix(t2), u2 = new DOMPoint(0, 0).matrixTransform(d2), p2 = new DOMPoint(0 + c2, 0).matrixTransform(d2), m2 = new DOMPoint(0 + c2, 0 + h2).matrixTransform(d2), f2 = new DOMPoint(0, 0 + h2).matrixTransform(d2), g2 = Math.abs(m2.x - u2.x), b2 = Math.abs(m2.y - u2.y), v2 = Math.abs(f2.x - p2.x), y2 = Math.abs(f2.y - p2.y);
        r2 = Math.max(g2, v2), l2 = Math.max(b2, y2);
      }
      return { contentWidth: r2, contentHeight: l2 };
    }
    setEdgeForce() {
      if (this.ignoreBounds || this.isDragging || "mousemove" === this.panMode || this.targetScale < this.scale)
        return this.isBouncingX = false, void (this.isBouncingY = false);
      const { target: t2 } = this, { x: e2, y: i2, xDiff: n2, yDiff: s2 } = this.checkBounds();
      const o2 = this.option("maxVelocity");
      let a2 = this.velocity.e, r2 = this.velocity.f;
      0 !== n2 ? (this.isBouncingX = true, n2 * a2 <= 0 ? a2 += 0.14 * n2 : (a2 = 0.14 * n2, e2.min !== 1 / 0 && (this.target.e = Math.max(t2.e, e2.min)), e2.max !== 1 / 0 && (this.target.e = Math.min(t2.e, e2.max))), o2 && (a2 = Math.max(Math.min(a2, o2), -1 * o2))) : this.isBouncingX = false, 0 !== s2 ? (this.isBouncingY = true, s2 * r2 <= 0 ? r2 += 0.14 * s2 : (r2 = 0.14 * s2, i2.min !== 1 / 0 && (this.target.f = Math.max(t2.f, i2.min)), i2.max !== 1 / 0 && (this.target.f = Math.min(t2.f, i2.max))), o2 && (r2 = Math.max(Math.min(r2, o2), -1 * o2))) : this.isBouncingY = false, this.isBouncingX && (this.velocity.e = a2), this.isBouncingY && (this.velocity.f = r2);
    }
    enable() {
      const { content: t2 } = this, e2 = new DOMMatrixReadOnly(window.getComputedStyle(t2).transform);
      for (const t3 of R)
        this.current[t3] = this.target[t3] = e2[t3];
      this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = L.Ready, this.emit("ready");
    }
    onClick(t2) {
      var e2;
      this.isDragging && (null === (e2 = this.pointerTracker) || void 0 === e2 || e2.clear(), this.trackingPoints = [], this.startDecelAnim());
      const i2 = t2.target;
      if (!i2 || t2.defaultPrevented)
        return;
      if (i2 && i2.hasAttribute("disabled"))
        return t2.preventDefault(), void t2.stopPropagation();
      if ((() => {
        const t3 = window.getSelection();
        return t3 && "Range" === t3.type;
      })() && !i2.closest("button"))
        return;
      const s2 = i2.closest("[data-panzoom-action]"), o2 = i2.closest("[data-panzoom-change]"), a2 = s2 || o2, r2 = a2 && n(a2) ? a2.dataset : null;
      if (r2) {
        const e3 = r2.panzoomChange, i3 = r2.panzoomAction;
        if ((e3 || i3) && t2.preventDefault(), e3) {
          let t3 = {};
          try {
            t3 = JSON.parse(e3);
          } catch (t4) {
            console && console.warn("The given data was not valid JSON");
          }
          return void this.applyChange(t3);
        }
        if (i3)
          return void (this[i3] && this[i3]());
      }
      if ((Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) && Date.now() - this.dragStart.time < 300)
        return t2.preventDefault(), void t2.stopPropagation();
      const l2 = this.content.getBoundingClientRect();
      if (this.dragStart.time && !this.canZoomOut() && (Math.abs(l2.x - this.dragStart.x) > 2 || Math.abs(l2.y - this.dragStart.y) > 2))
        return;
      this.dragStart.time = 0;
      const c2 = (e3) => {
        !this.option("zoom") || Math.abs(this.velocity.a) > 0.3 || e3 && "string" == typeof e3 && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e3) && "function" == typeof this[e3] && (t2.preventDefault(), this[e3]({ event: t2 }));
      }, h2 = this.option("click", t2), d2 = this.option("dblClick", t2);
      d2 ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(() => {
        1 === this.clicks ? (this.emit("click", t2), !t2.defaultPrevented && h2 && c2(h2)) : (this.emit("dblClick", t2), t2.defaultPrevented || c2(d2)), this.clicks = 0, this.clickTimer = null;
      }, 350))) : (this.emit("click", t2), !t2.defaultPrevented && h2 && c2(h2));
    }
    addTrackingPoint(t2) {
      const e2 = this.trackingPoints.filter((t3) => t3.time > Date.now() - 100);
      e2.push(t2), this.trackingPoints = e2;
    }
    onPointerDown(t2, e2, i2) {
      var n2;
      this.pwt = 0, this.dragOffset = { x: 0, y: 0, time: 0 }, this.trackingPoints = [];
      const s2 = this.content.getBoundingClientRect();
      if (this.dragStart = { x: s2.x, y: s2.y, top: s2.top, left: s2.left, time: Date.now() }, this.clickTimer)
        return false;
      if ("mousemove" === this.panMode && this.targetScale > 1)
        return t2.preventDefault(), t2.stopPropagation(), false;
      if (!i2.length) {
        const e3 = t2.composedPath()[0];
        if (["A", "TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].includes(e3.nodeName) || e3.closest("[contenteditable]") || e3.closest("[data-selectable]") || e3.closest("[data-panzoom-change]") || e3.closest("[data-panzoom-action]"))
          return false;
        null === (n2 = window.getSelection()) || void 0 === n2 || n2.removeAllRanges();
      }
      return "mousedown" === t2.type && t2.preventDefault(), x(this.targetScale, 1e3) === x(this.minScale, 1e3) ? (this.stop(), this.target.e = this.current.e, this.target.f = this.current.f) : this.stop("target"), this.isDragging = true, this.addTrackingPoint(e2), this.emit("touchStart", t2), true;
    }
    onPointerMove(t2, e2, i2) {
      if (false === this.option("touch", t2))
        return;
      if (!this.isDragging)
        return;
      if (e2.length < 2 && this.panOnlyZoomed && x(this.targetScale) <= x(this.minScale))
        return;
      if (this.emit("touchMove", t2), t2.defaultPrevented)
        return;
      this.addTrackingPoint(e2[0]);
      const { content: n2 } = this, s2 = z(i2[0], i2[1]), o2 = z(e2[0], e2[1]);
      let a2 = 0, r2 = 0;
      if (e2.length > 1) {
        const t3 = n2.getBoundingClientRect();
        a2 = s2.clientX - t3.left - 0.5 * t3.width, r2 = s2.clientY - t3.top - 0.5 * t3.height;
      }
      const l2 = A(i2[0], i2[1]), c2 = A(e2[0], e2[1]);
      let h2 = l2 ? c2 / l2 : 1, d2 = o2.clientX - s2.clientX, u2 = o2.clientY - s2.clientY;
      this.dragOffset.x += d2, this.dragOffset.y += u2, this.dragOffset.time = Date.now() - this.dragStart.time;
      let p2 = x(this.targetScale) === x(this.minScale) && this.option("lockAxis");
      if (p2 && !this.lockedAxis)
        if ("xy" === p2 || "y" === p2 || "touchmove" === t2.type) {
          if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6)
            return void t2.preventDefault();
          const e3 = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
          this.lockedAxis = e3 > 45 && e3 < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, d2 = 0, u2 = 0;
        } else
          this.lockedAxis = p2;
      if (S(t2.target, this.content) && (p2 = "x", this.dragOffset.y = 0), p2 && "xy" !== p2 && this.lockedAxis !== p2 && x(this.targetScale) === x(this.minScale))
        return;
      t2.cancelable && t2.preventDefault(), this.container.classList.add(this.cn("isDragging"));
      const m2 = this.checkBounds(d2, u2);
      this.option("rubberband") ? ("x" !== this.isInfinite && (m2.xDiff > 0 && d2 < 0 || m2.xDiff < 0 && d2 > 0) && (d2 *= Math.max(0, 0.5 - Math.abs(0.75 / this.contentRect.fitWidth * m2.xDiff))), "y" !== this.isInfinite && (m2.yDiff > 0 && u2 < 0 || m2.yDiff < 0 && u2 > 0) && (u2 *= Math.max(0, 0.5 - Math.abs(0.75 / this.contentRect.fitHeight * m2.yDiff)))) : (m2.xDiff && (d2 = 0), m2.yDiff && (u2 = 0));
      const f2 = this.targetScale, g2 = this.minScale, b2 = this.maxScale;
      f2 < 0.5 * g2 && (h2 = Math.max(h2, g2)), f2 > 1.5 * b2 && (h2 = Math.min(h2, b2)), "y" === this.lockedAxis && x(f2) === x(g2) && (d2 = 0), "x" === this.lockedAxis && x(f2) === x(g2) && (u2 = 0), this.applyChange({ originX: a2, originY: r2, panX: d2, panY: u2, scale: h2, friction: this.option("dragFriction"), ignoreBounds: true });
    }
    onPointerUp(t2, e2, i2) {
      if (i2.length)
        return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
      this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e2), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), S(t2.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t2), this.isDragging = false, this.lockedAxis = false, this.state !== L.Destroy && (t2.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
      this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = false, this.isBouncingY = false;
      for (const t3 of R)
        this.velocity[t3] = 0, this.target[t3] = this.current[t3];
      I(this.container, "is-scaling"), I(this.container, "is-animating"), this.isTicking = false;
      const { trackingPoints: t2 } = this, e2 = t2[0], i2 = t2[t2.length - 1];
      let n2 = 0, s2 = 0, o2 = 0;
      i2 && e2 && (n2 = i2.clientX - e2.clientX, s2 = i2.clientY - e2.clientY, o2 = i2.time - e2.time);
      let a2 = 0, r2 = 0, l2 = 0, c2 = 0, h2 = this.option("decelFriction");
      const d2 = this.targetScale;
      if ((d2 < this.minScale - 1e-5 || d2 > this.maxScale + 1e-5) && (h2 = 0.35), o2 > 0) {
        l2 = Math.abs(n2) > 3 ? n2 / (o2 / 30) : 0, c2 = Math.abs(s2) > 3 ? s2 / (o2 / 30) : 0;
        const t3 = this.option("maxVelocity");
        t3 && (l2 = Math.max(Math.min(l2, t3), -1 * t3), c2 = Math.max(Math.min(c2, t3), -1 * t3));
      }
      l2 && (a2 = l2 / (1 / (1 - h2) - 1)), c2 && (r2 = c2 / (1 / (1 - h2) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && x(d2) === this.minScale) && (a2 = l2 = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && x(d2) === this.minScale) && (r2 = c2 = 0);
      const u2 = this.dragOffset.x, p2 = this.dragOffset.y, m2 = this.option("dragMinThreshold") || 0;
      Math.abs(u2) < m2 && Math.abs(p2) < m2 && (a2 = r2 = 0, l2 = c2 = 0), this.applyChange({ panX: a2, panY: r2, friction: h2 }), this.emit("decel", l2, c2, u2, p2);
    }
    onWheel(t2) {
      var e2 = [-t2.deltaX || 0, -t2.deltaY || 0, -t2.detail || 0].reduce(function(t3, e3) {
        return Math.abs(e3) > Math.abs(t3) ? e3 : t3;
      });
      const i2 = Math.max(-1, Math.min(1, e2));
      if (this.emit("wheel", t2, i2), "mousemove" === this.panMode)
        return;
      if (t2.defaultPrevented)
        return;
      const n2 = this.option("wheel");
      "pan" === n2 ? (t2.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({ panX: 2 * -t2.deltaX, panY: 2 * -t2.deltaY, bounce: false })) : "zoom" === n2 && false !== this.option("zoom") && this.zoomWithWheel(t2);
    }
    onMouseMove(t2) {
      this.panWithMouse(t2);
    }
    onKeydown(t2) {
      "Escape" === t2.key && this.toggleFS();
    }
    onResize() {
      this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
      this.emit("beforeTransform");
      const { current: t2, target: e2, content: i2, contentRect: n2 } = this, s2 = Object.assign({}, F);
      for (const i3 of R) {
        const n3 = "e" == i3 || "f" === i3 ? 1e3 : 1e5;
        s2[i3] = x(t2[i3], n3), Math.abs(e2[i3] - t2[i3]) < ("e" == i3 || "f" === i3 ? 0.51 : 1e-3) && (this.current[i3] = e2[i3]);
      }
      const { a: o2, b: a2, c: r2, d: l2, e: c2, f: h2 } = s2, d2 = `matrix(${o2}, ${a2}, ${r2}, ${l2}, ${c2}, ${h2})`;
      let u2 = i2.parentElement instanceof HTMLPictureElement ? i2.parentElement : i2;
      if (this.option("transformParent") && (u2 = u2.parentElement || u2), u2.style.transform === d2)
        return;
      u2.style.transform = d2;
      const { contentWidth: p2, contentHeight: m2 } = this.calculateContentDim();
      n2.width = p2, n2.height = m2, this.emit("afterTransform");
    }
    updateMetrics(t2 = false) {
      if (!this || this.state === L.Destroy)
        return;
      if (this.isContentLoading)
        return;
      const { container: e2, containerRect: i2, content: n2 } = this, s2 = n2 instanceof HTMLImageElement, o2 = i2.innerWidth, a2 = i2.innerHeight, r2 = e2.getBoundingClientRect(), l2 = getComputedStyle(this.container), c2 = r2.width, h2 = r2.height, d2 = parseFloat(l2.paddingTop) + parseFloat(l2.paddingBottom), u2 = parseFloat(l2.paddingLeft) + parseFloat(l2.paddingRight);
      this.containerRect = { width: c2, height: h2, innerWidth: c2 - u2, innerHeight: h2 - d2 };
      let p2 = this.option("width") || "auto", m2 = this.option("height") || "auto";
      "auto" === p2 && (p2 = parseFloat(n2.dataset.width || "") || ((t3) => {
        let e3 = 0;
        return e3 = t3 instanceof HTMLImageElement ? t3.naturalWidth : t3 instanceof SVGElement ? t3.width.baseVal.value : Math.max(t3.offsetWidth, t3.scrollWidth), e3 || 0;
      })(n2)), "auto" === m2 && (m2 = parseFloat(n2.dataset.height || "") || ((t3) => {
        let e3 = 0;
        return e3 = t3 instanceof HTMLImageElement ? t3.naturalHeight : t3 instanceof SVGElement ? t3.height.baseVal.value : Math.max(t3.offsetHeight, t3.scrollHeight), e3 || 0;
      })(n2));
      let f2 = n2.parentElement instanceof HTMLPictureElement ? n2.parentElement : n2;
      this.option("transformParent") && (f2 = f2.parentElement || f2);
      const g2 = f2.getAttribute("style") || "";
      f2.style.setProperty("transform", "none", "important"), s2 && (f2.style.width = "", f2.style.height = ""), f2.offsetHeight;
      const b2 = n2.getBoundingClientRect();
      let v2 = b2.width, y2 = b2.height, w2 = 0, E2 = 0;
      if (s2 && ({ width: v2, height: y2, top: w2, left: E2 } = ((t3, e3, i3, n3) => {
        const s3 = i3 / n3;
        return s3 > t3 / e3 ? (i3 = t3, n3 = t3 / s3) : (i3 = e3 * s3, n3 = e3), { width: i3, height: n3, top: 0.5 * (e3 - n3), left: 0.5 * (t3 - i3) };
      })(b2.width, b2.height, p2, m2)), this.contentRect = Object.assign(Object.assign({}, this.contentRect), { top: b2.top - r2.top + w2, bottom: r2.bottom - b2.bottom + w2, left: b2.left - r2.left + E2, right: r2.right - b2.right + E2, fitWidth: v2, fitHeight: y2, width: v2, height: y2, fullWidth: p2, fullHeight: m2 }), f2.style.cssText = g2, s2 && (f2.style.width = `${v2}px`, f2.style.height = `${y2}px`), this.setTransform(), true !== t2) {
        let t3 = "";
        Math.abs(c2 - o2) > 1 && (t3 += "x"), Math.abs(h2 - a2) > 1 && (t3 += "y"), t3 && this.emit("refresh", t3);
      }
      this.ignoreBounds || (x(this.targetScale) < x(this.minScale) ? this.zoomTo(this.minScale, { friction: 0 }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, { friction: 0 }) : this.state === L.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    getBounds() {
      const t2 = this.option("bounds");
      if ("auto" !== t2)
        return t2;
      const { contentWidth: e2, contentHeight: i2 } = this.calculateContentDim(this.target);
      let n2 = 0, s2 = 0, o2 = 0, a2 = 0;
      const r2 = this.option("infinite");
      if (true === r2 || this.lockedAxis && r2 === this.lockedAxis)
        n2 = -1 / 0, o2 = 1 / 0, s2 = -1 / 0, a2 = 1 / 0;
      else {
        let { containerRect: t3, contentRect: r3 } = this, l2 = x(this.contentRect.fitWidth * this.targetScale, 1e3), c2 = x(this.contentRect.fitHeight * this.targetScale, 1e3), { innerWidth: h2, innerHeight: d2 } = t3;
        if (this.containerRect.width === l2 && (h2 = t3.width), this.containerRect.width === c2 && (d2 = t3.height), e2 > h2) {
          o2 = 0.5 * (e2 - h2), n2 = -1 * o2;
          let t4 = 0.5 * (r3.right - r3.left);
          n2 += t4, o2 += t4;
        }
        if (this.contentRect.fitWidth > h2 && e2 < h2 && (n2 -= 0.5 * (this.contentRect.fitWidth - h2), o2 -= 0.5 * (this.contentRect.fitWidth - h2)), i2 > d2) {
          a2 = 0.5 * (i2 - d2), s2 = -1 * a2;
          let t4 = 0.5 * (r3.bottom - r3.top);
          s2 += t4, a2 += t4;
        }
        this.contentRect.fitHeight > d2 && i2 < d2 && (n2 -= 0.5 * (this.contentRect.fitHeight - d2), o2 -= 0.5 * (this.contentRect.fitHeight - d2));
      }
      return { x: { min: n2, max: o2 }, y: { min: s2, max: a2 } };
    }
    updateControls() {
      const t2 = this, e2 = t2.container, { panMode: i2, contentRect: n2, fullScale: s2, targetScale: o2, coverScale: a2, maxScale: r2, minScale: l2 } = t2;
      let c2 = { toggleMax: o2 - l2 < 0.5 * (r2 - l2) ? r2 : l2, toggleCover: o2 - l2 < 0.5 * (a2 - l2) ? a2 : l2, toggleZoom: o2 - l2 < 0.5 * (s2 - l2) ? s2 : l2 }[t2.option("click") || ""] || l2, h2 = t2.canZoomIn(), d2 = t2.canZoomOut(), u2 = d2 && "drag" === i2;
      x(o2) < x(l2) && !this.panOnlyZoomed && (u2 = true), (x(n2.width, 1) > x(n2.fitWidth, 1) || x(n2.height, 1) > x(n2.fitHeight, 1)) && (u2 = true), x(n2.width * o2, 1) < x(n2.fitWidth, 1) && (u2 = false), "mousemove" === i2 && (u2 = false);
      let p2 = h2 && x(c2) > x(o2), m2 = !p2 && !u2 && d2 && x(c2) < x(o2);
      C(e2, this.cn("canZoomIn"), p2), C(e2, this.cn("canZoomOut"), m2), C(e2, this.cn("isDraggable"), u2);
      for (const t3 of e2.querySelectorAll('[data-panzoom-action="zoomIn"]'))
        h2 ? (t3.removeAttribute("disabled"), t3.removeAttribute("tabindex")) : (t3.setAttribute("disabled", ""), t3.setAttribute("tabindex", "-1"));
      for (const t3 of e2.querySelectorAll('[data-panzoom-action="zoomOut"]'))
        d2 ? (t3.removeAttribute("disabled"), t3.removeAttribute("tabindex")) : (t3.setAttribute("disabled", ""), t3.setAttribute("tabindex", "-1"));
      for (const t3 of e2.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')) {
        h2 || d2 ? (t3.removeAttribute("disabled"), t3.removeAttribute("tabindex")) : (t3.setAttribute("disabled", ""), t3.setAttribute("tabindex", "-1"));
        const e3 = t3.querySelector("g");
        e3 && (e3.style.display = h2 ? "" : "none");
      }
    }
    panTo({ x: t2 = this.target.e, y: e2 = this.target.f, scale: i2 = this.targetScale, friction: n2 = this.option("friction"), angle: s2 = 0, originX: o2 = 0, originY: a2 = 0, flipX: r2 = false, flipY: l2 = false, ignoreBounds: c2 = false }) {
      this.state !== L.Destroy && this.applyChange({ panX: t2 - this.target.e, panY: e2 - this.target.f, scale: i2 / this.targetScale, angle: s2, originX: o2, originY: a2, friction: n2, flipX: r2, flipY: l2, ignoreBounds: c2 });
    }
    applyChange({ panX: t2 = 0, panY: e2 = 0, scale: i2 = 1, angle: n2 = 0, originX: s2 = -this.current.e, originY: o2 = -this.current.f, friction: a2 = this.option("friction"), flipX: r2 = false, flipY: l2 = false, ignoreBounds: c2 = false, bounce: h2 = this.option("bounce") }) {
      if (this.state === L.Destroy)
        return;
      this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = false, this.isBouncingY = false;
      for (const t3 of R)
        this.velocity[t3] = 0;
      this.friction = a2 || 0, this.ignoreBounds = c2;
      const { current: d2 } = this, u2 = d2.e, p2 = d2.f, m2 = this.getMatrix(this.target);
      let f2 = new DOMMatrix().translate(u2, p2).translate(s2, o2).translate(t2, e2);
      if (this.option("zoom")) {
        if (!c2) {
          const t3 = this.targetScale, e3 = this.minScale, n3 = this.maxScale;
          t3 * i2 < e3 && (i2 = e3 / t3), t3 * i2 > n3 && (i2 = n3 / t3);
        }
        f2 = f2.scale(i2);
      }
      f2 = f2.translate(-s2, -o2).translate(-u2, -p2).multiply(m2), n2 && (f2 = f2.rotate(n2)), r2 && (f2 = f2.scale(-1, 1)), l2 && (f2 = f2.scale(1, -1));
      for (const t3 of R)
        "a" != t3 && "d" != t3 || !(f2[t3] > this.minScale + 1e-5 || f2[t3] < this.minScale - 1e-5) ? this.target[t3] = x(f2[t3], 1e3) : this.target[t3] = f2[t3];
      (this.targetScale < this.scale || Math.abs(i2 - 1) > 0.1 || "mousemove" === this.panMode || false === h2) && !c2 && this.clampTargetBounds(), this.isResting || (this.state = L.Panning, this.requestTick());
    }
    stop(t2 = false) {
      if (this.state === L.Init || this.state === L.Destroy)
        return;
      const e2 = this.isTicking;
      this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = false, this.isBouncingY = false;
      for (const e3 of R)
        this.velocity[e3] = 0, "current" === t2 ? this.current[e3] = this.target[e3] : "target" === t2 && (this.target[e3] = this.current[e3]);
      this.setTransform(), I(this.container, "is-scaling"), I(this.container, "is-animating"), this.isTicking = false, this.state = L.Ready, e2 && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
      this.isTicking || (this.emit("startAnimation"), this.updateControls(), D(this.container, "is-animating"), this.isScaling && D(this.container, "is-scaling")), this.isTicking = true, this.rAF || (this.rAF = requestAnimationFrame(() => this.animate()));
    }
    panWithMouse(t2, e2 = this.option("mouseMoveFriction")) {
      if (this.pmme = t2, "mousemove" !== this.panMode || !t2)
        return;
      if (x(this.targetScale) <= x(this.minScale))
        return;
      this.emit("mouseMove", t2);
      const { container: i2, containerRect: n2, contentRect: s2 } = this, o2 = n2.width, a2 = n2.height, r2 = i2.getBoundingClientRect(), l2 = (t2.clientX || 0) - r2.left, c2 = (t2.clientY || 0) - r2.top;
      let { contentWidth: h2, contentHeight: d2 } = this.calculateContentDim(this.target);
      const u2 = this.option("mouseMoveFactor");
      u2 > 1 && (h2 !== o2 && (h2 *= u2), d2 !== a2 && (d2 *= u2));
      let p2 = 0.5 * (h2 - o2) - l2 / o2 * 100 / 100 * (h2 - o2);
      p2 += 0.5 * (s2.right - s2.left);
      let m2 = 0.5 * (d2 - a2) - c2 / a2 * 100 / 100 * (d2 - a2);
      m2 += 0.5 * (s2.bottom - s2.top), this.applyChange({ panX: p2 - this.target.e, panY: m2 - this.target.f, friction: e2 });
    }
    zoomWithWheel(t2) {
      if (this.state === L.Destroy || this.state === L.Init)
        return;
      const e2 = Date.now();
      if (e2 - this.pwt < 45)
        return void t2.preventDefault();
      this.pwt = e2;
      var i2 = [-t2.deltaX || 0, -t2.deltaY || 0, -t2.detail || 0].reduce(function(t3, e3) {
        return Math.abs(e3) > Math.abs(t3) ? e3 : t3;
      });
      const n2 = Math.max(-1, Math.min(1, i2)), { targetScale: s2, maxScale: o2, minScale: a2 } = this;
      let r2 = s2 * (100 + 45 * n2) / 100;
      x(r2) < x(a2) && x(s2) <= x(a2) ? (this.cwd += Math.abs(n2), r2 = a2) : x(r2) > x(o2) && x(s2) >= x(o2) ? (this.cwd += Math.abs(n2), r2 = o2) : (this.cwd = 0, r2 = Math.max(Math.min(r2, o2), a2)), this.cwd > this.option("wheelLimit") || (t2.preventDefault(), x(r2) !== x(s2) && this.zoomTo(r2, { event: t2 }));
    }
    canZoomIn() {
      return this.option("zoom") && (x(this.contentRect.width, 1) < x(this.contentRect.fitWidth, 1) || x(this.targetScale) < x(this.maxScale));
    }
    canZoomOut() {
      return this.option("zoom") && x(this.targetScale) > x(this.minScale);
    }
    zoomIn(t2 = 1.25, e2) {
      this.zoomTo(this.targetScale * t2, e2);
    }
    zoomOut(t2 = 0.8, e2) {
      this.zoomTo(this.targetScale * t2, e2);
    }
    zoomToFit(t2) {
      this.zoomTo("fit", t2);
    }
    zoomToCover(t2) {
      this.zoomTo("cover", t2);
    }
    zoomToFull(t2) {
      this.zoomTo("full", t2);
    }
    zoomToMax(t2) {
      this.zoomTo("max", t2);
    }
    toggleZoom(t2) {
      this.zoomTo(this.targetScale - this.minScale < 0.5 * (this.fullScale - this.minScale) ? "full" : "fit", t2);
    }
    toggleMax(t2) {
      this.zoomTo(this.targetScale - this.minScale < 0.5 * (this.maxScale - this.minScale) ? "max" : "fit", t2);
    }
    toggleCover(t2) {
      this.zoomTo(this.targetScale - this.minScale < 0.5 * (this.coverScale - this.minScale) ? "cover" : "fit", t2);
    }
    iterateZoom(t2) {
      this.zoomTo("next", t2);
    }
    zoomTo(t2 = 1, { friction: e2 = "auto", originX: i2 = 0, originY: n2 = 0, event: s2 } = {}) {
      if (this.isContentLoading || this.state === L.Destroy)
        return;
      this.stop();
      const { targetScale: o2 } = this;
      let a2 = 1;
      if ("mousemove" === this.panMode && (s2 = this.pmme || s2), s2) {
        const t3 = this.content.getBoundingClientRect(), e3 = s2.clientX || 0, o3 = s2.clientY || 0;
        i2 = e3 - t3.left - 0.5 * t3.width, n2 = o3 - t3.top - 0.5 * t3.height;
      }
      const r2 = this.fullScale, l2 = this.maxScale;
      let c2 = this.coverScale;
      "number" == typeof t2 ? a2 = t2 / o2 : ("next" === t2 && (r2 - c2 < 0.2 && (c2 = r2), t2 = o2 < r2 - 1e-5 ? "full" : o2 < l2 - 1e-5 ? "max" : "fit"), a2 = "full" === t2 ? r2 / o2 || 1 : "cover" === t2 ? c2 / o2 || 1 : "max" === t2 ? l2 / o2 || 1 : 1 / o2 || 1), e2 = "auto" === e2 ? a2 > 1 ? 0.15 : 0.25 : e2, this.applyChange({ scale: a2, originX: i2, originY: n2, friction: e2 }), s2 && "mousemove" === this.panMode && this.panWithMouse(s2, e2);
    }
    rotateCCW() {
      this.applyChange({ angle: -90 });
    }
    rotateCW() {
      this.applyChange({ angle: 90 });
    }
    flipX() {
      this.applyChange({ flipX: true });
    }
    flipY() {
      this.applyChange({ flipY: true });
    }
    fitX() {
      this.stop("target");
      const { containerRect: t2, contentRect: e2, target: i2 } = this;
      this.applyChange({ panX: 0.5 * t2.width - (e2.left + 0.5 * e2.fitWidth) - i2.e, panY: 0.5 * t2.height - (e2.top + 0.5 * e2.fitHeight) - i2.f, scale: t2.width / e2.fitWidth / this.targetScale, originX: 0, originY: 0, ignoreBounds: true });
    }
    fitY() {
      this.stop("target");
      const { containerRect: t2, contentRect: e2, target: i2 } = this;
      this.applyChange({ panX: 0.5 * t2.width - (e2.left + 0.5 * e2.fitWidth) - i2.e, panY: 0.5 * t2.height - (e2.top + 0.5 * e2.fitHeight) - i2.f, scale: t2.height / e2.fitHeight / this.targetScale, originX: 0, originY: 0, ignoreBounds: true });
    }
    toggleFS() {
      const { container: t2 } = this, e2 = this.cn("inFullscreen"), i2 = this.cn("htmlHasFullscreen");
      t2.classList.toggle(e2);
      const n2 = t2.classList.contains(e2);
      n2 ? (document.documentElement.classList.add(i2), document.addEventListener("keydown", this.onKeydown, true)) : (document.documentElement.classList.remove(i2), document.removeEventListener("keydown", this.onKeydown, true)), this.updateMetrics(), this.emit(n2 ? "enterFS" : "exitFS");
    }
    getMatrix(t2 = this.current) {
      const { a: e2, b: i2, c: n2, d: s2, e: o2, f: a2 } = t2;
      return new DOMMatrix([e2, i2, n2, s2, o2, a2]);
    }
    reset(t2) {
      if (this.state !== L.Init && this.state !== L.Destroy) {
        this.stop("current");
        for (const t3 of R)
          this.target[t3] = F[t3];
        this.target.a = this.minScale, this.target.d = this.minScale, this.isResting || (this.friction = void 0 === t2 ? this.option("friction") : t2, this.state = L.Panning, this.requestTick());
      }
    }
    destroy() {
      this.stop(), this.state = L.Destroy, this.detachEvents(), this.detachObserver();
      const { container: t2, content: e2 } = this, i2 = this.option("classes") || {};
      for (const e3 of Object.values(i2))
        t2.classList.remove(e3 + "");
      e2 && (e2.removeEventListener("load", this.onLoad), e2.removeEventListener("error", this.onError)), this.detachPlugins();
    }
  };
  Object.defineProperty(B, "defaults", { enumerable: true, configurable: true, writable: true, value: k }), Object.defineProperty(B, "Plugins", { enumerable: true, configurable: true, writable: true, value: {} });
  var _ = (t2) => new Promise((e2, i2) => {
    const n2 = new Image();
    n2.onload = e2, n2.onerror = i2, n2.src = t2;
  });
  var N = class extends b {
    onCreateSlide(t2, e2, i2) {
      const n2 = this.instance, s2 = n2.optionFor(i2, "src") || "", { el: o2, type: a2 } = i2;
      o2 && "image" === a2 && "string" == typeof s2 && this.setContent(i2, s2).then((t3) => {
        if (n2.isClosing())
          return;
        const e3 = i2.contentEl, s3 = i2.imageEl, o3 = i2.thumbElSrc, a3 = this.optionFor(i2, "initialSize"), r2 = this.optionFor(i2, "zoom"), l2 = { event: n2.prevMouseMoveEvent || n2.options.event, friction: r2 ? 0.12 : 0 };
        if (e3 && s3 && o3 && n2.isOpeningSlide(i2) && this.getZoomInfo(i2)) {
          let t4 = document.createElement("img");
          D(t4, "fancybox-ghost"), e3.appendChild(t4), t4.src = o3, setTimeout(() => {
            n2.animate(t4, "f-fadeFastOut", () => {
              t4 && (t4.remove(), t4 = null);
            });
          }, 333), _(o3).then(() => {
            i2.state = p.Opening, this.instance.emit("reveal", i2), this.zoomIn(i2).then(() => {
              this.instance.done(i2);
            }, () => {
              n2.hideLoading(i2);
            });
          }, () => {
            n2.hideLoading(i2), n2.revealContent(i2);
          });
        } else {
          let e4 = n2.optionFor(i2, "showClass") || void 0, s4 = true;
          n2.isOpeningSlide(i2) && ("full" === a3 ? t3.zoomToFull(l2) : "cover" === a3 ? t3.zoomToCover(l2) : "max" === a3 ? t3.zoomToMax(l2) : s4 = false, t3.stop("current")), s4 && e4 && (e4 = "f-fadeIn"), n2.revealContent(i2, e4);
        }
      }, () => {
        n2.setError(i2, "{{IMAGE_ERROR}}");
      });
    }
    onRemoveSlide(t2, e2, i2) {
      i2.panzoom && i2.panzoom.destroy(), i2.panzoom = void 0, i2.imageEl = void 0;
    }
    onChange(t2, e2, i2, n2) {
      for (const t3 of e2.slides) {
        const e3 = t3.panzoom;
        e3 && t3.index !== i2 && e3.reset(0.35);
      }
    }
    onClose() {
      const t2 = this.instance, e2 = t2.container, i2 = t2.getSlide();
      if (!e2 || !e2.parentElement || !i2)
        return;
      const { el: n2, contentEl: s2, panzoom: o2 } = i2, a2 = i2.thumbElSrc;
      if (!n2 || !a2 || !s2 || !o2 || o2.isContentLoading || o2.state === L.Init || o2.state === L.Destroy)
        return;
      o2.updateMetrics();
      let r2 = this.getZoomInfo(i2);
      if (!r2)
        return;
      this.instance.state = u.CustomClosing, n2.classList.remove("is-zooming-in"), n2.classList.add("is-zooming-out"), s2.style.backgroundImage = `url('${a2}')`, _(a2).then(() => {
        n2.classList.add("hide-image");
      }, () => {
      });
      const l2 = e2.getBoundingClientRect();
      Object.assign(e2.style, { position: "absolute", top: `${window.pageYOffset}px`, left: `${window.pageXOffset}px`, bottom: "auto", right: "auto", width: `${l2.width}px`, height: `${l2.height}px`, overflow: "hidden" });
      const { x: c2, y: h2, scale: d2, opacity: p2 } = r2;
      if (p2) {
        const t3 = ((t4, e3, i3, n3) => {
          const s3 = e3 - t4, o3 = n3 - i3;
          return (e4) => i3 + ((e4 - t4) / s3 * o3 || 0);
        })(o2.scale, d2, 1, 0);
        o2.on("afterTransform", () => {
          s2.style.opacity = t3(o2.scale) + "";
        });
      }
      o2.on("endAnimation", () => {
        t2.destroy();
      }), o2.target.a = d2, o2.target.b = 0, o2.target.c = 0, o2.target.d = d2, o2.panTo({ x: c2, y: h2, scale: d2, friction: p2 ? 0.2 : 0.33, ignoreBounds: true }), o2.isResting && t2.destroy();
    }
    setContent(t2, s2) {
      return new Promise((o2, a2) => {
        var r2, l2;
        const c2 = this.instance, h2 = t2.el;
        if (!h2)
          return void a2();
        c2.showLoading(t2);
        let d2 = this.optionFor(t2, "content");
        if ("string" == typeof d2 && (d2 = i(d2)), d2 && n(d2) || (d2 = document.createElement("img"), d2 instanceof HTMLImageElement && (d2.src = s2 || "", d2.alt = (null === (r2 = t2.caption) || void 0 === r2 ? void 0 : r2.replace(/<[^>]+>/gi, "").substring(0, 1e3)) || `Image ${t2.index + 1} of ${null === (l2 = c2.carousel) || void 0 === l2 ? void 0 : l2.pages.length}`, d2.draggable = false, t2.srcset && d2.setAttribute("srcset", t2.srcset)), t2.sizes && d2.setAttribute("sizes", t2.sizes)), d2.classList.add("fancybox-image"), t2.imageEl = d2, c2.setContent(t2, d2, false), this.option("protected")) {
          h2.addEventListener("contextmenu", (t3) => {
            t3.preventDefault();
          });
          const e2 = t2.contentEl;
          if (e2) {
            const t3 = document.createElement("div");
            D(t3, "fancybox-protected"), e2.append(t3);
          }
        }
        t2.panzoom = new B(h2, e({}, this.option("Panzoom") || {}, { content: d2, width: c2.optionFor(t2, "width", "auto"), height: c2.optionFor(t2, "height", "auto"), wheel: () => {
          const t3 = c2.option("wheel");
          return ("zoom" === t3 || "pan" == t3) && t3;
        }, click: (e2, i2) => {
          var n2, s3;
          if (c2.isCompact || c2.isClosing())
            return false;
          if (t2.index !== (null === (n2 = c2.getSlide()) || void 0 === n2 ? void 0 : n2.index))
            return false;
          let o3 = !i2 || i2.target && (null === (s3 = t2.contentEl) || void 0 === s3 ? void 0 : s3.contains(i2.target));
          return c2.option(o3 ? "contentClick" : "backdropClick") || false;
        }, dblClick: () => c2.isCompact ? "toggleZoom" : c2.option("contentDblClick") || false, spinner: false, panOnlyZoomed: true, wheelLimit: 1 / 0, transformParent: true, on: { ready: (t3) => {
          o2(t3);
        }, error: () => {
          a2();
        }, destroy: () => {
          a2();
        } } }));
      });
    }
    zoomIn(t2) {
      return new Promise((e2, i2) => {
        const { panzoom: n2, contentEl: s2, el: o2 } = t2;
        n2 && n2.updateMetrics();
        const a2 = this.getZoomInfo(t2);
        if (!(a2 && o2 && s2 && n2))
          return void i2();
        const { x: r2, y: l2, scale: c2, opacity: h2 } = a2, d2 = () => {
          t2.state !== p.Closing && (h2 && (s2.style.opacity = Math.max(Math.min(1, 1 - (1 - n2.scale) / (1 - c2)), 0) + ""), n2.scale >= 1 && n2.scale > n2.targetScale - 0.1 && e2(n2));
        }, u2 = (t3) => {
          t3.scale < 0.99 || t3.scale > 1.01 || (s2.style.opacity = "", o2.classList.remove("is-zooming-in"), t3.off("endAnimation", u2), t3.off("touchStart", u2), t3.off("afterTransform", d2), e2(t3));
        };
        n2.on("endAnimation", u2), n2.on("touchStart", u2), n2.on("afterTransform", d2), n2.on(["error", "destroy"], () => {
          i2();
        }), n2.panTo({ x: r2, y: l2, scale: c2, friction: 0, ignoreBounds: true }), n2.stop("current");
        const m2 = this.instance, f2 = { event: "mousemove" === n2.panMode ? m2.prevMouseMoveEvent || m2.options.event : void 0 }, g2 = this.optionFor(t2, "initialSize");
        D(o2, "is-zooming-in"), m2.hideLoading(t2), "full" === g2 ? n2.zoomToFull(f2) : "cover" === g2 ? n2.zoomToCover(f2) : "max" === g2 ? n2.zoomToMax(f2) : n2.reset(0.165);
      });
    }
    getZoomInfo(t2) {
      const { el: e2, imageEl: i2, thumbEl: n2, panzoom: o2 } = t2;
      if (!e2 || !i2 || !n2 || !o2 || s(n2) < 3 || !this.optionFor(t2, "zoom") || this.instance.state === u.Destroy)
        return false;
      const { top: a2, left: r2, width: l2, height: c2 } = n2.getBoundingClientRect();
      let { top: h2, left: d2, fitWidth: p2, fitHeight: m2 } = o2.contentRect;
      if (!(l2 && c2 && p2 && m2))
        return false;
      const f2 = l2 / p2, g2 = o2.container.getBoundingClientRect();
      h2 += g2.top, d2 += g2.left;
      const b2 = -1 * (d2 + 0.5 * p2 - (r2 + 0.5 * l2)), v2 = -1 * (h2 + 0.5 * m2 - (a2 + 0.5 * c2));
      let y2 = this.option("zoomOpacity") || false;
      return "auto" === y2 && (y2 = Math.abs(l2 / c2 - p2 / m2) > 0.1), { x: b2, y: v2, scale: f2, opacity: y2 };
    }
    attach() {
      this.instance.on("Carousel.change", this.onChange), this.instance.on("Carousel.createSlide", this.onCreateSlide), this.instance.on("Carousel.removeSlide", this.onRemoveSlide), this.instance.on("close", this.onClose);
    }
    detach() {
      this.instance.off("Carousel.change", this.onChange), this.instance.off("Carousel.createSlide", this.onCreateSlide), this.instance.off("Carousel.removeSlide", this.onRemoveSlide), this.instance.off("close", this.onClose);
    }
  };
  Object.defineProperty(N, "defaults", { enumerable: true, configurable: true, writable: true, value: { initialSize: "fit", Panzoom: { maxScale: 1 }, protected: false, zoom: true, zoomOpacity: "auto" } });
  var W = (t2, e2 = {}) => {
    const i2 = new URL(t2), n2 = new URLSearchParams(i2.search), s2 = new URLSearchParams();
    for (const [t3, i3] of [...n2, ...Object.entries(e2)]) {
      let e3 = i3.toString();
      "t" === t3 ? s2.set("start", parseInt(e3).toString()) : s2.set(t3, e3);
    }
    let o2 = s2.toString(), a2 = t2.match(/#t=((.*)?\d+s)/);
    return a2 && (o2 += `#t=${a2[1]}`), o2;
  };
  var $ = { ajax: null, autoSize: true, preload: true, videoAutoplay: true, videoRatio: 16 / 9, videoTpl: `<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">
  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn't support embedded videos.</video>`, videoFormat: "", vimeo: { byline: 1, color: "00adef", controls: 1, dnt: 1, muted: 0 }, youtube: { controls: 1, enablejsapi: 1, nocookie: 1, rel: 0, fs: 1 } };
  var X = ["image", "html", "ajax", "inline", "clone", "iframe", "map", "pdf", "html5video", "youtube", "vimeo", "video"];
  var Y = class extends b {
    onInitSlide(t2, e2, i2) {
      this.processType(i2);
    }
    onCreateSlide(t2, e2, i2) {
      this.setContent(i2);
    }
    onRemoveSlide(t2, e2, i2) {
      i2.closeBtnEl && (i2.closeBtnEl.remove(), i2.closeBtnEl = void 0), i2.xhr && (i2.xhr.abort(), i2.xhr = null), i2.iframeEl && (i2.iframeEl.onload = i2.iframeEl.onerror = null, i2.iframeEl.src = "//about:blank", i2.iframeEl = null);
      const n2 = i2.contentEl, s2 = i2.placeholderEl;
      if ("inline" === i2.type && n2 && s2)
        n2.classList.remove("fancybox__content"), "none" !== n2.style.display && (n2.style.display = "none"), s2.parentNode && s2.parentNode.insertBefore(n2, s2), s2.remove(), i2.placeholderEl = null;
      else
        for (; i2.el && i2.el.firstChild; )
          i2.el.removeChild(i2.el.firstChild);
    }
    onSelectSlide(t2, e2, i2) {
      i2.state === p.Ready && this.playVideo();
    }
    onUnselectSlide(t2, e2, i2) {
      var n2, s2;
      if ("html5video" === i2.type) {
        try {
          null === (s2 = null === (n2 = i2.el) || void 0 === n2 ? void 0 : n2.querySelector("video")) || void 0 === s2 || s2.pause();
        } catch (t3) {
        }
        return;
      }
      let o2;
      "vimeo" === i2.type ? o2 = { method: "pause", value: "true" } : "youtube" === i2.type && (o2 = { event: "command", func: "pauseVideo" }), o2 && i2.iframeEl && i2.iframeEl.contentWindow && i2.iframeEl.contentWindow.postMessage(JSON.stringify(o2), "*"), i2.poller && clearTimeout(i2.poller);
    }
    onDone(t2, e2) {
      t2.isCurrentSlide(e2) && !t2.isClosing() && this.playVideo();
    }
    onRefresh(t2, e2) {
      e2.slides.forEach((t3) => {
        t3.el && (this.setAspectRatio(t3), this.resizeIframe(t3));
      });
    }
    onMessage(t2) {
      try {
        let e2 = JSON.parse(t2.data);
        if ("https://player.vimeo.com" === t2.origin) {
          if ("ready" === e2.event)
            for (let e3 of Array.from(document.getElementsByClassName("fancybox__iframe")))
              e3 instanceof HTMLIFrameElement && e3.contentWindow === t2.source && (e3.dataset.ready = "true");
        } else if (t2.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e2.event) {
          const t3 = document.getElementById(e2.id);
          t3 && (t3.dataset.ready = "true");
        }
      } catch (t3) {
      }
    }
    loadAjaxContent(t2) {
      const e2 = this.instance.optionFor(t2, "src") || "";
      this.instance.showLoading(t2);
      const i2 = this.instance, n2 = new XMLHttpRequest();
      i2.showLoading(t2), n2.onreadystatechange = function() {
        n2.readyState === XMLHttpRequest.DONE && i2.state === u.Ready && (i2.hideLoading(t2), 200 === n2.status ? i2.setContent(t2, n2.responseText) : i2.setError(t2, 404 === n2.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
      };
      const s2 = t2.ajax || null;
      n2.open(s2 ? "POST" : "GET", e2 + ""), n2.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n2.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n2.send(s2), t2.xhr = n2;
    }
    setInlineContent(t2) {
      let e2 = null;
      if (n(t2.src))
        e2 = t2.src;
      else if ("string" == typeof t2.src) {
        const i2 = t2.src.split("#", 2).pop();
        e2 = i2 ? document.getElementById(i2) : null;
      }
      if (e2) {
        if ("clone" === t2.type || e2.closest(".fancybox__slide")) {
          e2 = e2.cloneNode(true);
          const i2 = e2.dataset.animationName;
          i2 && (e2.classList.remove(i2), delete e2.dataset.animationName);
          let n2 = e2.getAttribute("id");
          n2 = n2 ? `${n2}--clone` : `clone-${this.instance.id}-${t2.index}`, e2.setAttribute("id", n2);
        } else if (e2.parentNode) {
          const i2 = document.createElement("div");
          i2.classList.add("fancybox-placeholder"), e2.parentNode.insertBefore(i2, e2), t2.placeholderEl = i2;
        }
        this.instance.setContent(t2, e2);
      } else
        this.instance.setError(t2, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t2) {
      const { src: e2, el: i2 } = t2;
      if (!e2 || "string" != typeof e2 || !i2)
        return;
      const n2 = this.instance, s2 = document.createElement("iframe");
      s2.className = "fancybox__iframe", s2.setAttribute("id", `fancybox__iframe_${n2.id}_${t2.index}`), s2.setAttribute("allow", "autoplay; fullscreen"), s2.setAttribute("scrolling", "auto"), s2.onerror = () => {
        n2.setError(t2, "{{IFRAME_ERROR}}");
      }, t2.iframeEl = s2;
      const o2 = this.optionFor(t2, "preload");
      if (i2.classList.add("is-loading"), "iframe" !== t2.type || false === o2)
        return s2.setAttribute("src", t2.src + ""), this.resizeIframe(t2), void n2.setContent(t2, s2);
      n2.showLoading(t2), s2.onload = () => {
        if (!s2.src.length)
          return;
        const e3 = "true" !== s2.dataset.ready;
        s2.dataset.ready = "true", this.resizeIframe(t2), e3 ? n2.revealContent(t2) : n2.hideLoading(t2);
      }, s2.setAttribute("src", e2), n2.setContent(t2, s2, false);
    }
    resizeIframe(t2) {
      const e2 = t2.iframeEl, i2 = null == e2 ? void 0 : e2.parentElement;
      if (!e2 || !i2)
        return;
      let n2 = t2.autoSize, s2 = t2.width || 0, o2 = t2.height || 0;
      s2 && o2 && (n2 = false);
      const a2 = i2 && i2.style;
      if (false !== t2.preload && false !== n2 && a2)
        try {
          const t3 = window.getComputedStyle(i2), n3 = parseFloat(t3.paddingLeft) + parseFloat(t3.paddingRight), r2 = parseFloat(t3.paddingTop) + parseFloat(t3.paddingBottom), l2 = e2.contentWindow;
          if (l2) {
            const t4 = l2.document, e3 = t4.getElementsByTagName("html")[0], i3 = t4.body;
            a2.width = "", i3.style.overflow = "hidden", s2 = s2 || e3.scrollWidth + n3, a2.width = `${s2}px`, i3.style.overflow = "", a2.flex = "0 0 auto", a2.height = `${i3.scrollHeight}px`, o2 = e3.scrollHeight + r2;
          }
        } catch (t3) {
        }
      if (s2 || o2) {
        const t3 = { flex: "0 1 auto", width: "", height: "" };
        s2 && (t3.width = `${s2}px`), o2 && (t3.height = `${o2}px`), Object.assign(a2, t3);
      }
    }
    playVideo() {
      const t2 = this.instance.getSlide();
      if (!t2)
        return;
      const { el: e2 } = t2;
      if (!e2 || !e2.offsetParent)
        return;
      if (!this.optionFor(t2, "videoAutoplay"))
        return;
      if ("html5video" === t2.type)
        try {
          const t3 = e2.querySelector("video");
          if (t3) {
            const e3 = t3.play();
            void 0 !== e3 && e3.then(() => {
            }).catch((e4) => {
              t3.muted = true, t3.play();
            });
          }
        } catch (t3) {
        }
      if ("youtube" !== t2.type && "vimeo" !== t2.type)
        return;
      const i2 = () => {
        if (t2.iframeEl && t2.iframeEl.contentWindow) {
          let e3;
          if ("true" === t2.iframeEl.dataset.ready)
            return e3 = "youtube" === t2.type ? { event: "command", func: "playVideo" } : { method: "play", value: "true" }, e3 && t2.iframeEl.contentWindow.postMessage(JSON.stringify(e3), "*"), void (t2.poller = void 0);
          "youtube" === t2.type && (e3 = { event: "listening", id: t2.iframeEl.getAttribute("id") }, t2.iframeEl.contentWindow.postMessage(JSON.stringify(e3), "*"));
        }
        t2.poller = setTimeout(i2, 250);
      };
      i2();
    }
    processType(t2) {
      if (t2.html)
        return t2.type = "html", t2.src = t2.html, void (t2.html = "");
      const e2 = this.instance.optionFor(t2, "src", "");
      if (!e2 || "string" != typeof e2)
        return;
      let i2 = t2.type, n2 = null;
      if (n2 = e2.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
        const s2 = this.optionFor(t2, "youtube"), { nocookie: o2 } = s2, a2 = function(t3, e3) {
          var i3 = {};
          for (var n3 in t3)
            Object.prototype.hasOwnProperty.call(t3, n3) && e3.indexOf(n3) < 0 && (i3[n3] = t3[n3]);
          if (null != t3 && "function" == typeof Object.getOwnPropertySymbols) {
            var s3 = 0;
            for (n3 = Object.getOwnPropertySymbols(t3); s3 < n3.length; s3++)
              e3.indexOf(n3[s3]) < 0 && Object.prototype.propertyIsEnumerable.call(t3, n3[s3]) && (i3[n3[s3]] = t3[n3[s3]]);
          }
          return i3;
        }(s2, ["nocookie"]), r2 = `www.youtube${o2 ? "-nocookie" : ""}.com`, l2 = W(e2, a2), c2 = encodeURIComponent(n2[2]);
        t2.videoId = c2, t2.src = `https://${r2}/embed/${c2}?${l2}`, t2.thumbSrc = t2.thumbSrc || `https://i.ytimg.com/vi/${c2}/mqdefault.jpg`, i2 = "youtube";
      } else if (n2 = e2.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
        const s2 = W(e2, this.optionFor(t2, "vimeo")), o2 = encodeURIComponent(n2[1]), a2 = n2[4] || "";
        t2.videoId = o2, t2.src = `https://player.vimeo.com/video/${o2}?${a2 ? `h=${a2}${s2 ? "&" : ""}` : ""}${s2}`, i2 = "vimeo";
      }
      if (!i2 && t2.triggerEl) {
        const e3 = t2.triggerEl.dataset.type;
        X.includes(e3) && (i2 = e3);
      }
      i2 || "string" == typeof e2 && ("#" === e2.charAt(0) ? i2 = "inline" : (n2 = e2.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i2 = "html5video", t2.videoFormat = t2.videoFormat || "video/" + ("ogv" === n2[1] ? "ogg" : n2[1])) : e2.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i2 = "image" : e2.match(/\.(pdf)((\?|#).*)?$/i) ? i2 = "pdf" : (n2 = e2.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t2.src = `https://maps.google.${n2[1]}/?ll=${(n2[2] ? n2[2] + "&z=" + Math.floor(parseFloat(n2[3])) + (n2[4] ? n2[4].replace(/^\//, "&") : "") : n2[4] + "").replace(/\?/, "&")}&output=${n2[4] && n2[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i2 = "map") : (n2 = e2.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t2.src = `https://maps.google.${n2[1]}/maps?q=${n2[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i2 = "map")), i2 = i2 || this.instance.option("defaultType"), t2.type = i2, "image" === i2 && (t2.thumbSrc = t2.thumbSrc || t2.src);
    }
    setContent(t2) {
      const e2 = this.instance.optionFor(t2, "src") || "";
      if (t2 && t2.type && e2) {
        switch (t2.type) {
          case "html":
            this.instance.setContent(t2, e2);
            break;
          case "html5video":
            const i2 = this.option("videoTpl");
            i2 && this.instance.setContent(t2, i2.replace(/\{\{src\}\}/gi, e2 + "").replace(/\{\{format\}\}/gi, this.optionFor(t2, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t2.poster || t2.thumbSrc || ""));
            break;
          case "inline":
          case "clone":
            this.setInlineContent(t2);
            break;
          case "ajax":
            this.loadAjaxContent(t2);
            break;
          case "pdf":
          case "map":
          case "youtube":
          case "vimeo":
            t2.preload = false;
          case "iframe":
            this.setIframeContent(t2);
        }
        this.setAspectRatio(t2);
      }
    }
    setAspectRatio(t2) {
      var e2;
      const i2 = t2.contentEl, n2 = this.optionFor(t2, "videoRatio"), s2 = null === (e2 = t2.el) || void 0 === e2 ? void 0 : e2.getBoundingClientRect();
      if (!(i2 && s2 && n2 && 1 !== n2 && t2.type && ["video", "youtube", "vimeo", "html5video"].includes(t2.type)))
        return;
      const o2 = s2.width, a2 = s2.height;
      i2.style.aspectRatio = n2 + "", i2.style.width = o2 / a2 > n2 ? "auto" : "", i2.style.height = o2 / a2 > n2 ? "" : "auto";
    }
    attach() {
      this.instance.on("Carousel.initSlide", this.onInitSlide), this.instance.on("Carousel.createSlide", this.onCreateSlide), this.instance.on("Carousel.removeSlide", this.onRemoveSlide), this.instance.on("Carousel.selectSlide", this.onSelectSlide), this.instance.on("Carousel.unselectSlide", this.onUnselectSlide), this.instance.on("Carousel.Panzoom.refresh", this.onRefresh), this.instance.on("done", this.onDone), window.addEventListener("message", this.onMessage);
    }
    detach() {
      this.instance.off("Carousel.initSlide", this.onInitSlide), this.instance.off("Carousel.createSlide", this.onCreateSlide), this.instance.off("Carousel.removeSlide", this.onRemoveSlide), this.instance.off("Carousel.selectSlide", this.onSelectSlide), this.instance.off("Carousel.unselectSlide", this.onUnselectSlide), this.instance.off("Carousel.Panzoom.refresh", this.onRefresh), this.instance.off("done", this.onDone), window.removeEventListener("message", this.onMessage);
    }
  };
  Object.defineProperty(Y, "defaults", { enumerable: true, configurable: true, writable: true, value: $ });
  var q = class extends b {
    constructor() {
      super(...arguments), Object.defineProperty(this, "state", { enumerable: true, configurable: true, writable: true, value: "ready" }), Object.defineProperty(this, "inHover", { enumerable: true, configurable: true, writable: true, value: false }), Object.defineProperty(this, "timer", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "progressBar", { enumerable: true, configurable: true, writable: true, value: null });
    }
    get isActive() {
      return "ready" !== this.state;
    }
    onReady(t2) {
      this.option("autoStart") && (t2.isInfinite || t2.page < t2.pages.length - 1) && this.start();
    }
    onChange() {
      var t2;
      (null === (t2 = this.instance.panzoom) || void 0 === t2 ? void 0 : t2.isResting) || (this.removeProgressBar(), this.pause());
    }
    onSettle() {
      this.resume();
    }
    onVisibilityChange() {
      "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
      this.inHover = true, this.pause();
    }
    onMouseLeave() {
      var t2;
      this.inHover = false, (null === (t2 = this.instance.panzoom) || void 0 === t2 ? void 0 : t2.isResting) && this.resume();
    }
    onTimerEnd() {
      "play" === this.state && (this.instance.isInfinite || this.instance.page !== this.instance.pages.length - 1 ? this.instance.slideNext() : this.instance.slideTo(0));
    }
    removeProgressBar() {
      this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
      var t2;
      if (!this.option("showProgress"))
        return null;
      this.removeProgressBar();
      const e2 = this.instance, i2 = (null === (t2 = e2.pages[e2.page]) || void 0 === t2 ? void 0 : t2.slides) || [];
      let n2 = this.option("progressParentEl");
      if (n2 || (n2 = (1 === i2.length ? i2[0].el : null) || e2.viewport), !n2)
        return null;
      const s2 = document.createElement("div");
      return D(s2, "f-progress"), n2.prepend(s2), this.progressBar = s2, s2.offsetHeight, s2;
    }
    set() {
      if (this.instance.pages.length < 2)
        return;
      if (this.progressBar)
        return;
      const t2 = this.option("timeout");
      this.state = "play", D(this.instance.container, "has-autoplay");
      let e2 = this.createProgressBar();
      e2 && (e2.style.transitionDuration = `${t2}ms`, e2.style.transform = "scaleX(1)"), this.timer = setTimeout(() => {
        this.timer = null, this.inHover || this.onTimerEnd();
      }, t2), this.emit("set");
    }
    clear() {
      this.timer && (clearTimeout(this.timer), this.timer = null), this.removeProgressBar();
    }
    start() {
      if (this.set(), this.option("pauseOnHover")) {
        const t2 = this.instance.container;
        t2.addEventListener("mouseenter", this.onMouseEnter, false), t2.addEventListener("mouseleave", this.onMouseLeave, false);
      }
      document.addEventListener("visibilitychange", this.onVisibilityChange, false);
    }
    stop() {
      const t2 = this.instance.container;
      this.clear(), this.state = "ready", t2.removeEventListener("mouseenter", this.onMouseEnter, false), t2.removeEventListener("mouseleave", this.onMouseLeave, false), document.removeEventListener("visibilitychange", this.onVisibilityChange, false), I(t2, "has-autoplay"), this.emit("stop");
    }
    pause() {
      "play" === this.state && (this.state = "pause", this.clear(), this.emit("pause"));
    }
    resume() {
      const t2 = this.instance;
      if (t2.isInfinite || t2.page !== t2.pages.length - 1)
        if ("play" !== this.state) {
          if ("pause" === this.state && !this.inHover) {
            const t3 = new Event("resume", { bubbles: true, cancelable: true });
            this.emit("resume", event), t3.defaultPrevented || this.set();
          }
        } else
          this.set();
      else
        this.stop();
    }
    toggle() {
      "play" === this.state || "pause" === this.state ? this.stop() : this.set();
    }
    attach() {
      this.instance.on("ready", this.onReady), this.instance.on("Panzoom.startAnimation", this.onChange), this.instance.on("Panzoom.endAnimation", this.onSettle), this.instance.on("Panzoom.touchMove", this.onChange);
    }
    detach() {
      this.instance.off("ready", this.onReady), this.instance.off("Panzoom.startAnimation", this.onChange), this.instance.off("Panzoom.endAnimation", this.onSettle), this.instance.off("Panzoom.touchMove", this.onChange), this.stop();
    }
  };
  Object.defineProperty(q, "defaults", { enumerable: true, configurable: true, writable: true, value: { autoStart: true, pauseOnHover: true, progressParentEl: null, showProgress: true, timeout: 3e3 } });
  var Z = class extends b {
    constructor() {
      super(...arguments), Object.defineProperty(this, "ref", { enumerable: true, configurable: true, writable: true, value: null });
    }
    onPrepare(t2) {
      const i2 = t2.carousel;
      if (!i2)
        return;
      const n2 = t2.container;
      n2 && (i2.options.Autoplay = e(this.option("Autoplay") || {}, { pauseOnHover: false, autoStart: false, timeout: this.option("timeout"), progressParentEl: () => n2.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]") || n2, on: { set: (e2) => {
        var i3;
        n2.classList.add("has-slideshow"), (null === (i3 = t2.getSlide()) || void 0 === i3 ? void 0 : i3.state) !== p.Ready && e2.pause();
      }, stop: () => {
        n2.classList.remove("has-slideshow"), t2.isCompact || t2.endIdle();
      }, resume: (e2, i3) => {
        var n3, s2, o2;
        !i3 || !i3.cancelable || (null === (n3 = t2.getSlide()) || void 0 === n3 ? void 0 : n3.state) === p.Ready && (null === (o2 = null === (s2 = t2.carousel) || void 0 === s2 ? void 0 : s2.panzoom) || void 0 === o2 ? void 0 : o2.isResting) || i3.preventDefault();
      } } }), i2.attachPlugins({ Autoplay: q }), this.ref = i2.plugins.Autoplay);
    }
    onReady(t2) {
      const e2 = t2.carousel, i2 = this.ref;
      e2 && i2 && this.option("playOnStart") && (e2.isInfinite || e2.page < e2.pages.length - 1) && i2.start();
    }
    onDone(t2, e2) {
      const i2 = this.ref;
      if (!i2)
        return;
      const n2 = e2.panzoom;
      n2 && n2.on("startAnimation", () => {
        t2.isCurrentSlide(e2) && i2.stop();
      }), t2.isCurrentSlide(e2) && i2.resume();
    }
    onKeydown(t2, e2) {
      var i2;
      const n2 = this.ref;
      n2 && e2 === this.option("key") && "BUTTON" !== (null === (i2 = document.activeElement) || void 0 === i2 ? void 0 : i2.nodeName) && n2.toggle();
    }
    attach() {
      this.instance.on("Carousel.init", this.onPrepare), this.instance.on("Carousel.ready", this.onReady), this.instance.on("done", this.onDone), this.instance.on("keydown", this.onKeydown);
    }
    detach() {
      this.instance.off("Carousel.init", this.onPrepare), this.instance.off("Carousel.ready", this.onReady), this.instance.off("done", this.onDone), this.instance.off("keydown", this.onKeydown);
    }
  };
  Object.defineProperty(Z, "defaults", { enumerable: true, configurable: true, writable: true, value: { key: " ", playOnStart: false, timeout: 3e3 } });
  var V = { classes: { container: "f-thumbs f-carousel__thumbs", viewport: "f-thumbs__viewport", track: "f-thumbs__track", slide: "f-thumbs__slide", isResting: "is-resting", isSelected: "is-selected", isLoading: "is-loading", hasThumbs: "has-thumbs" }, minCount: 2, parentEl: null, thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>', type: "modern" };
  var G;
  !function(t2) {
    t2[t2.Init = 0] = "Init", t2[t2.Ready = 1] = "Ready", t2[t2.Hidden = 2] = "Hidden", t2[t2.Disabled = 3] = "Disabled";
  }(G || (G = {}));
  var U = class extends b {
    constructor() {
      super(...arguments), Object.defineProperty(this, "type", { enumerable: true, configurable: true, writable: true, value: "modern" }), Object.defineProperty(this, "container", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "track", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "carousel", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "panzoom", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "thumbWidth", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "thumbClipWidth", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "thumbHeight", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "thumbGap", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "thumbExtraGap", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "shouldCenter", { enumerable: true, configurable: true, writable: true, value: true }), Object.defineProperty(this, "state", { enumerable: true, configurable: true, writable: true, value: G.Init });
    }
    formatThumb(t2, e2) {
      return this.instance.localize(e2, [["%i", t2.index], ["%d", t2.index + 1], ["%s", t2.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"]]);
    }
    getSlides() {
      const t2 = [], e2 = this.option("thumbTpl") || "";
      if (e2)
        for (const i2 of this.instance.slides || []) {
          let n2 = "";
          i2.type && (n2 = `for-${i2.type}`, i2.type && ["video", "youtube", "vimeo", "html5video"].includes(i2.type) && (n2 += " for-video")), t2.push({ html: this.formatThumb(i2, e2), customClass: n2 });
        }
      return t2;
    }
    onInitSlide(t2, e2) {
      const i2 = e2.el;
      i2 && (e2.thumbSrc = i2.dataset.thumbSrc || e2.thumbSrc || "", e2.thumbClipWidth = parseFloat(i2.dataset.thumbClipWidth || "") || e2.thumbClipWidth || 0, e2.thumbHeight = parseFloat(i2.dataset.thumbHeight || "") || e2.thumbHeight || 0);
    }
    onInitSlides() {
      this.state === G.Init && this.build();
    }
    onRefreshM() {
      this.refreshModern();
    }
    onChangeM() {
      "modern" === this.type && (this.shouldCenter = true, this.centerModern());
    }
    onClickModern(t2) {
      t2.preventDefault(), t2.stopPropagation();
      const e2 = this.instance, i2 = e2.page, n2 = (t3) => {
        if (t3) {
          const e3 = t3.closest("[data-carousel-index]");
          if (e3)
            return parseInt(e3.dataset.carouselIndex || "", 10) || 0;
        }
        return -1;
      }, s2 = (t3, e3) => {
        const i3 = document.elementFromPoint(t3, e3);
        return i3 ? n2(i3) : -1;
      };
      let o2 = n2(t2.target);
      o2 < 0 && (o2 = s2(t2.clientX + this.thumbGap, t2.clientY), o2 === i2 && (o2 = i2 - 1)), o2 < 0 && (o2 = s2(t2.clientX - this.thumbGap, t2.clientY), o2 === i2 && (o2 = i2 + 1)), o2 < 0 && (o2 = ((e3) => {
        let n3 = s2(t2.clientX - e3, t2.clientY), a2 = s2(t2.clientX + e3, t2.clientY);
        return o2 < 0 && n3 === i2 && (o2 = i2 + 1), o2 < 0 && a2 === i2 && (o2 = i2 - 1), o2;
      })(this.thumbExtraGap)), o2 === i2 ? this.centerModern() : o2 > -1 && o2 < e2.pages.length && e2.slideTo(o2);
    }
    onTransformM() {
      if ("modern" !== this.type)
        return;
      const { instance: t2, container: e2, track: i2 } = this, n2 = t2.panzoom;
      if (!(e2 && i2 && n2 && this.panzoom))
        return;
      C(e2, this.cn("isResting"), n2.state !== L.Init && n2.isResting);
      const s2 = this.thumbGap, o2 = this.thumbExtraGap, a2 = this.thumbClipWidth;
      let r2 = 0, l2 = 0, c2 = 0;
      for (const e3 of t2.slides) {
        let i3 = e3.index, n3 = e3.thumbSlideEl;
        if (!n3)
          continue;
        C(n3, this.cn("isSelected"), i3 === t2.page), l2 = 1 - Math.abs(t2.getProgress(i3)), n3.style.setProperty("--progress", l2 ? l2 + "" : "");
        const h2 = 0.5 * ((e3.thumbWidth || 0) - a2);
        r2 += s2, r2 += h2, l2 && (r2 -= l2 * (h2 + o2)), n3.style.setProperty("--shift", r2 - s2 + ""), r2 += h2, l2 && (r2 -= l2 * (h2 + o2)), r2 -= s2, 0 === i3 && (c2 = o2 * l2);
      }
      i2 && (i2.style.setProperty("--left", c2 + ""), i2.style.setProperty("--width", r2 + c2 + s2 + o2 * l2 + "")), this.shouldCenter && this.centerModern();
    }
    buildClassic() {
      const { container: t2, track: i2 } = this, n2 = this.getSlides();
      if (!t2 || !i2 || !n2)
        return;
      const s2 = new this.instance.constructor(t2, e({ track: i2, infinite: false, center: true, fill: true, dragFree: true, slidesPerPage: 1, transition: false, Dots: false, Navigation: false, Sync: {}, classes: { container: "f-thumbs", viewport: "f-thumbs__viewport", track: "f-thumbs__track", slide: "f-thumbs__slide" } }, this.option("Carousel") || {}, { Sync: { target: this.instance }, slides: n2 }));
      this.carousel = s2, this.track = i2, s2.on("ready", () => {
        this.emit("ready");
      });
    }
    buildModern() {
      if ("modern" !== this.type)
        return;
      const { container: t2, track: e2, instance: n2 } = this, s2 = this.option("thumbTpl") || "";
      if (!t2 || !e2 || !s2)
        return;
      D(t2, "is-horizontal"), this.updateModern();
      for (const t3 of n2.slides || []) {
        const n3 = document.createElement("div");
        if (D(n3, this.cn("slide")), t3.type) {
          let e3 = `for-${t3.type}`;
          ["video", "youtube", "vimeo", "html5video"].includes(t3.type) && (e3 += " for-video"), D(n3, e3);
        }
        n3.appendChild(i(this.formatThumb(t3, s2))), t3.thumbSlideEl = n3, e2.appendChild(n3), this.resizeModernSlide(t3);
      }
      const o2 = new n2.constructor.Panzoom(t2, { content: e2, lockAxis: "x", zoom: false, panOnlyZoomed: false, bounds: () => {
        let t3 = 0, e3 = 0, i2 = n2.slides[0], s3 = n2.slides[n2.slides.length - 1], o3 = n2.slides[n2.page];
        return i2 && s3 && o3 && (e3 = -1 * this.getModernThumbPos(0), 0 !== n2.page && (e3 += 0.5 * (i2.thumbWidth || 0)), t3 = -1 * this.getModernThumbPos(n2.slides.length - 1), n2.page !== n2.slides.length - 1 && (t3 += (s3.thumbWidth || 0) - (o3.thumbWidth || 0) - 0.5 * (s3.thumbWidth || 0))), { x: { min: t3, max: e3 }, y: { min: 0, max: 0 } };
      } });
      o2.on("touchStart", (t3, e3) => {
        this.shouldCenter = false;
      }), o2.on("click", (t3, e3) => this.onClickModern(e3)), o2.on("ready", () => {
        this.centerModern(), this.emit("ready");
      }), o2.on(["afterTransform", "refresh"], (t3) => {
        this.lazyLoadModern();
      }), this.panzoom = o2, this.refreshModern();
    }
    updateModern() {
      if ("modern" !== this.type)
        return;
      const { container: t2 } = this;
      t2 && (this.thumbGap = parseFloat(getComputedStyle(t2).getPropertyValue("--f-thumb-gap")) || 0, this.thumbExtraGap = parseFloat(getComputedStyle(t2).getPropertyValue("--f-thumb-extra-gap")) || 0, this.thumbWidth = parseFloat(getComputedStyle(t2).getPropertyValue("--f-thumb-width")) || 40, this.thumbClipWidth = parseFloat(getComputedStyle(t2).getPropertyValue("--f-thumb-clip-width")) || 40, this.thumbHeight = parseFloat(getComputedStyle(t2).getPropertyValue("--f-thumb-height")) || 40);
    }
    refreshModern() {
      var t2;
      if ("modern" === this.type) {
        this.updateModern();
        for (const t3 of this.instance.slides || [])
          this.resizeModernSlide(t3);
        this.onTransformM(), null === (t2 = this.panzoom) || void 0 === t2 || t2.updateMetrics(true), this.centerModern(0);
      }
    }
    centerModern(t2) {
      const e2 = this.instance, { container: i2, panzoom: n2 } = this;
      if (!i2 || !n2 || n2.state === L.Init)
        return;
      const s2 = e2.page;
      let o2 = this.getModernThumbPos(s2), a2 = o2;
      for (let t3 = e2.page - 3; t3 < e2.page + 3; t3++) {
        if (t3 < 0 || t3 > e2.pages.length - 1 || t3 === e2.page)
          continue;
        const i3 = 1 - Math.abs(e2.getProgress(t3));
        i3 > 0 && i3 < 1 && (a2 += i3 * (this.getModernThumbPos(t3) - o2));
      }
      let r2 = 100;
      void 0 === t2 && (t2 = 0.2, e2.inTransition.size > 0 && (t2 = 0.12), Math.abs(-1 * n2.current.e - a2) > n2.containerRect.width && (t2 = 0.5, r2 = 0)), n2.options.maxVelocity = r2, n2.applyChange({ panX: x(-1 * a2 - n2.target.e, 1e3), friction: null === e2.prevPage ? 0 : t2 });
    }
    lazyLoadModern() {
      const { instance: t2, panzoom: e2 } = this;
      if (!e2)
        return;
      const n2 = -1 * e2.current.e || 0;
      let s2 = this.getModernThumbPos(t2.page);
      if (e2.state !== L.Init || 0 === s2)
        for (const s3 of t2.slides || []) {
          const t3 = s3.thumbSlideEl;
          if (!t3)
            continue;
          const o2 = t3.querySelector("img[data-lazy-src]"), a2 = s3.index, r2 = this.getModernThumbPos(a2), l2 = n2 - 0.5 * e2.containerRect.innerWidth, h2 = l2 + e2.containerRect.innerWidth;
          if (!o2 || r2 < l2 || r2 > h2)
            continue;
          let d2 = o2.dataset.lazySrc;
          if (!d2 || !d2.length)
            continue;
          if (delete o2.dataset.lazySrc, o2.src = d2, o2.complete)
            continue;
          D(t3, this.cn("isLoading"));
          const u2 = i(c);
          t3.appendChild(u2), o2.addEventListener("load", () => {
            t3.offsetParent && (t3.classList.remove(this.cn("isLoading")), u2.remove());
          }, false);
        }
    }
    resizeModernSlide(t2) {
      if ("modern" !== this.type)
        return;
      if (!t2.thumbSlideEl)
        return;
      const e2 = t2.thumbClipWidth && t2.thumbHeight ? Math.round(this.thumbHeight * (t2.thumbClipWidth / t2.thumbHeight)) : this.thumbWidth;
      t2.thumbWidth = e2;
    }
    getModernThumbPos(t2) {
      const e2 = this.instance.slides[t2], i2 = this.panzoom;
      if (!i2 || !i2.contentRect.fitWidth)
        return 0;
      let n2 = i2.containerRect.innerWidth, s2 = i2.contentRect.width;
      2 === this.instance.slides.length && (t2 -= 1, s2 = 2 * this.thumbClipWidth);
      let o2 = t2 * (this.thumbClipWidth + this.thumbGap) + this.thumbExtraGap + 0.5 * (e2.thumbWidth || 0);
      return o2 -= s2 > n2 ? 0.5 * n2 : 0.5 * s2, x(o2 || 0, 1);
    }
    build() {
      const t2 = this.instance, e2 = t2.container, i2 = this.option("minCount") || 0;
      if (i2) {
        let e3 = 0;
        for (const i3 of t2.slides || [])
          i3.thumbSrc && e3++;
        if (e3 < i2)
          return this.cleanup(), void (this.state = G.Disabled);
      }
      const n2 = this.option("type");
      if (["modern", "classic"].indexOf(n2) < 0)
        return void (this.state = G.Disabled);
      this.type = n2;
      const s2 = document.createElement("div");
      D(s2, this.cn("container")), D(s2, `is-${n2}`);
      const o2 = this.option("parentEl");
      o2 ? o2.appendChild(s2) : e2.after(s2), this.container = s2, D(e2, this.cn("hasThumbs"));
      const a2 = document.createElement("div");
      D(a2, this.cn("track")), s2.appendChild(a2), this.track = a2, "classic" === n2 ? this.buildClassic() : this.buildModern(), this.state = G.Ready, s2.addEventListener("click", (e3) => {
        setTimeout(() => {
          var e4;
          null === (e4 = null == s2 ? void 0 : s2.querySelector(`[data-carousel-index="${t2.page}"]`)) || void 0 === e4 || e4.focus();
        }, 100);
      });
    }
    cleanup() {
      this.carousel && this.carousel.destroy(), this.carousel = null, this.panzoom && this.panzoom.destroy(), this.panzoom = null, this.container && this.container.remove(), this.container = null, this.track = null, this.state = G.Init, I(this.instance.container, this.cn("hasThumbs"));
    }
    attach() {
      this.instance.on("initSlide", this.onInitSlide), this.instance.on("initSlides", this.onInitSlides), this.instance.on("Panzoom.afterTransform", this.onTransformM), this.instance.on("Panzoom.refresh", this.onRefreshM), this.instance.on("change", this.onChangeM);
    }
    detach() {
      this.instance.off("initSlide", this.onInitSlide), this.instance.off("initSlides", this.onInitSlides), this.instance.off("Panzoom.afterTransform", this.onTransformM), this.instance.off("Panzoom.refresh", this.onRefreshM), this.instance.off("change", this.onChangeM), this.cleanup();
    }
  };
  Object.defineProperty(U, "defaults", { enumerable: true, configurable: true, writable: true, value: V });
  var K = Object.assign(Object.assign({}, V), { key: "t", showOnStart: true, parentEl: null });
  var J = class extends b {
    constructor() {
      super(...arguments), Object.defineProperty(this, "ref", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "hidden", { enumerable: true, configurable: true, writable: true, value: false });
    }
    get isEnabled() {
      const t2 = this.ref;
      return t2 && t2.state !== G.Disabled;
    }
    get isHidden() {
      return this.hidden;
    }
    onInit() {
      const t2 = this.instance, i2 = t2.carousel;
      if (!i2)
        return;
      const n2 = this.option("parentEl") || t2.footer || t2.container;
      n2 && (i2.options.Thumbs = e({}, this.options, { parentEl: n2, classes: { container: "f-thumbs fancybox__thumbs" }, Carousel: { Sync: { friction: t2.option("Carousel.friction") }, on: { click: (t3, e2) => {
        e2.stopPropagation();
      } } }, on: { ready: (t3) => {
        const e2 = t3.container;
        e2 && this.hidden && (this.refresh(), e2.style.transition = "none", this.hide(), e2.offsetHeight, queueMicrotask(() => {
          e2.style.transition = "", this.show();
        }));
      } } }), i2.attachPlugins({ Thumbs: U }), this.ref = i2.plugins.Thumbs, this.option("showOnStart") || (this.ref.state = G.Hidden, this.hidden = true));
    }
    onResize() {
      var t2;
      const e2 = null === (t2 = this.ref) || void 0 === t2 ? void 0 : t2.container;
      e2 && (e2.style.maxHeight = "");
    }
    onKeydown(t2, e2) {
      const i2 = this.option("key");
      i2 && i2 === e2 && this.toggle();
    }
    toggle() {
      const t2 = this.ref;
      t2 && t2.state !== G.Disabled && (t2.state !== G.Hidden ? this.hidden ? this.show() : this.hide() : t2.build());
    }
    show() {
      const t2 = this.ref, e2 = t2 && t2.state !== G.Disabled && t2.container;
      e2 && (this.refresh(), e2.offsetHeight, e2.removeAttribute("aria-hidden"), e2.classList.remove("is-hidden"), this.hidden = false);
    }
    hide() {
      const t2 = this.ref, e2 = t2 && t2.container;
      e2 && (this.refresh(), e2.offsetHeight, e2.classList.add("is-hidden"), e2.setAttribute("aria-hidden", "true")), this.hidden = true;
    }
    refresh() {
      const t2 = this.ref;
      if (!t2 || t2.state === G.Disabled)
        return;
      const e2 = t2.container, i2 = (null == e2 ? void 0 : e2.firstChild) || null;
      e2 && i2 && i2.childNodes.length && (e2.style.maxHeight = `${i2.getBoundingClientRect().height}px`);
    }
    attach() {
      this.instance.on("Carousel.init", this.onInit), this.instance.on("resize", this.onResize), this.instance.on("keydown", this.onKeydown);
    }
    detach() {
      this.instance.off("Carousel.init", this.onInit), this.instance.off("resize", this.onResize), this.instance.off("keydown", this.onKeydown);
    }
  };
  Object.defineProperty(J, "defaults", { enumerable: true, configurable: true, writable: true, value: K });
  var Q = { panLeft: { icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>', change: { panX: -100 } }, panRight: { icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>', change: { panX: 100 } }, panUp: { icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>', change: { panY: -100 } }, panDown: { icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>', change: { panY: 100 } }, zoomIn: { icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>', action: "zoomIn" }, zoomOut: { icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>', action: "zoomOut" }, toggle1to1: { icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>', action: "toggleZoom" }, toggleZoom: { icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>', action: "toggleZoom" }, iterateZoom: { icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>', action: "iterateZoom" }, rotateCCW: { icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>', action: "rotateCCW" }, rotateCW: { icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>', action: "rotateCW" }, flipX: { icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>', action: "flipX" }, flipY: { icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>', action: "flipY" }, fitX: { icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>', action: "fitX" }, fitY: { icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>', action: "fitY" }, reset: { icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>', action: "reset" }, toggleFS: { icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>', action: "toggleFS" } };
  var tt;
  !function(t2) {
    t2[t2.Init = 0] = "Init", t2[t2.Ready = 1] = "Ready", t2[t2.Disabled = 2] = "Disabled";
  }(tt || (tt = {}));
  var et = { absolute: "auto", display: { left: ["infobar"], middle: [], right: ["iterateZoom", "slideshow", "fullscreen", "thumbs", "close"] }, enabled: "auto", items: { infobar: { tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>' }, download: { tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>' }, prev: { tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>' }, next: { tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>' }, slideshow: { tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>' }, fullscreen: { tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>' }, thumbs: { tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>' }, close: { tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>' } }, parentEl: null };
  var it = { tabindex: "-1", width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" };
  var nt = class extends b {
    constructor() {
      super(...arguments), Object.defineProperty(this, "state", { enumerable: true, configurable: true, writable: true, value: tt.Init }), Object.defineProperty(this, "container", { enumerable: true, configurable: true, writable: true, value: null });
    }
    onReady(t2) {
      var e2;
      if (!t2.carousel)
        return;
      let i2 = this.option("display"), n2 = this.option("absolute"), s2 = this.option("enabled");
      if ("auto" === s2) {
        const t3 = this.instance.carousel;
        let e3 = 0;
        if (t3)
          for (const i3 of t3.slides)
            (i3.panzoom || "image" === i3.type) && e3++;
        e3 || (s2 = false);
      }
      s2 || (i2 = void 0);
      let o2 = 0;
      const a2 = { left: [], middle: [], right: [] };
      if (i2)
        for (const t3 of ["left", "middle", "right"])
          for (const n3 of i2[t3]) {
            const i3 = this.createEl(n3);
            i3 && (null === (e2 = a2[t3]) || void 0 === e2 || e2.push(i3), o2++);
          }
      let r2 = null;
      if (o2 && (r2 = this.createContainer()), r2) {
        for (const [t3, e3] of Object.entries(a2)) {
          const i3 = document.createElement("div");
          D(i3, "fancybox__toolbar__column is-" + t3);
          for (const t4 of e3)
            i3.appendChild(t4);
          "auto" !== n2 || "middle" !== t3 || e3.length || (n2 = true), r2.appendChild(i3);
        }
        true === n2 && D(r2, "is-absolute"), this.state = tt.Ready, this.onRefresh();
      } else
        this.state = tt.Disabled;
    }
    onClick(t2) {
      var e2, i2;
      const s2 = this.instance, o2 = s2.getSlide(), a2 = null == o2 ? void 0 : o2.panzoom, r2 = t2.target, l2 = r2 && n(r2) ? r2.dataset : null;
      if (!l2)
        return;
      if (void 0 !== l2.fancyboxToggleThumbs)
        return t2.preventDefault(), t2.stopPropagation(), void (null === (e2 = s2.plugins.Thumbs) || void 0 === e2 || e2.toggle());
      if (void 0 !== l2.fancyboxToggleFullscreen)
        return t2.preventDefault(), t2.stopPropagation(), void this.instance.toggleFullscreen();
      if (void 0 !== l2.fancyboxToggleSlideshow) {
        t2.preventDefault(), t2.stopPropagation();
        const e3 = null === (i2 = s2.carousel) || void 0 === i2 ? void 0 : i2.plugins.Autoplay;
        let n2 = e3.isActive;
        return a2 && "mousemove" === a2.panMode && !n2 && a2.reset(), void (n2 ? e3.stop() : e3.start());
      }
      const c2 = l2.panzoomAction, h2 = l2.panzoomChange;
      if ((h2 || c2) && (t2.preventDefault(), t2.stopPropagation()), h2) {
        let t3 = {};
        try {
          t3 = JSON.parse(h2);
        } catch (t4) {
        }
        a2 && a2.applyChange(t3);
      } else
        c2 && a2 && a2[c2] && a2[c2]();
    }
    onChange() {
      this.onRefresh();
    }
    onRefresh() {
      if (this.instance.isClosing())
        return;
      const t2 = this.container;
      if (!t2)
        return;
      const e2 = this.instance.getSlide();
      if (!e2 || e2.state !== p.Ready)
        return;
      const i2 = e2 && !e2.error && e2.panzoom;
      for (const e3 of t2.querySelectorAll("[data-panzoom-action]"))
        i2 ? (e3.removeAttribute("disabled"), e3.removeAttribute("tabindex")) : (e3.setAttribute("disabled", ""), e3.setAttribute("tabindex", "-1"));
      let n2 = i2 && i2.canZoomIn(), s2 = i2 && i2.canZoomOut();
      for (const e3 of t2.querySelectorAll('[data-panzoom-action="zoomIn"]'))
        n2 ? (e3.removeAttribute("disabled"), e3.removeAttribute("tabindex")) : (e3.setAttribute("disabled", ""), e3.setAttribute("tabindex", "-1"));
      for (const e3 of t2.querySelectorAll('[data-panzoom-action="zoomOut"]'))
        s2 ? (e3.removeAttribute("disabled"), e3.removeAttribute("tabindex")) : (e3.setAttribute("disabled", ""), e3.setAttribute("tabindex", "-1"));
      for (const e3 of t2.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')) {
        s2 || n2 ? (e3.removeAttribute("disabled"), e3.removeAttribute("tabindex")) : (e3.setAttribute("disabled", ""), e3.setAttribute("tabindex", "-1"));
        const t3 = e3.querySelector("g");
        t3 && (t3.style.display = n2 ? "" : "none");
      }
    }
    onDone(t2, e2) {
      var i2;
      null === (i2 = e2.panzoom) || void 0 === i2 || i2.on("afterTransform", () => {
        this.instance.isCurrentSlide(e2) && this.onRefresh();
      }), this.instance.isCurrentSlide(e2) && this.onRefresh();
    }
    createContainer() {
      const t2 = this.instance.container;
      if (!t2)
        return null;
      const e2 = this.option("parentEl") || t2, i2 = document.createElement("div");
      return D(i2, "fancybox__toolbar"), e2.prepend(i2), i2.addEventListener("click", this.onClick, { passive: false, capture: true }), t2 && D(t2, "has-toolbar"), this.container = i2, i2;
    }
    createEl(t2) {
      var e2;
      const n2 = this.instance.carousel;
      if (!n2)
        return null;
      if ("toggleFS" === t2)
        return null;
      if ("fullscreen" === t2 && !this.instance.fsAPI)
        return null;
      let s2 = null;
      const o2 = n2.slides.length || 0;
      let a2 = 0, r2 = 0;
      for (const t3 of n2.slides)
        (t3.panzoom || "image" === t3.type) && a2++, ("image" === t3.type || t3.downloadSrc) && r2++;
      if (o2 < 2 && ["infobar", "prev", "next"].includes(t2))
        return s2;
      if (void 0 !== Q[t2] && !a2)
        return null;
      if ("download" === t2 && !r2)
        return null;
      if ("thumbs" === t2) {
        const t3 = this.instance.plugins.Thumbs;
        if (!t3 || !t3.isEnabled)
          return null;
      }
      if ("slideshow" === t2) {
        if (!(null === (e2 = this.instance.carousel) || void 0 === e2 ? void 0 : e2.plugins.Autoplay) || o2 < 2)
          return null;
      }
      if (void 0 !== Q[t2]) {
        const e3 = Q[t2];
        s2 = document.createElement("button"), s2.setAttribute("title", this.instance.localize(`{{${t2.toUpperCase()}}}`)), D(s2, "f-button"), e3.action && (s2.dataset.panzoomAction = e3.action), e3.change && (s2.dataset.panzoomChange = JSON.stringify(e3.change)), s2.appendChild(i(this.instance.localize(e3.icon)));
      } else {
        const e3 = (this.option("items") || [])[t2];
        e3 && (s2 = i(this.instance.localize(e3.tpl)), "function" == typeof e3.click && s2.addEventListener("click", (t3) => {
          t3.preventDefault(), t3.stopPropagation(), "function" == typeof e3.click && e3.click.call(this, this, t3);
        }));
      }
      const l2 = null == s2 ? void 0 : s2.querySelector("svg");
      if (l2)
        for (const [t3, e3] of Object.entries(it))
          l2.getAttribute(t3) || l2.setAttribute(t3, String(e3));
      return s2;
    }
    removeContainer() {
      var t2;
      const e2 = this.container;
      e2 && e2.removeEventListener("click", this.onClick, { passive: false, capture: true }), null === (t2 = this.container) || void 0 === t2 || t2.remove(), this.container = null, this.state = tt.Disabled;
      const i2 = this.instance.container;
      i2 && I(i2, "has-toolbar");
    }
    attach() {
      this.instance.on("Carousel.initSlides", this.onReady), this.instance.on("done", this.onDone), this.instance.on("reveal", this.onChange), this.instance.on("Carousel.change", this.onChange), this.onReady(this.instance);
    }
    detach() {
      this.instance.off("Carousel.initSlides", this.onReady), this.instance.off("done", this.onDone), this.instance.off("reveal", this.onChange), this.instance.off("Carousel.change", this.onChange), this.removeContainer();
    }
  };
  Object.defineProperty(nt, "defaults", { enumerable: true, configurable: true, writable: true, value: et });
  var st = { Hash: y, Html: Y, Images: N, Slideshow: Z, Thumbs: J, Toolbar: nt };
  var ot = function(t2, e2) {
    let i2 = true;
    return (...n2) => {
      i2 && (i2 = false, t2(...n2), setTimeout(() => {
        i2 = true;
      }, e2));
    };
  };
  var at = (t2, e2) => {
    let i2 = [];
    return t2.childNodes.forEach((t3) => {
      t3.nodeType !== Node.ELEMENT_NODE || e2 && !t3.matches(e2) || i2.push(t3);
    }), i2;
  };
  var rt = { viewport: null, track: null, enabled: true, slides: [], axis: "x", transition: "fade", preload: 1, slidesPerPage: "auto", initialPage: 0, friction: 0.12, Panzoom: { decelFriction: 0.12 }, center: true, infinite: true, fill: true, dragFree: false, adaptiveHeight: false, direction: "ltr", classes: { container: "f-carousel", viewport: "f-carousel__viewport", track: "f-carousel__track", slide: "f-carousel__slide", isLTR: "is-ltr", isRTL: "is-rtl", isHorizontal: "is-horizontal", isVertical: "is-vertical", inTransition: "in-transition", isSelected: "is-selected" }, l10n: { NEXT: "Next slide", PREV: "Previous slide", GOTO: "Go to slide #%d" } };
  var lt;
  !function(t2) {
    t2[t2.Init = 0] = "Init", t2[t2.Ready = 1] = "Ready", t2[t2.Destroy = 2] = "Destroy";
  }(lt || (lt = {}));
  var ct = (t2) => {
    if ("string" == typeof t2 && (t2 = { html: t2 }), !(t2 instanceof String || t2 instanceof HTMLElement)) {
      const e2 = t2.thumb;
      void 0 !== e2 && ("string" == typeof e2 && (t2.thumbSrc = e2), e2 instanceof HTMLImageElement && (t2.thumbEl = e2, t2.thumbElSrc = e2.src, t2.thumbSrc = e2.src), delete t2.thumb);
    }
    return Object.assign({ html: "", el: null, isDom: false, class: "", index: -1, dim: 0, gap: 0, pos: 0, transition: false }, t2);
  };
  var ht = (t2 = {}) => Object.assign({ index: -1, slides: [], dim: 0, pos: -1 }, t2);
  var dt = { classes: { list: "f-carousel__dots", isDynamic: "is-dynamic", hasDots: "has-dots", dot: "f-carousel__dot", isBeforePrev: "is-before-prev", isPrev: "is-prev", isCurrent: "is-current", isNext: "is-next", isAfterNext: "is-after-next" }, dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>', dynamicFrom: 11, maxCount: 1 / 0, minCount: 2 };
  var ut = class extends b {
    constructor() {
      super(...arguments), Object.defineProperty(this, "isDynamic", { enumerable: true, configurable: true, writable: true, value: false }), Object.defineProperty(this, "list", { enumerable: true, configurable: true, writable: true, value: null });
    }
    onRefresh() {
      this.refresh();
    }
    build() {
      let t2 = this.list;
      return t2 || (t2 = document.createElement("ul"), D(t2, this.cn("list")), t2.setAttribute("role", "tablist"), this.instance.container.appendChild(t2), D(this.instance.container, this.cn("hasDots")), this.list = t2), t2;
    }
    refresh() {
      var t2;
      const e2 = this.instance.pages.length, i2 = Math.min(2, this.option("minCount")), n2 = Math.max(2e3, this.option("maxCount")), s2 = this.option("dynamicFrom");
      if (e2 < i2 || e2 > n2)
        return void this.cleanup();
      const o2 = "number" == typeof s2 && e2 > 5 && e2 >= s2, a2 = !this.list || this.isDynamic !== o2 || this.list.children.length !== e2;
      a2 && this.cleanup();
      const r2 = this.build();
      if (C(r2, this.cn("isDynamic"), !!o2), a2)
        for (let t3 = 0; t3 < e2; t3++)
          r2.append(this.createItem(t3));
      let l2, c2 = 0;
      for (const e3 of [...r2.children]) {
        const i3 = c2 === this.instance.page;
        i3 && (l2 = e3), C(e3, this.cn("isCurrent"), i3), null === (t2 = e3.children[0]) || void 0 === t2 || t2.setAttribute("aria-selected", i3 ? "true" : "false");
        for (const t3 of ["isBeforePrev", "isPrev", "isNext", "isAfterNext"])
          I(e3, this.cn(t3));
        c2++;
      }
      if (l2 = l2 || r2.firstChild, o2 && l2) {
        const t3 = l2.previousElementSibling, e3 = t3 && t3.previousElementSibling;
        D(t3, this.cn("isPrev")), D(e3, this.cn("isBeforePrev"));
        const i3 = l2.nextElementSibling, n3 = i3 && i3.nextElementSibling;
        D(i3, this.cn("isNext")), D(n3, this.cn("isAfterNext"));
      }
      this.isDynamic = o2;
    }
    createItem(t2 = 0) {
      var e2;
      const n2 = document.createElement("li");
      n2.setAttribute("role", "presentation");
      const s2 = i(this.instance.localize(this.option("dotTpl"), [["%d", t2 + 1]]).replace(/\%i/g, t2 + ""));
      return n2.appendChild(s2), null === (e2 = n2.children[0]) || void 0 === e2 || e2.setAttribute("role", "tab"), n2;
    }
    cleanup() {
      this.list && (this.list.remove(), this.list = null), this.isDynamic = false, I(this.instance.container, this.cn("hasDots"));
    }
    attach() {
      this.instance.on(["refresh", "change"], this.onRefresh);
    }
    detach() {
      this.instance.off(["refresh", "change"], this.onRefresh), this.cleanup();
    }
  };
  Object.defineProperty(ut, "defaults", { enumerable: true, configurable: true, writable: true, value: dt });
  var pt = class extends b {
    constructor() {
      super(...arguments), Object.defineProperty(this, "container", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "prev", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "next", { enumerable: true, configurable: true, writable: true, value: null });
    }
    onRefresh() {
      const t2 = this.instance, e2 = t2.pages.length, i2 = t2.page;
      if (e2 < 2)
        return void this.cleanup();
      this.build();
      let n2 = this.prev, s2 = this.next;
      n2 && s2 && (n2.removeAttribute("disabled"), s2.removeAttribute("disabled"), t2.isInfinite || (i2 <= 0 && n2.setAttribute("disabled", ""), i2 >= e2 - 1 && s2.setAttribute("disabled", "")));
    }
    createButton(t2) {
      const e2 = this.instance, i2 = document.createElement("button");
      i2.setAttribute("tabindex", "0"), i2.setAttribute("title", e2.localize(`{{${t2.toUpperCase()}}}`)), D(i2, this.cn("button") + " " + this.cn("next" === t2 ? "isNext" : "isPrev"));
      const n2 = e2.isRTL ? "next" === t2 ? "prev" : "next" : t2;
      var s2;
      return i2.innerHTML = e2.localize(this.option(`${n2}Tpl`)), i2.dataset[`carousel${s2 = t2, s2 ? s2.match("^[a-z]") ? s2.charAt(0).toUpperCase() + s2.substring(1) : s2 : ""}`] = "true", i2;
    }
    build() {
      let t2 = this.container;
      t2 || (this.container = t2 = document.createElement("div"), D(t2, this.cn("container")), this.instance.container.appendChild(t2)), this.next || (this.next = t2.appendChild(this.createButton("next"))), this.prev || (this.prev = t2.appendChild(this.createButton("prev")));
    }
    cleanup() {
      this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove(), this.prev = null, this.next = null, this.container = null;
    }
    attach() {
      this.instance.on(["refresh", "change"], this.onRefresh);
    }
    detach() {
      this.instance.off(["refresh", "change"], this.onRefresh), this.cleanup();
    }
  };
  Object.defineProperty(pt, "defaults", { enumerable: true, configurable: true, writable: true, value: { classes: { container: "f-carousel__nav", button: "f-button", isNext: "is-next", isPrev: "is-prev" }, nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>', prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>' } });
  var mt = class extends b {
    constructor() {
      super(...arguments), Object.defineProperty(this, "selectedIndex", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "target", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "nav", { enumerable: true, configurable: true, writable: true, value: null });
    }
    addAsTargetFor(t2) {
      this.target = this.instance, this.nav = t2, this.attachEvents();
    }
    addAsNavFor(t2) {
      this.nav = this.instance, this.target = t2, this.attachEvents();
    }
    attachEvents() {
      this.nav && this.target && (this.nav.options.initialSlide = this.target.options.initialPage, this.nav.on("ready", this.onNavReady), this.nav.state === lt.Ready && this.onNavReady(this.nav), this.target.on("ready", this.onTargetReady), this.target.state === lt.Ready && this.onTargetReady(this.target));
    }
    onNavReady(t2) {
      t2.on("createSlide", this.onNavCreateSlide), t2.on("Panzoom.click", this.onNavClick), t2.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t2) {
      t2.on("change", this.onTargetChange), t2.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t2, e2, i2) {
      i2.pointerType || this.onNavTouch(t2, t2.panzoom, i2);
    }
    onNavTouch(t2, e2, i2) {
      var n2, s2;
      if (Math.abs(e2.dragOffset.x) > 3 || Math.abs(e2.dragOffset.y) > 3)
        return;
      const o2 = i2.target, { nav: a2, target: r2 } = this;
      if (!a2 || !r2 || !o2)
        return;
      const l2 = o2.closest("[data-index]");
      if (i2.stopPropagation(), i2.preventDefault(), !l2)
        return;
      const c2 = parseInt(l2.dataset.index || "", 10) || 0, h2 = r2.getPageForSlide(c2), d2 = a2.getPageForSlide(c2);
      a2.slideTo(d2), r2.slideTo(h2, { friction: null === (s2 = null === (n2 = this.nav) || void 0 === n2 ? void 0 : n2.plugins) || void 0 === s2 ? void 0 : s2.Sync.option("friction") }), this.markSelectedSlide(c2);
    }
    onNavCreateSlide(t2, e2) {
      e2.index === this.selectedIndex && this.markSelectedSlide(e2.index);
    }
    onTargetChange() {
      const { target: t2, nav: e2 } = this;
      if (!t2 || !e2)
        return;
      if (e2.state !== lt.Ready || t2.state !== lt.Ready)
        return;
      const i2 = t2.pages[t2.page].slides[0].index, n2 = e2.getPageForSlide(i2);
      this.markSelectedSlide(i2), e2.slideTo(n2);
    }
    markSelectedSlide(t2) {
      const { nav: e2 } = this;
      e2 && e2.state === lt.Ready && (this.selectedIndex = t2, [...e2.slides].map((e3) => {
        e3.el && e3.el.classList[e3.index === t2 ? "add" : "remove"]("is-nav-selected");
      }));
    }
    attach() {
      let t2 = this.options.target, e2 = this.options.nav;
      t2 ? this.addAsNavFor(t2) : e2 && this.addAsTargetFor(e2);
    }
    detach() {
      this.nav && (this.nav.off("ready", this.onNavReady), this.nav.off("createSlide", this.onNavCreateSlide), this.nav.off("Panzoom.click", this.onNavClick), this.nav.off("Panzoom.touchEnd", this.onNavTouch)), this.nav = null, this.target && (this.target.off("ready", this.onTargetReady), this.target.off("refresh", this.onTargetChange), this.target.off("change", this.onTargetChange)), this.target = null;
    }
  };
  Object.defineProperty(mt, "defaults", { enumerable: true, configurable: true, writable: true, value: { friction: 0.35 } });
  var ft = { Navigation: pt, Dots: ut, Sync: mt };
  var gt = class extends g {
    get axis() {
      return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
      return this.state === lt.Ready;
    }
    get isInfinite() {
      let t2 = false;
      const e2 = this.contentDim, i2 = this.viewportDim;
      return this.pages.length >= 2 && e2 > 1.5 * i2 && (t2 = this.option("infinite")), t2;
    }
    get isRTL() {
      return "rtl" === this.option("direction");
    }
    get isHorizontal() {
      return "x" === this.option("axis");
    }
    constructor(t2, e2 = {}, i2 = {}) {
      if (super(), Object.defineProperty(this, "userOptions", { enumerable: true, configurable: true, writable: true, value: {} }), Object.defineProperty(this, "userPlugins", { enumerable: true, configurable: true, writable: true, value: {} }), Object.defineProperty(this, "bp", { enumerable: true, configurable: true, writable: true, value: "" }), Object.defineProperty(this, "state", { enumerable: true, configurable: true, writable: true, value: lt.Init }), Object.defineProperty(this, "page", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "prevPage", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "container", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "viewport", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "track", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "slides", { enumerable: true, configurable: true, writable: true, value: [] }), Object.defineProperty(this, "pages", { enumerable: true, configurable: true, writable: true, value: [] }), Object.defineProperty(this, "panzoom", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "inTransition", { enumerable: true, configurable: true, writable: true, value: /* @__PURE__ */ new Set() }), Object.defineProperty(this, "contentDim", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "viewportDim", { enumerable: true, configurable: true, writable: true, value: 0 }), "string" == typeof t2 && (t2 = document.querySelector(t2)), !t2 || !n(t2))
        throw new Error("No Element found");
      this.container = t2, this.slideNext = ot(this.slideNext.bind(this), 150), this.slidePrev = ot(this.slidePrev.bind(this), 150), this.userOptions = e2, this.userPlugins = i2, queueMicrotask(() => {
        this.processOptions();
      });
    }
    processOptions() {
      const i2 = e({}, gt.defaults, this.userOptions);
      let n2 = "";
      const s2 = i2.breakpoints;
      if (s2 && t(s2))
        for (const [o2, a2] of Object.entries(s2))
          window.matchMedia(o2).matches && t(a2) && (n2 += o2, e(i2, a2));
      n2 === this.bp && this.state !== lt.Init || (this.bp = n2, this.state === lt.Ready && (i2.initialSlide = this.pages[this.page].slides[0].index), this.state !== lt.Init && this.destroy(), super.setOptions(i2), false === this.option("enabled") ? this.attachEvents() : setTimeout(() => {
        this.init();
      }, 0));
    }
    init() {
      this.state = lt.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, gt.Plugins), this.userPlugins)), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = lt.Ready, this.emit("ready");
    }
    initLayout() {
      const { container: t2 } = this, e2 = this.option("classes");
      D(t2, this.cn("container")), C(t2, e2.isLTR, !this.isRTL), C(t2, e2.isRTL, this.isRTL), C(t2, e2.isVertical, !this.isHorizontal), C(t2, e2.isHorizontal, this.isHorizontal);
      let i2 = this.option("viewport") || t2.querySelector(`.${e2.viewport}`);
      i2 || (i2 = document.createElement("div"), D(i2, e2.viewport), i2.append(...at(t2, `.${e2.slide}`)), t2.prepend(i2));
      let n2 = this.option("track") || t2.querySelector(`.${e2.track}`);
      n2 || (n2 = document.createElement("div"), D(n2, e2.track), n2.append(...Array.from(i2.childNodes))), n2.setAttribute("aria-live", "polite"), i2.contains(n2) || i2.prepend(n2), this.viewport = i2, this.track = n2, this.emit("initLayout");
    }
    initSlides() {
      const { track: t2 } = this;
      if (t2) {
        this.slides = [], [...at(t2, `.${this.cn("slide")}`)].forEach((t3) => {
          if (n(t3)) {
            const e2 = ct({ el: t3, isDom: true, index: this.slides.length });
            this.slides.push(e2), this.emit("initSlide", e2, this.slides.length);
          }
        });
        for (let t3 of this.option("slides", [])) {
          const e2 = ct(t3);
          e2.index = this.slides.length, this.slides.push(e2), this.emit("initSlide", e2, this.slides.length);
        }
        this.emit("initSlides");
      }
    }
    setInitialPage() {
      let t2 = 0;
      const e2 = this.option("initialSlide");
      t2 = "number" == typeof e2 ? this.getPageForSlide(e2) : parseInt(this.option("initialPage", 0) + "", 10) || 0, this.page = t2;
    }
    setInitialPosition() {
      if (!this.track || !this.pages.length)
        return;
      const t2 = this.isHorizontal;
      let e2 = this.page;
      this.pages[e2] || (this.page = e2 = 0);
      const i2 = this.pages[e2].pos * (this.isRTL && t2 ? 1 : -1), n2 = t2 ? `${i2}px` : "0", s2 = t2 ? "0" : `${i2}px`;
      this.track.style.transform = `translate3d(${n2}, ${s2}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
      this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
      const t2 = this.option("Panzoom") || {};
      this.panzoom = new B(this.viewport, e({}, { content: this.track, zoom: false, panOnlyZoomed: false, lockAxis: this.isHorizontal ? "x" : "y", infinite: this.isInfinite, click: false, dblClick: false, touch: (t3) => !(this.pages.length < 2 && !t3.options.infinite), bounds: () => this.getBounds(), maxVelocity: (t3) => Math.abs(t3.target[this.axis] - t3.current[this.axis]) < 2 * this.viewportDim ? 100 : 0 }, t2)), this.panzoom.on("*", (t3, e2, ...i2) => {
        this.emit(`Panzoom.${e2}`, t3, ...i2);
      }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
      const t2 = this.container;
      t2 && (t2.addEventListener("click", this.onClick, { passive: false, capture: false }), t2.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
      let t2 = [];
      const { contentDim: e2, viewportDim: i2 } = this, n2 = this.option("slidesPerPage");
      if ("number" == typeof n2 && e2 > i2) {
        for (let e3 = 0; e3 < this.slides.length; e3 += n2)
          t2.push(ht({ index: e3, slides: this.slides.slice(e3, e3 + n2) }));
        return t2;
      }
      let s2 = 0, o2 = 0;
      for (const e3 of this.slides)
        (!t2.length || o2 + e3.dim > i2) && (t2.push(ht()), s2 = t2.length - 1, o2 = 0), o2 += e3.dim + e3.gap, t2[s2].slides.push(e3);
      return t2;
    }
    processPages() {
      const t2 = this.pages, { contentDim: e2, viewportDim: i2 } = this, n2 = this.option("center"), s2 = this.option("fill"), o2 = s2 && n2 && e2 > i2 && !this.isInfinite;
      if (t2.forEach((t3, s3) => {
        t3.index = s3, t3.pos = t3.slides[0].pos, t3.dim = 0;
        for (const [e3, i3] of t3.slides.entries())
          t3.dim += i3.dim, e3 < t3.slides.length - 1 && (t3.dim += i3.gap);
        o2 && t3.pos + 0.5 * t3.dim < 0.5 * i2 ? t3.pos = 0 : o2 && t3.pos + 0.5 * t3.dim >= e2 - 0.5 * i2 ? t3.pos = e2 - i2 : n2 && (t3.pos += -0.5 * (i2 - t3.dim));
      }), t2.forEach((t3, n3) => {
        s2 && !this.isInfinite && e2 > i2 && (t3.pos = Math.max(t3.pos, 0), t3.pos = Math.min(t3.pos, e2 - i2)), t3.pos = x(t3.pos, 1e3), t3.dim = x(t3.dim, 1e3), t3.pos < 0.1 && t3.pos > -0.1 && (t3.pos = 0);
      }), this.isInfinite)
        return t2;
      const a2 = [];
      let r2;
      return t2.forEach((t3) => {
        const e3 = Object.assign({}, t3);
        r2 && e3.pos === r2.pos ? (r2.dim += e3.dim, r2.slides = [...r2.slides, ...e3.slides]) : (e3.index = a2.length, r2 = e3, a2.push(e3));
      }), a2;
    }
    getPageFromIndex(t2 = 0) {
      const e2 = this.pages.length;
      let i2;
      return t2 = parseInt((t2 || 0).toString()) || 0, i2 = this.isInfinite ? (t2 % e2 + e2) % e2 : Math.max(Math.min(t2, this.pages.length - 1), 0), i2;
    }
    getSlideMetrics(t2) {
      const e2 = this.isHorizontal ? "width" : "height";
      let i2 = 0, n2 = 0, s2 = t2.el;
      s2 ? i2 = parseFloat(s2.dataset[e2] || "") || 0 : (s2 = document.createElement("div"), s2.style.visibility = "hidden", D(s2, this.cn("slide") + " " + t2.class), (this.track || document.body).prepend(s2)), i2 ? (s2.style[e2] = `${i2}px`, s2.style["width" === e2 ? "height" : "width"] = "") : i2 = s2.getBoundingClientRect()[e2];
      const o2 = getComputedStyle(s2);
      return "content-box" === o2.boxSizing && (this.isHorizontal ? (i2 += parseFloat(o2.paddingLeft) || 0, i2 += parseFloat(o2.paddingRight) || 0) : (i2 += parseFloat(o2.paddingTop) || 0, i2 += parseFloat(o2.paddingBottom) || 0)), n2 = parseFloat(o2[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, this.isHorizontal, t2.el || s2.remove(), { dim: x(i2, 1e3), gap: x(n2, 1e3) };
    }
    getBounds() {
      let t2 = { min: 0, max: 0 };
      if (this.isInfinite)
        t2 = { min: -1 / 0, max: 1 / 0 };
      else if (this.pages.length) {
        const e2 = this.pages[0].pos, i2 = this.pages[this.pages.length - 1].pos;
        t2 = this.isRTL && this.isHorizontal ? { min: e2, max: i2 } : { min: -1 * i2, max: -1 * e2 };
      }
      return { x: this.isHorizontal ? t2 : { min: 0, max: 0 }, y: this.isHorizontal ? { min: 0, max: 0 } : t2 };
    }
    repositionSlides() {
      const { viewportDim: t2, contentDim: e2, page: i2, pages: n2 } = this;
      let s2, o2 = 0, a2 = 0, r2 = 0, l2 = 0;
      this.panzoom ? l2 = -1 * this.panzoom.current[this.isHorizontal ? "e" : "f"] : n2[i2] && (l2 = n2[i2].pos || 0), s2 = this.isHorizontal ? this.isRTL ? "right" : "left" : "top", this.isRTL && this.isHorizontal && (l2 *= -1);
      for (const t3 of this.slides)
        t3.el ? ("top" === s2 ? (t3.el.style.right = "", t3.el.style.left = "") : t3.el.style.top = "", t3.index !== o2 ? t3.el.style[s2] = 0 === a2 ? "" : `${x(a2, 1e3)}px` : t3.el.style[s2] = "", r2 += t3.dim + t3.gap, o2++) : a2 += t3.dim + t3.gap;
      if (this.isInfinite && r2)
        for (const i3 of this.slides)
          i3.el && (x(i3.pos) < x(t2) && x(i3.pos + i3.dim + i3.gap) < x(l2) && x(l2) > x(e2 - t2) && (i3.el.style[s2] = `${x(a2 + r2, 1e3)}px`), x(i3.pos + i3.gap) >= x(e2 - t2) && x(i3.pos) > x(l2 + t2) && x(l2) < x(t2) && (i3.el.style[s2] = `-${x(r2, 1e3)}px`));
      let c2, h2, d2 = [...this.inTransition];
      if (d2.length > 1 && (c2 = this.pages[d2[0]], h2 = this.pages[d2[1]]), c2 && h2) {
        let t3 = 0;
        for (const e3 of this.slides)
          e3.el ? this.inTransition.has(e3.index) && c2.slides.indexOf(e3) < 0 && (e3.el.style[s2] = `${x(t3 + (c2.pos - h2.pos), 1e3)}px`) : t3 += e3.dim + e3.gap;
      }
    }
    createSlideEl(t2) {
      if (!this.track || !t2)
        return;
      if (t2.el)
        return;
      const e2 = document.createElement("div");
      D(e2, this.cn("slide")), D(e2, t2.class), D(e2, t2.customClass), t2.html && (e2.innerHTML = t2.html);
      const i2 = [];
      this.slides.forEach((t3, e3) => {
        t3.el && i2.push(e3);
      });
      const n2 = t2.index;
      let s2 = null;
      if (i2.length) {
        let t3 = i2.reduce((t4, e3) => Math.abs(e3 - n2) < Math.abs(t4 - n2) ? e3 : t4);
        s2 = this.slides[t3];
      }
      const o2 = s2 && s2.el ? s2.index < t2.index ? s2.el.nextSibling : s2.el : null;
      this.track.insertBefore(e2, this.track.contains(o2) ? o2 : null), t2.el = e2, this.emit("createSlide", t2);
    }
    removeSlideEl(t2, e2 = false) {
      const i2 = t2.el;
      if (!i2)
        return;
      if (I(i2, this.cn("isSelected")), t2.isDom && !e2)
        return i2.removeAttribute("aria-hidden"), i2.removeAttribute("data-index"), I(i2, this.cn("isSelected")), void (i2.style.left = "");
      this.emit("removeSlide", t2);
      const n2 = new CustomEvent("animationend");
      i2.dispatchEvent(n2), t2.el && t2.el.remove(), t2.el = null;
    }
    transitionTo(t2 = 0, e2 = this.option("transition")) {
      if (!e2)
        return false;
      const { pages: i2, panzoom: n2 } = this;
      t2 = parseInt((t2 || 0).toString()) || 0;
      const s2 = this.getPageFromIndex(t2);
      if (!n2 || !i2[s2] || i2.length < 2 || i2[this.page].slides[0].dim < this.viewportDim)
        return false;
      const o2 = t2 > this.page ? 1 : -1, a2 = this.pages[s2].pos * (this.isRTL ? 1 : -1);
      if (this.page === s2 && x(a2, 1e3) === x(n2.target[this.axis], 1e3))
        return false;
      this.clearTransitions();
      const r2 = n2.isResting;
      D(this.container, this.cn("inTransition"));
      const l2 = this.pages[this.page].slides[0], c2 = this.pages[s2].slides[0];
      this.inTransition.add(c2.index), this.createSlideEl(c2);
      let h2 = l2.el, d2 = c2.el;
      r2 || "slide" === e2 || (e2 = "fadeFast", h2 = null);
      const u2 = this.isRTL ? "next" : "prev", p2 = this.isRTL ? "prev" : "next";
      return h2 && (this.inTransition.add(l2.index), l2.transition = e2, h2.addEventListener("animationend", this.onAnimationEnd), h2.classList.add(`f-${e2}Out`, `to-${o2 > 0 ? p2 : u2}`)), d2 && (c2.transition = e2, d2.addEventListener("animationend", this.onAnimationEnd), d2.classList.add(`f-${e2}In`, `from-${o2 > 0 ? u2 : p2}`)), n2.panTo({ x: this.isHorizontal ? a2 : 0, y: this.isHorizontal ? 0 : a2, friction: 0 }), this.onChange(s2), true;
    }
    manageSlideVisiblity() {
      const t2 = /* @__PURE__ */ new Set(), e2 = /* @__PURE__ */ new Set(), i2 = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
      for (const n2 of this.slides)
        i2.has(n2) ? t2.add(n2) : e2.add(n2);
      for (const e3 of this.inTransition)
        t2.add(this.slides[e3]);
      for (const e3 of t2)
        this.createSlideEl(e3), this.lazyLoadSlide(e3);
      for (const i3 of e2)
        t2.has(i3) || this.removeSlideEl(i3);
      this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
      if (!this.pages[this.page] || !this.pages[this.page].slides)
        return;
      const t2 = "aria-hidden";
      let e2 = this.cn("isSelected");
      if (e2)
        for (const i2 of this.slides)
          i2.el && (i2.el.dataset.index = `${i2.index}`, this.pages[this.page].slides.includes(i2) ? (i2.el.classList.contains(e2) || (D(i2.el, e2), this.emit("selectSlide", i2)), i2.el.removeAttribute(t2)) : (i2.el.classList.contains(e2) && (I(i2.el, e2), this.emit("unselectSlide", i2)), i2.el.setAttribute(t2, "true")));
    }
    flipInfiniteTrack() {
      const t2 = this.panzoom;
      if (!t2 || !this.isInfinite)
        return;
      const e2 = "x" === this.option("axis") ? "e" : "f", { viewportDim: i2, contentDim: n2 } = this;
      let s2 = t2.current[e2], o2 = t2.target[e2] - s2, a2 = 0, r2 = 0.5 * i2, l2 = n2;
      this.isRTL && this.isHorizontal ? (s2 < -r2 && (a2 = -1, s2 += l2), s2 > l2 - r2 && (a2 = 1, s2 -= l2)) : (s2 > r2 && (a2 = 1, s2 -= l2), s2 < -l2 + r2 && (a2 = -1, s2 += l2)), a2 && (t2.current[e2] = s2, t2.target[e2] = s2 + o2);
    }
    lazyLoadSlide(t2) {
      const e2 = this, s2 = t2 && t2.el;
      if (!s2)
        return;
      const o2 = /* @__PURE__ */ new Set(), a2 = "f-fadeIn";
      s2.querySelectorAll("[data-lazy-srcset]").forEach((t3) => {
        t3 instanceof HTMLImageElement && o2.add(t3);
      }), s2.querySelectorAll("[data-lazy-src]").forEach((t3) => {
        t3 instanceof HTMLImageElement ? o2.add(t3) : n(t3) && (t3.style.backgroundImage = `url('${t3.dataset.lazySrc || ""}')`);
      });
      const r2 = (t3, i2, n2) => {
        n2 && (n2.remove(), n2 = null), i2.complete && (i2.classList.add(a2), setTimeout(() => {
          i2.classList.remove(a2);
        }, 350), i2.style.display = ""), this.option("adaptiveHeight") && t3.el && this.pages[this.page].slides.indexOf(t3) > -1 && e2.setViewportHeight();
      };
      for (const e3 of o2) {
        let n2 = null;
        e3.src = e3.dataset.lazySrcset || e3.dataset.lazySrc || "", delete e3.dataset.lazySrc, delete e3.dataset.lazySrcset, e3.style.display = "none", e3.addEventListener("error", () => {
          r2(t2, e3, n2);
        }), e3.addEventListener("load", () => {
          r2(t2, e3, n2);
        }), setTimeout(() => {
          e3.parentNode && t2.el && (e3.complete ? r2(t2, e3, n2) : (n2 = i(c), e3.parentNode.insertBefore(n2, e3)));
        }, 300);
      }
      let l2 = s2.dataset.lazySrc;
      l2 && l2.length && (s2.style.backgroundImage = `url('${l2}')`);
    }
    onAnimationEnd(t2) {
      var e2;
      const i2 = t2.target, n2 = i2 ? parseInt(i2.dataset.index || "", 10) || 0 : -1, s2 = this.slides[n2], o2 = t2.animationName;
      if (!i2 || !s2 || !o2)
        return;
      const a2 = !!this.inTransition.has(n2) && s2.transition;
      a2 && o2.substring(0, a2.length + 2) === `f-${a2}` && this.inTransition.delete(n2), this.inTransition.size || this.clearTransitions(), n2 === this.page && (null === (e2 = this.panzoom) || void 0 === e2 ? void 0 : e2.isResting) && this.emit("settle");
    }
    onDecel(t2, e2 = 0, i2 = 0, n2 = 0, s2 = 0) {
      const o2 = this.isRTL, a2 = this.isHorizontal, r2 = this.axis, l2 = this.pages.length, c2 = Math.abs(Math.atan2(i2, e2) / (Math.PI / 180));
      let h2 = 0;
      if (h2 = c2 > 45 && c2 < 135 ? a2 ? 0 : i2 : a2 ? e2 : 0, !l2)
        return;
      const d2 = this.option("dragFree");
      let u2 = this.page;
      const p2 = t2.target[r2] * (this.isRTL && a2 ? 1 : -1), { pageIndex: m2 } = this.getPageFromPosition(p2), f2 = t2.current[r2] * (o2 && a2 ? 1 : -1);
      let { page: g2 } = this.getPageFromPosition(f2);
      d2 ? this.onChange(m2) : (Math.abs(h2) > 5 ? ((this.pages.length < 3 || Math.max(Math.abs(n2), Math.abs(s2)) > this.pages[u2].slides[0].dim) && (u2 = g2), u2 = o2 && a2 ? h2 < 0 ? u2 - 1 : u2 + 1 : h2 < 0 ? u2 + 1 : u2 - 1) : u2 = g2, this.slideTo(u2, { transition: false, friction: t2.option("decelFriction") }));
    }
    onClick(t2) {
      const e2 = t2.target, i2 = e2 && n(e2) ? e2.dataset : null;
      let s2, o2;
      i2 && (void 0 !== i2.carouselPage ? (o2 = "slideTo", s2 = i2.carouselPage) : void 0 !== i2.carouselNext ? o2 = "slideNext" : void 0 !== i2.carouselPrev && (o2 = "slidePrev")), o2 ? (t2.preventDefault(), t2.stopPropagation(), e2 && !e2.hasAttribute("disabled") && this[o2](s2)) : this.emit("click", t2);
    }
    onSlideTo(t2) {
      const e2 = t2.detail || 0;
      this.slideTo(this.getPageForSlide(e2), { friction: 0 });
    }
    onChange(t2, e2 = 0) {
      const i2 = this.page;
      this.prevPage = i2, this.page = t2, this.option("adaptiveHeight") && this.setViewportHeight(), t2 !== i2 && (this.markSelectedSlides(), this.emit("change", t2, i2, e2));
    }
    onRefresh(t2, e2 = "") {
      let i2 = this.contentDim, n2 = this.viewportDim;
      this.updateMetrics(), this.contentDim === i2 && this.viewportDim === n2 || this.slideTo(this.page, { friction: 0, transition: false });
    }
    onResize() {
      this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform() {
      this.flipInfiniteTrack(), this.manageSlideVisiblity();
    }
    onEndAnimation() {
      this.emit("settle");
    }
    reInit(t2 = null, e2 = null) {
      this.destroy(), this.state = lt.Init, this.userOptions = t2 || this.userOptions, this.userPlugins = e2 || this.userPlugins, this.processOptions();
    }
    slideTo(t2 = 0, { friction: e2 = this.option("friction"), transition: i2 = this.option("transition") } = {}) {
      if (this.state === lt.Destroy)
        return;
      const n2 = this.panzoom, s2 = this.pages.length;
      if (!n2 || !s2)
        return;
      if (this.transitionTo(t2, i2))
        return;
      const o2 = this.axis, a2 = this.getPageFromIndex(t2);
      let r2 = this.pages[a2].pos, l2 = 0;
      if (this.isInfinite) {
        const t3 = n2.current[o2] * (this.isRTL && this.isHorizontal ? 1 : -1), e3 = this.contentDim, i3 = r2 + e3, s3 = r2 - e3;
        Math.abs(t3 - i3) < Math.abs(t3 - r2) && (r2 = i3, l2 = 1), Math.abs(t3 - s3) < Math.abs(t3 - r2) && (r2 = s3, l2 = -1);
      }
      r2 *= this.isRTL && this.isHorizontal ? 1 : -1, Math.abs(n2.target[o2] - r2) < 0.1 || (n2.panTo({ x: this.isHorizontal ? r2 : 0, y: this.isHorizontal ? 0 : r2, friction: e2 }), this.onChange(a2, l2));
    }
    slideToClosest(t2) {
      if (this.panzoom) {
        const { pageIndex: e2 } = this.getPageFromPosition(this.panzoom.current[this.isHorizontal ? "e" : "f"]);
        this.slideTo(e2, t2);
      }
    }
    slideNext() {
      this.slideTo(this.page + 1);
    }
    slidePrev() {
      this.slideTo(this.page - 1);
    }
    clearTransitions() {
      this.inTransition.clear(), I(this.container, this.cn("inTransition"));
      const t2 = ["to-prev", "to-next", "from-prev", "from-next"];
      for (const e2 of this.slides) {
        const i2 = e2.el;
        if (i2) {
          i2.removeEventListener("animationend", this.onAnimationEnd), i2.classList.remove(...t2);
          const n2 = e2.transition;
          n2 && i2.classList.remove(`f-${n2}Out`, `f-${n2}In`);
        }
      }
      this.manageSlideVisiblity();
    }
    prependSlide(t2) {
      var e2, i2;
      let n2 = Array.isArray(t2) ? t2 : [t2];
      for (const t3 of n2.reverse())
        this.slides.unshift(ct(t3));
      for (let t3 = 0; t3 < this.slides.length; t3++)
        this.slides[t3].index = t3;
      const s2 = (null === (e2 = this.pages[this.page]) || void 0 === e2 ? void 0 : e2.pos) || 0;
      this.page += n2.length, this.updateMetrics();
      const o2 = (null === (i2 = this.pages[this.page]) || void 0 === i2 ? void 0 : i2.pos) || 0;
      if (this.panzoom) {
        const t3 = this.isRTL ? s2 - o2 : o2 - s2;
        this.panzoom.target.e -= t3, this.panzoom.current.e -= t3, this.panzoom.requestTick();
      }
    }
    appendSlide(t2) {
      let e2 = Array.isArray(t2) ? t2 : [t2];
      for (const t3 of e2) {
        const e3 = ct(t3);
        e3.index = this.slides.length, this.slides.push(e3), this.emit("initSlide", t3, this.slides.length);
      }
      this.updateMetrics();
    }
    removeSlide(t2) {
      const e2 = this.slides.length;
      t2 = (t2 % e2 + e2) % e2, this.removeSlideEl(this.slides[t2], true), this.slides.splice(t2, 1);
      for (let t3 = 0; t3 < this.slides.length; t3++)
        this.slides[t3].index = t3;
      this.updateMetrics(), this.slideTo(this.page, { friction: 0, transition: false });
    }
    updateMetrics() {
      const t2 = this.panzoom;
      if (!this.track)
        return;
      const e2 = "e" === this.axis ? "width" : "height";
      let i2, n2 = this.pages.length, s2 = 0;
      for (const [t3, e3] of this.slides.entries()) {
        let n3 = 0, o3 = 0;
        !e3.el && i2 ? (n3 = i2.dim, o3 = i2.gap) : ({ dim: n3, gap: o3 } = this.getSlideMetrics(e3), i2 = e3), n3 = x(n3, 1e3), o3 = x(o3, 1e3), e3.dim = n3, e3.gap = o3, e3.pos = s2, s2 += n3, (this.isInfinite || t3 < this.slides.length - 1) && (s2 += o3);
      }
      this.viewport && (this.viewportDim = x(this.viewport.getBoundingClientRect()[e2], 1e3));
      const o2 = this.contentDim;
      this.contentDim = s2, t2 && (t2.contentRect[e2] = s2, t2.contentRect["e" === this.axis ? "fullWidth" : "fullHeight"] = s2), this.pages = this.createPages(), this.pages = this.processPages(), this.state === lt.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), t2 && n2 === this.pages.length && s2 !== o2 && (t2.target[this.axis] = -1 * this.pages[this.page].pos, t2.current[this.axis] = -1 * this.pages[this.page].pos, t2.stop()), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(t2, e2 = false) {
      void 0 === t2 && (t2 = this.page);
      const i2 = this, n2 = i2.panzoom, s2 = i2.pages[t2] || 0;
      if (!s2 || !n2)
        return 0;
      let o2 = -1 * n2.current.e, a2 = i2.contentDim;
      var r2 = [x((o2 - s2.pos) / (1 * s2.dim), 1e3), x((o2 + a2 - s2.pos) / (1 * s2.dim), 1e3), x((o2 - a2 - s2.pos) / (1 * s2.dim), 1e3)].reduce(function(t3, e3) {
        return Math.abs(e3) < Math.abs(t3) ? e3 : t3;
      });
      return e2 ? r2 : Math.max(-1, Math.min(1, r2));
    }
    setViewportHeight() {
      const { page: t2, pages: e2, viewport: i2, isHorizontal: n2 } = this;
      if (!i2 || !e2[t2])
        return;
      let s2 = 0;
      n2 && this.track && (this.track.style.height = "auto", e2[t2].slides.forEach((t3) => {
        t3.el && (s2 = Math.max(s2, t3.el.offsetHeight));
      })), i2.style.height = s2 ? `${s2}px` : "";
    }
    getPageForSlide(t2) {
      for (const e2 of this.pages)
        for (const i2 of e2.slides)
          if (i2.index === t2)
            return e2.index;
      return -1;
    }
    getVisibleSlides(t2 = 0) {
      var e2;
      const i2 = /* @__PURE__ */ new Set();
      let { contentDim: n2, viewportDim: s2, pages: o2, page: a2 } = this;
      n2 = n2 + (null === (e2 = this.slides[this.slides.length - 1]) || void 0 === e2 ? void 0 : e2.gap) || 0;
      let r2 = 0;
      r2 = this.panzoom ? -1 * this.panzoom.current[this.axis] : o2[a2] && o2[a2].pos || 0, this.isInfinite && (r2 -= Math.floor(r2 / n2) * n2), this.isRTL && this.isHorizontal && (r2 *= -1);
      const l2 = r2 - s2 * t2, c2 = r2 + s2 * (t2 + 1), h2 = this.isInfinite ? [-1, 0, 1] : [0];
      for (const t3 of this.slides)
        for (const e3 of h2) {
          const s3 = t3.pos + e3 * n2, o3 = t3.pos + t3.dim + t3.gap + e3 * n2;
          s3 < c2 && o3 > l2 && i2.add(t3);
        }
      return i2;
    }
    getPageFromPosition(t2) {
      const { viewportDim: e2, contentDim: i2 } = this, n2 = this.pages.length, s2 = this.slides.length, o2 = this.slides[s2 - 1];
      let a2 = 0, r2 = 0, l2 = 0;
      const c2 = this.option("center");
      c2 && (t2 += 0.5 * e2), this.isInfinite || (t2 = Math.max(this.slides[0].pos, Math.min(t2, o2.pos)));
      const h2 = i2 + o2.gap;
      l2 = Math.floor(t2 / h2) || 0, t2 -= l2 * h2;
      let d2 = o2, u2 = this.slides.find((e3) => {
        const i3 = t2 + (d2 && !c2 ? 0.5 * d2.dim : 0);
        return d2 = e3, e3.pos <= i3 && e3.pos + e3.dim + e3.gap > i3;
      });
      return u2 || (u2 = o2), r2 = this.getPageForSlide(u2.index), a2 = r2 + l2 * n2, { page: a2, pageIndex: r2 };
    }
    destroy() {
      if ([lt.Destroy].includes(this.state))
        return;
      this.state = lt.Destroy;
      const { container: t2, viewport: e2, track: i2, slides: n2, panzoom: s2 } = this, o2 = this.option("classes");
      t2.removeEventListener("click", this.onClick, { passive: false, capture: false }), t2.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s2 && (s2.destroy(), this.panzoom = null), n2 && n2.forEach((t3) => {
        this.removeSlideEl(t3);
      }), this.detachPlugins(), this.track = null, this.viewport = null, this.page = 0, e2 && i2 && e2.replaceWith(...i2.childNodes);
      for (const [e3, i3] of Object.entries(o2))
        "container" !== e3 && i3 && t2.classList.remove(i3);
      this.slides = [];
      const a2 = this.events.get("ready");
      this.events = /* @__PURE__ */ new Map(), a2 && this.events.set("ready", a2);
    }
  };
  Object.defineProperty(gt, "Panzoom", { enumerable: true, configurable: true, writable: true, value: B }), Object.defineProperty(gt, "defaults", { enumerable: true, configurable: true, writable: true, value: rt }), Object.defineProperty(gt, "Plugins", { enumerable: true, configurable: true, writable: true, value: ft });
  var bt = null;
  var vt = null;
  var yt = /* @__PURE__ */ new Map();
  var wt = 0;
  var xt = class extends g {
    get isIdle() {
      return this.idle;
    }
    get isCompact() {
      return this.option("compact");
    }
    constructor(t2 = [], e2 = {}, i2 = {}) {
      super(e2), Object.defineProperty(this, "userSlides", { enumerable: true, configurable: true, writable: true, value: [] }), Object.defineProperty(this, "userPlugins", { enumerable: true, configurable: true, writable: true, value: {} }), Object.defineProperty(this, "idle", { enumerable: true, configurable: true, writable: true, value: false }), Object.defineProperty(this, "idleTimer", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "clickTimer", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "pwt", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "ignoreFocusChange", { enumerable: true, configurable: true, writable: true, value: false }), Object.defineProperty(this, "state", { enumerable: true, configurable: true, writable: true, value: u.Init }), Object.defineProperty(this, "id", { enumerable: true, configurable: true, writable: true, value: 0 }), Object.defineProperty(this, "container", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "footer", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "caption", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "carousel", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "lastFocus", { enumerable: true, configurable: true, writable: true, value: null }), Object.defineProperty(this, "prevMouseMoveEvent", { enumerable: true, configurable: true, writable: true, value: void 0 }), Object.defineProperty(this, "fsAPI", { enumerable: true, configurable: true, writable: true, value: void 0 }), this.fsAPI = (() => {
        let t3, e3 = "", i3 = "", n2 = "";
        return document.fullscreenEnabled ? (e3 = "requestFullscreen", i3 = "exitFullscreen", n2 = "fullscreenElement") : document.webkitFullscreenEnabled && (e3 = "webkitRequestFullscreen", i3 = "webkitExitFullscreen", n2 = "webkitFullscreenElement"), e3 && (t3 = { request: function(t4) {
          return "webkitRequestFullscreen" === e3 ? t4[e3](Element.ALLOW_KEYBOARD_INPUT) : t4[e3]();
        }, exit: function() {
          return document[n2] && document[i3]();
        }, isFullscreen: function() {
          return document[n2];
        } }), t3;
      })(), this.id = e2.id || ++wt, yt.set(this.id, this), this.userSlides = t2, this.userPlugins = i2, queueMicrotask(() => {
        this.init();
      });
    }
    init() {
      this.state = u.Init, this.attachPlugins(Object.assign(Object.assign({}, xt.Plugins), this.userPlugins)), this.emit("init"), true === this.option("hideScrollbar") && (() => {
        if (!o)
          return;
        const t3 = document.body;
        if (t3.classList.contains("hide-scrollbar"))
          return;
        const e2 = window.innerWidth - document.documentElement.getBoundingClientRect().width, i2 = t3.currentStyle || window.getComputedStyle(t3), n2 = parseFloat(i2.marginRight);
        document.documentElement.style.setProperty("--fancybox-scrollbar-compensate", `${e2}px`), n2 && t3.style.setProperty("--fancybox-body-margin", `${n2}px`), t3.classList.add("hide-scrollbar");
      })(), this.initLayout();
      const t2 = () => {
        this.initCarousel(this.userSlides), this.state = u.Ready, this.attachEvents(), this.emit("ready"), setTimeout(() => {
          this.container && this.container.setAttribute("aria-hidden", "false");
        }, 16);
      };
      this.option("Fullscreen.autoStart") && this.fsAPI && !this.fsAPI.isFullscreen() ? this.fsAPI.request(this.container).then(() => t2()).catch(() => t2()) : t2();
    }
    initLayout() {
      const t2 = this.option("parentEl") || document.body, e2 = i(this.localize(this.option("tpl.main") || ""));
      e2 && (e2.setAttribute("id", `fancybox-${this.id}`), e2.setAttribute("aria-label", this.localize("{{MODAL}}")), e2.classList.toggle("is-compact", this.isCompact), D(e2, this.option("mainClass") || ""), this.container = e2, this.footer = e2.querySelector(".fancybox__footer"), t2.appendChild(e2), D(document.documentElement, "with-fancybox"), bt && vt || (bt = document.createElement("span"), D(bt, "fancybox-focus-guard"), bt.setAttribute("tabindex", "0"), bt.setAttribute("aria-hidden", "true"), bt.setAttribute("aria-label", "Focus guard"), vt = bt.cloneNode(), document.body.insertBefore(bt, e2), document.body.append(vt)), this.option("animated") && (D(e2, "is-animated"), setTimeout(() => {
        this.isClosing() || I(e2, "is-animated");
      }, 350)), this.emit("initLayout"));
    }
    initCarousel(t2) {
      const i2 = this.container;
      if (!i2)
        return;
      const n2 = i2.querySelector(".fancybox__carousel");
      if (!n2)
        return;
      const s2 = this.carousel = new gt(n2, e({}, { slides: t2, transition: "fade", Panzoom: { lockAxis: this.option("dragToClose") ? "xy" : "x", infinite: !!this.option("dragToClose") && "y" }, Dots: false, Navigation: { classes: { container: "fancybox__nav", button: "f-button", isNext: "is-next", isPrev: "is-prev" } }, initialPage: this.option("startIndex"), l10n: this.option("l10n") }, this.option("Carousel") || {}));
      s2.on("*", (t3, e2, ...i3) => {
        this.emit(`Carousel.${e2}`, t3, ...i3);
      }), s2.on(["ready", "change"], () => {
        var t3;
        const e2 = this.getSlide();
        e2 && (null === (t3 = e2.panzoom) || void 0 === t3 || t3.updateControls()), this.manageCaption(e2);
      }), s2.on("removeSlide", (t3, e2) => {
        e2.closeBtnEl && e2.closeBtnEl.remove(), e2.closeBtnEl = void 0, e2.captionEl && e2.captionEl.remove(), e2.captionEl = void 0, e2.spinnerEl && e2.spinnerEl.remove(), e2.spinnerEl = void 0, e2.state = void 0;
      }), s2.on("Panzoom.touchStart", () => {
        this.isCompact || this.endIdle();
      }), s2.on("settle", () => {
        this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && this.checkFocus();
      }), this.option("dragToClose") && (s2.on("Panzoom.afterTransform", (t3, e2) => {
        const i3 = this.getSlide();
        if (i3 && E(i3.el))
          return;
        const n3 = this.container;
        if (n3) {
          const t4 = Math.abs(e2.current.f), i4 = t4 < 1 ? "" : Math.max(0.5, Math.min(1, 1 - t4 / e2.contentRect.fitHeight * 1.5));
          n3.style.setProperty("--fancybox-ts", i4 ? "0s" : ""), n3.style.setProperty("--fancybox-opacity", i4 + "");
        }
      }), s2.on("Panzoom.touchEnd", (t3, e2, i3) => {
        var n3;
        const s3 = this.getSlide();
        if (s3 && E(s3.el))
          return;
        if (e2.isMobile && document.activeElement && -1 !== ["TEXTAREA", "INPUT"].indexOf(null === (n3 = document.activeElement) || void 0 === n3 ? void 0 : n3.nodeName))
          return;
        const o2 = Math.abs(e2.dragOffset.y);
        "y" === e2.lockedAxis && (o2 >= 200 || o2 >= 50 && e2.dragOffset.time < 300) && (i3 && i3.cancelable && i3.preventDefault(), this.close(i3, "f-throwOut" + (e2.current.f < 0 ? "Up" : "Down")));
      })), s2.on(["change"], (t3) => {
        var e2;
        let i3 = null === (e2 = this.getSlide()) || void 0 === e2 ? void 0 : e2.triggerEl;
        if (i3) {
          const e3 = new CustomEvent("slideTo", { bubbles: true, cancelable: true, detail: t3.page });
          i3.dispatchEvent(e3);
        }
      }), s2.on(["refresh", "change"], (t3) => {
        const e2 = this.container;
        if (!e2)
          return;
        for (const i4 of e2.querySelectorAll("[data-fancybox-current-index]"))
          i4.innerHTML = t3.page + 1;
        for (const i4 of e2.querySelectorAll("[data-fancybox-count]"))
          i4.innerHTML = t3.pages.length;
        if (!t3.isInfinite) {
          for (const i4 of e2.querySelectorAll("[data-fancybox-next]"))
            t3.page < t3.pages.length - 1 ? (i4.removeAttribute("disabled"), i4.removeAttribute("tabindex")) : (i4.setAttribute("disabled", ""), i4.setAttribute("tabindex", "-1"));
          for (const i4 of e2.querySelectorAll("[data-fancybox-prev]"))
            t3.page > 0 ? (i4.removeAttribute("disabled"), i4.removeAttribute("tabindex")) : (i4.setAttribute("disabled", ""), i4.setAttribute("tabindex", "-1"));
        }
        const i3 = this.getSlide();
        if (!i3)
          return;
        let n3 = i3.downloadSrc || "";
        n3 || "image" !== i3.type || i3.error || "string" != typeof i3.src || (n3 = i3.src);
        for (const t4 of e2.querySelectorAll("[data-fancybox-download]")) {
          const e3 = i3.downloadFilename;
          n3 ? (t4.removeAttribute("disabled"), t4.removeAttribute("tabindex"), t4.setAttribute("href", n3), t4.setAttribute("download", e3 || n3), t4.setAttribute("target", "_blank")) : (t4.setAttribute("disabled", ""), t4.setAttribute("tabindex", "-1"), t4.removeAttribute("href"), t4.removeAttribute("download"));
        }
      }), this.emit("initCarousel");
    }
    attachEvents() {
      const t2 = this.container;
      t2 && (t2.addEventListener("click", this.onClick, { passive: false, capture: false }), t2.addEventListener("wheel", this.onWheel, { passive: false, capture: false }), document.addEventListener("keydown", this.onKeydown, { passive: false, capture: true }), document.addEventListener("visibilitychange", this.onVisibilityChange, false), document.addEventListener("mousemove", this.onMousemove), this.option("trapFocus") && document.addEventListener("focus", this.onFocus, true), window.addEventListener("resize", this.onResize));
    }
    detachEvents() {
      const t2 = this.container;
      t2 && (document.removeEventListener("keydown", this.onKeydown, { passive: false, capture: true }), t2.removeEventListener("wheel", this.onWheel, { passive: false, capture: false }), t2.removeEventListener("click", this.onClick, { passive: false, capture: false }), document.removeEventListener("mousemove", this.onMousemove), window.removeEventListener("resize", this.onResize), document.removeEventListener("visibilitychange", this.onVisibilityChange, false), document.removeEventListener("focus", this.onFocus, true));
    }
    onClick(t2) {
      var e2, i2;
      if (this.isClosing())
        return;
      !this.isCompact && this.option("idle") && this.resetIdle();
      const n2 = t2.composedPath()[0];
      if (n2 === (null === (e2 = this.carousel) || void 0 === e2 ? void 0 : e2.container))
        return;
      if (n2.closest(".f-spinner") || n2.closest("[data-fancybox-close]"))
        return t2.preventDefault(), void this.close(t2);
      if (n2.closest("[data-fancybox-prev]"))
        return t2.preventDefault(), void this.prev();
      if (n2.closest("[data-fancybox-next]"))
        return t2.preventDefault(), void this.next();
      if (this.isCompact && "image" === (null === (i2 = this.getSlide()) || void 0 === i2 ? void 0 : i2.type))
        return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(() => {
          this.toggleIdle(), this.clickTimer = null;
        }, 350));
      if (this.emit("click", t2), t2.defaultPrevented)
        return;
      let s2 = false;
      const o2 = document.activeElement;
      if (n2.closest(".fancybox__content")) {
        if (o2) {
          if (o2.closest("[contenteditable]"))
            return;
          n2.matches(r) || o2.blur();
        }
        if ((a2 = window.getSelection()) && "Range" === a2.type)
          return;
        s2 = this.option("contentClick");
      } else
        n2.closest(".fancybox__carousel") && !n2.matches(r) && (s2 = this.option("backdropClick"));
      var a2;
      "close" === s2 ? (t2.preventDefault(), this.close(t2)) : "next" === s2 ? (t2.preventDefault(), this.next()) : "prev" === s2 && (t2.preventDefault(), this.prev());
    }
    onWheel(t2) {
      const e2 = this.option("wheel", t2), i2 = "slide" === e2, n2 = [-t2.deltaX || 0, -t2.deltaY || 0, -t2.detail || 0].reduce(function(t3, e3) {
        return Math.abs(e3) > Math.abs(t3) ? e3 : t3;
      }), s2 = Math.max(-1, Math.min(1, n2)), o2 = Date.now();
      this.pwt && o2 - this.pwt < 300 ? i2 && t2.preventDefault() : (this.pwt = o2, this.emit("wheel", t2), t2.defaultPrevented || ("close" === e2 ? (t2.preventDefault(), this.close(t2)) : "slide" === e2 && (t2.preventDefault(), this[s2 > 0 ? "prev" : "next"]())));
    }
    onKeydown(t2) {
      if (!this.isTopmost())
        return;
      this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
      const e2 = t2.key, i2 = this.option("keyboard");
      if (!i2 || t2.ctrlKey || t2.altKey || t2.shiftKey)
        return;
      const s2 = t2.composedPath()[0], o2 = document.activeElement && document.activeElement.classList, a2 = o2 && o2.contains("f-button") || s2.dataset.carouselPage || s2.dataset.carouselIndex;
      if ("Escape" !== e2 && !a2 && n(s2)) {
        if (s2.isContentEditable || -1 !== ["TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].indexOf(s2.nodeName))
          return;
      }
      this.emit("keydown", e2, t2);
      const r2 = i2[e2];
      "function" == typeof this[r2] && (t2.preventDefault(), this[r2]());
    }
    onResize() {
      const t2 = this.container;
      if (!t2)
        return;
      const e2 = this.isCompact;
      t2.classList.toggle("is-compact", e2), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.emit("resize");
    }
    onFocus(t2) {
      this.isTopmost() && this.checkFocus(t2);
    }
    onMousemove(t2) {
      this.prevMouseMoveEvent = t2, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
      "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t2) {
      const e2 = this.optionFor(t2, "closeButton") || false;
      if ("auto" === e2) {
        const t3 = this.plugins.Toolbar;
        if (t3 && t3.state === tt.Ready)
          return;
      }
      if (!e2)
        return;
      if (!t2.contentEl || t2.closeBtnEl)
        return;
      const n2 = this.option("tpl.closeButton");
      if (n2) {
        const e3 = i(this.localize(n2));
        t2.closeBtnEl = t2.contentEl.appendChild(e3), t2.el && D(t2.el, "has-close-btn");
      }
    }
    manageCaption(t2) {
      var e2, i2;
      const n2 = "fancybox__caption", s2 = "has-caption", o2 = this.container;
      if (!o2)
        return;
      const a2 = this.isCompact || this.option("commonCaption"), r2 = !a2;
      if (this.caption && this.stop(this.caption), r2 && this.caption && (this.caption.remove(), this.caption = null), a2 && !this.caption)
        for (const t3 of (null === (e2 = this.carousel) || void 0 === e2 ? void 0 : e2.slides) || [])
          t3.captionEl && (t3.captionEl.remove(), t3.captionEl = void 0, I(t3.el, s2), null === (i2 = t3.el) || void 0 === i2 || i2.removeAttribute("aria-labelledby"));
      if (t2 || (t2 = this.getSlide()), !t2 || a2 && !this.isCurrentSlide(t2))
        return;
      const l2 = t2.el;
      let c2 = this.optionFor(t2, "caption", "");
      if ("string" != typeof c2 || !c2.length)
        return void (a2 && this.caption && this.animate(this.caption, "f-fadeOut", () => {
          var t3;
          null === (t3 = this.caption) || void 0 === t3 || t3.remove(), this.caption = null;
        }));
      let h2 = null;
      if (r2) {
        if (h2 = t2.captionEl || null, l2 && !h2) {
          const e3 = `fancybox__caption_${this.id}_${t2.index}`;
          h2 = document.createElement("div"), D(h2, n2), h2.setAttribute("id", e3), t2.captionEl = l2.appendChild(h2), D(l2, s2), l2.setAttribute("aria-labelledby", e3);
        }
      } else {
        if (h2 = this.caption, h2 || (h2 = o2.querySelector("." + n2)), !h2) {
          h2 = document.createElement("div"), h2.dataset.fancyboxCaption = "", D(h2, n2), h2.innerHTML = c2;
          (this.footer || o2).prepend(h2);
        }
        D(o2, s2), this.caption = h2;
      }
      h2 && (h2.innerHTML = c2);
    }
    checkFocus(t2) {
      var e2;
      const i2 = document.activeElement || null;
      i2 && (null === (e2 = this.container) || void 0 === e2 ? void 0 : e2.contains(i2)) || this.focus(t2);
    }
    focus(t2) {
      var e2;
      if (this.ignoreFocusChange)
        return;
      const i2 = document.activeElement || null, n2 = (null == t2 ? void 0 : t2.target) || null, s2 = this.container, o2 = this.getSlide();
      if (!s2 || !(null === (e2 = this.carousel) || void 0 === e2 ? void 0 : e2.viewport))
        return;
      if (!t2 && i2 && s2.contains(i2))
        return;
      const a2 = o2 && o2.state === p.Ready ? o2.el : null;
      if (!a2 || a2.contains(i2) || s2 === i2)
        return;
      t2 && t2.cancelable && t2.preventDefault(), this.ignoreFocusChange = true;
      const c2 = Array.from(s2.querySelectorAll(r));
      let h2 = [], d2 = null;
      for (let t3 of c2) {
        const e3 = !t3.offsetParent || t3.closest('[aria-hidden="true"]'), i3 = a2 && a2.contains(t3), n3 = !this.carousel.viewport.contains(t3);
        t3 === s2 || (i3 || n3) && !e3 ? (h2.push(t3), void 0 !== t3.dataset.origTabindex && (t3.tabIndex = parseFloat(t3.dataset.origTabindex)), t3.removeAttribute("data-orig-tabindex"), !t3.hasAttribute("autoFocus") && d2 || (d2 = t3)) : (t3.dataset.origTabindex = void 0 === t3.dataset.origTabindex ? t3.getAttribute("tabindex") || void 0 : t3.dataset.origTabindex, t3.tabIndex = -1);
      }
      let u2 = null;
      t2 ? (!n2 || h2.indexOf(n2) < 0) && (u2 = d2 || s2, h2.length && (i2 === vt ? u2 = h2[0] : this.lastFocus !== s2 && i2 !== bt || (u2 = h2[h2.length - 1]))) : u2 = o2 && "image" === o2.type ? s2 : d2 || s2, u2 && l(u2), this.lastFocus = document.activeElement, this.ignoreFocusChange = false;
    }
    next() {
      const t2 = this.carousel;
      t2 && t2.pages.length > 1 && t2.slideNext();
    }
    prev() {
      const t2 = this.carousel;
      t2 && t2.pages.length > 1 && t2.slidePrev();
    }
    jumpTo(...t2) {
      this.carousel && this.carousel.slideTo(...t2);
    }
    isTopmost() {
      var t2;
      return (null === (t2 = xt.getInstance()) || void 0 === t2 ? void 0 : t2.id) == this.id;
    }
    animate(t2 = null, e2 = "", i2) {
      if (!t2 || !e2)
        return void (i2 && i2());
      this.stop(t2);
      const n2 = (s2) => {
        s2.target === t2 && t2.dataset.animationName && (t2.removeEventListener("animationend", n2), delete t2.dataset.animationName, i2 && i2(), I(t2, e2));
      };
      t2.dataset.animationName = e2, t2.addEventListener("animationend", n2), D(t2, e2);
    }
    stop(t2) {
      t2 && t2.dispatchEvent(new CustomEvent("animationend", { bubbles: false, cancelable: true, currentTarget: t2 }));
    }
    setContent(t2, e2 = "", s2 = true) {
      if (this.isClosing())
        return;
      const o2 = t2.el;
      if (!o2)
        return;
      let a2 = null;
      n(e2) ? ["img", "picture", "iframe", "video", "audio"].includes(e2.nodeName.toLowerCase()) ? (a2 = document.createElement("div"), a2.appendChild(e2)) : a2 = e2 : "string" == typeof e2 && (a2 = i(e2)), a2 instanceof Element && t2.filter && !t2.error && (a2 = a2.querySelector(t2.filter)), a2 instanceof Element ? (D(a2, "fancybox__content"), t2.id && a2.setAttribute("id", t2.id), "none" !== a2.style.display && "none" !== getComputedStyle(a2).getPropertyValue("display") || (a2.style.display = t2.display || this.option("defaultDisplay") || "flex"), o2.classList.add(`has-${t2.error ? "error" : t2.type || "unknown"}`), o2.prepend(a2), t2.contentEl = a2, s2 && this.revealContent(t2), this.manageCloseBtn(t2), this.manageCaption(t2)) : this.setError(t2, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t2, e2) {
      const i2 = t2.el, n2 = t2.contentEl;
      i2 && n2 && (this.emit("reveal", t2), this.hideLoading(t2), t2.state = p.Opening, (e2 = this.isOpeningSlide(t2) ? void 0 === e2 ? this.optionFor(t2, "showClass") : e2 : "f-fadeIn") ? this.animate(n2, e2, () => {
        this.done(t2);
      }) : this.done(t2));
    }
    done(t2) {
      this.isClosing() || (t2.state = p.Ready, this.emit("done", t2), D(t2.el, "is-done"), this.isCurrentSlide(t2) && this.option("autoFocus") && queueMicrotask(() => {
        this.option("autoFocus") && (this.option("autoFocus") ? this.focus() : this.checkFocus());
      }), this.isOpeningSlide(t2) && !this.isCompact && this.option("idle") && this.setIdle());
    }
    isCurrentSlide(t2) {
      const e2 = this.getSlide();
      return !(!t2 || !e2) && e2.index === t2.index;
    }
    isOpeningSlide(t2) {
      var e2, i2;
      return null === (null === (e2 = this.carousel) || void 0 === e2 ? void 0 : e2.prevPage) && t2.index === (null === (i2 = this.getSlide()) || void 0 === i2 ? void 0 : i2.index);
    }
    showLoading(t2) {
      t2.state = p.Loading;
      const e2 = t2.el;
      if (!e2)
        return;
      D(e2, "is-loading"), this.emit("loading", t2), t2.spinnerEl || setTimeout(() => {
        if (!this.isClosing() && !t2.spinnerEl && t2.state === p.Loading) {
          let n2 = i(c);
          t2.spinnerEl = n2, e2.prepend(n2), this.animate(n2, "f-fadeIn");
        }
      }, 250);
    }
    hideLoading(t2) {
      const e2 = t2.el;
      if (!e2)
        return;
      const i2 = t2.spinnerEl;
      this.isClosing() ? null == i2 || i2.remove() : (I(e2, "is-loading"), i2 && this.animate(i2, "f-fadeOut", () => {
        i2.remove();
      }), t2.state === p.Loading && (this.emit("loaded", t2), t2.state = p.Ready));
    }
    setError(t2, e2) {
      if (this.isClosing())
        return;
      this.emit("error"), t2.error = e2, this.hideLoading(t2), this.clearContent(t2);
      const i2 = document.createElement("div");
      i2.classList.add("fancybox-error"), i2.innerHTML = this.localize(e2 || "<p>{{ERROR}}</p>"), this.setContent(t2, i2);
    }
    clearContent(t2) {
      var e2;
      null === (e2 = this.carousel) || void 0 === e2 || e2.emit("removeSlide", t2), t2.contentEl && (t2.contentEl.remove(), t2.contentEl = void 0), t2.closeBtnEl && (t2.closeBtnEl.remove(), t2.closeBtnEl = void 0);
      const i2 = t2.el;
      i2 && (I(i2, "is-loading"), I(i2, "has-error"), I(i2, "has-unknown"), I(i2, `has-${t2.type || "unknown"}`));
    }
    getSlide() {
      var t2;
      const e2 = this.carousel;
      return (null === (t2 = null == e2 ? void 0 : e2.pages[null == e2 ? void 0 : e2.page]) || void 0 === t2 ? void 0 : t2.slides[0]) || void 0;
    }
    close(t2, e2) {
      if (this.isClosing())
        return;
      const i2 = new Event("shouldClose", { bubbles: true, cancelable: true });
      if (this.emit("shouldClose", i2, t2), i2.defaultPrevented)
        return;
      t2 && t2.cancelable && (t2.preventDefault(), t2.stopPropagation());
      const n2 = this.fsAPI, s2 = () => {
        this.proceedClose(t2, e2);
      };
      n2 && n2.isFullscreen() ? Promise.resolve(n2.exit()).then(() => s2()) : s2();
    }
    clearIdle() {
      this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t2 = false) {
      const e2 = () => {
        this.clearIdle(), this.idle = true, D(this.container, "is-idle"), this.emit("setIdle");
      };
      if (this.clearIdle(), !this.isClosing())
        if (t2)
          e2();
        else {
          const t3 = this.option("idle");
          t3 && (this.idleTimer = setTimeout(e2, t3));
        }
    }
    endIdle() {
      this.clearIdle(), this.idle && !this.isClosing() && (this.idle = false, I(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
      this.endIdle(), this.setIdle();
    }
    toggleIdle() {
      this.idle ? this.endIdle() : this.setIdle(true);
    }
    toggleFullscreen() {
      const t2 = this.fsAPI;
      t2 && (t2.isFullscreen() ? t2.exit() : this.container && t2.request(this.container));
    }
    isClosing() {
      return [u.Closing, u.CustomClosing, u.Destroy].includes(this.state);
    }
    proceedClose(t2, e2) {
      var i2;
      this.state = u.Closing, this.clearIdle(), this.detachEvents();
      const n2 = this.container, o2 = this.carousel, a2 = this.getSlide(), r2 = a2 && this.option("placeFocusBack") ? a2.triggerEl || this.option("trigger") : null;
      if (r2 && (s(r2) ? l(r2) : r2.focus()), n2 && (D(n2, "is-closing"), n2.setAttribute("aria-hidden", "true"), this.option("animated") && D(n2, "is-animated"), n2.style.pointerEvents = "none"), o2) {
        o2.clearTransitions(), null === (i2 = o2.panzoom) || void 0 === i2 || i2.destroy();
        for (const t3 of o2.slides) {
          t3.state = p.Closing, this.hideLoading(t3);
          const e3 = t3.contentEl;
          e3 && this.stop(e3);
          const i3 = null == t3 ? void 0 : t3.panzoom;
          i3 && (i3.stop(), i3.detachEvents(), i3.detachObserver()), this.isCurrentSlide(t3) || o2.emit("removeSlide", t3);
        }
      }
      this.emit("close", t2), this.state !== u.CustomClosing ? (void 0 === e2 && a2 && (e2 = this.optionFor(a2, "hideClass")), e2 && a2 ? (this.animate(a2.contentEl, e2, () => {
        o2 && o2.emit("removeSlide", a2);
      }), setTimeout(() => {
        this.destroy();
      }, 500)) : this.destroy()) : setTimeout(() => {
        this.destroy();
      }, 500);
    }
    destroy() {
      var t2;
      if (this.state === u.Destroy)
        return;
      this.state = u.Destroy, null === (t2 = this.carousel) || void 0 === t2 || t2.destroy();
      const e2 = this.container;
      e2 && e2.remove(), yt.delete(this.id);
      const i2 = xt.getInstance();
      i2 ? i2.focus() : (bt && (bt.remove(), bt = null), vt && (vt.remove(), vt = null), I(document.documentElement, "with-fancybox"), (() => {
        if (!o)
          return;
        const t3 = document, e3 = t3.body;
        e3.classList.remove("hide-scrollbar"), e3.style.setProperty("--fancybox-body-margin", ""), t3.documentElement.style.setProperty("--fancybox-scrollbar-compensate", "");
      })(), this.emit("destroy"));
    }
    static bind(t2, e2, i2) {
      if (!o)
        return;
      let s2, a2 = "", r2 = {};
      if (void 0 === t2 ? s2 = document.body : "string" == typeof t2 ? (s2 = document.body, a2 = t2, "object" == typeof e2 && (r2 = e2 || {})) : (s2 = t2, "string" == typeof e2 && (a2 = e2), "object" == typeof i2 && (r2 = i2 || {})), !s2 || !n(s2))
        return;
      a2 = a2 || "[data-fancybox]";
      const l2 = xt.openers.get(s2) || /* @__PURE__ */ new Map();
      l2.set(a2, r2), xt.openers.set(s2, l2), 1 === l2.size && s2.addEventListener("click", xt.fromEvent);
    }
    static unbind(t2, e2) {
      let i2, n2 = "";
      if ("string" == typeof t2 ? (i2 = document.body, n2 = t2) : (i2 = t2, "string" == typeof e2 && (n2 = e2)), !i2)
        return;
      const s2 = xt.openers.get(i2);
      s2 && n2 && s2.delete(n2), n2 && s2 || (xt.openers.delete(i2), i2.removeEventListener("click", xt.fromEvent));
    }
    static destroy() {
      let t2;
      for (; t2 = xt.getInstance(); )
        t2.destroy();
      for (const t3 of xt.openers.keys())
        t3.removeEventListener("click", xt.fromEvent);
      xt.openers = /* @__PURE__ */ new Map();
    }
    static fromEvent(t2) {
      if (t2.defaultPrevented)
        return;
      if (t2.button && 0 !== t2.button)
        return;
      if (t2.ctrlKey || t2.metaKey || t2.shiftKey)
        return;
      let i2 = t2.composedPath()[0];
      const n2 = i2.closest("[data-fancybox-trigger]");
      if (n2) {
        const t3 = n2.dataset.fancyboxTrigger || "", e2 = document.querySelectorAll(`[data-fancybox="${t3}"]`), s3 = parseInt(n2.dataset.fancyboxIndex || "", 10) || 0;
        i2 = e2[s3] || i2;
      }
      if (!(i2 && i2 instanceof Element))
        return;
      let s2, o2, a2, r2;
      if ([...xt.openers].reverse().find(([t3, e2]) => !(!t3.contains(i2) || ![...e2].reverse().find(([e3, n3]) => {
        let l3 = i2.closest(e3);
        return !!l3 && (s2 = t3, o2 = e3, a2 = l3, r2 = n3, true);
      }))), !s2 || !o2 || !a2)
        return;
      r2 = r2 || {}, t2.preventDefault(), i2 = a2;
      let l2 = [], c2 = e({}, d, r2);
      c2.event = t2, c2.trigger = i2, c2.delegate = n2;
      const h2 = c2.groupAll, u2 = c2.groupAttr, p2 = u2 && i2 ? i2.getAttribute(`${u2}`) : "";
      if ((!i2 || p2 || h2) && (l2 = [].slice.call(s2.querySelectorAll(o2))), i2 && !h2 && (l2 = p2 ? l2.filter((t3) => t3.getAttribute(`${u2}`) === p2) : [i2]), !l2.length)
        return;
      const m2 = xt.getInstance();
      return m2 && m2.options.trigger && l2.indexOf(m2.options.trigger) > -1 ? void 0 : (i2 && (c2.startIndex = l2.indexOf(i2)), xt.fromNodes(l2, c2));
    }
    static fromNodes(t2, i2) {
      i2 = e({}, d, i2);
      const n2 = [];
      for (const e2 of t2) {
        const t3 = e2.dataset || {}, s2 = t3.src || e2.getAttribute("href") || e2.getAttribute("currentSrc") || e2.getAttribute("src") || void 0;
        let o2;
        const a2 = i2.delegate;
        let r2;
        a2 && n2.length === i2.startIndex && (o2 = a2 instanceof HTMLImageElement ? a2 : a2.querySelector("img:not([aria-hidden])")), o2 || (o2 = e2 instanceof HTMLImageElement ? e2 : e2.querySelector("img:not([aria-hidden])")), o2 && (r2 = o2.currentSrc || o2.src || void 0, !r2 && o2.dataset && (r2 = o2.dataset.lazySrc || o2.dataset.src || void 0));
        const l2 = { src: s2, triggerEl: e2, thumbEl: o2, thumbElSrc: r2, thumbSrc: r2 };
        for (const e3 in t3)
          "fancybox" !== e3 && (l2[e3] = t3[e3] + "");
        n2.push(l2);
      }
      return new xt(n2, i2);
    }
    static getInstance(t2) {
      if (t2)
        return yt.get(t2);
      return Array.from(yt.values()).reverse().find((t3) => !t3.isClosing() && t3) || null;
    }
    static getSlide() {
      var t2;
      return (null === (t2 = xt.getInstance()) || void 0 === t2 ? void 0 : t2.getSlide()) || null;
    }
    static show(t2 = [], e2 = {}) {
      return new xt(t2, e2);
    }
    static next() {
      const t2 = xt.getInstance();
      t2 && t2.next();
    }
    static prev() {
      const t2 = xt.getInstance();
      t2 && t2.prev();
    }
    static close(t2 = true, ...e2) {
      if (t2)
        for (const t3 of yt.values())
          t3.close(...e2);
      else {
        const t3 = xt.getInstance();
        t3 && t3.close(...e2);
      }
    }
  };
  Object.defineProperty(xt, "version", { enumerable: true, configurable: true, writable: true, value: "5.0.13" }), Object.defineProperty(xt, "defaults", { enumerable: true, configurable: true, writable: true, value: d }), Object.defineProperty(xt, "Plugins", { enumerable: true, configurable: true, writable: true, value: st }), Object.defineProperty(xt, "openers", { enumerable: true, configurable: true, writable: true, value: /* @__PURE__ */ new Map() });

  // src/inc/observeIntersection.js
  function observeIntersection(el, callback, once, thresh, root, rootm) {
    const options = {
      root,
      rootMargin: rootm,
      threshold: thresh
    };
    const elContainer = document.querySelectorAll(el);
    const elObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback(entry, true);
          if (once) {
            elObserver.unobserve(entry.target);
          }
        } else {
          callback(entry, false);
        }
      });
    }, options);
    elContainer.forEach((target) => {
      elObserver.observe(target);
    });
  }

  // src/veggie-main.js
  var import_rellax = __toESM(require_rellax());
  document.addEventListener("DOMContentLoaded", () => {
    const frontpageHeaderWrapper = document.getElementById("frontpageHeaderWrapper");
    const allSlides = document.querySelectorAll("#frontpageSlider .splide__slide");
    if (frontpageHeaderWrapper) {
      frontpageHeaderWrapper.style.setProperty("--header-bg", allSlides[0].dataset.bgcolor);
      const frontpageSlider = new Splide("#frontpageSlider", {
        arrows: false,
        autoplay: true,
        interval: 3500,
        type: "loop"
      });
      frontpageSlider.mount();
      frontpageSlider.on("move", (i2) => {
        frontpageHeaderWrapper.style.setProperty("--header-bg", allSlides[i2].dataset.bgcolor);
        const frontpageHeaderProducts = document.querySelectorAll("#frontpageHeaderProducts > div");
        frontpageHeaderProducts.forEach((product) => {
          product.classList.remove("active");
        });
        frontpageHeaderProducts[i2].classList.add("active");
      });
    }
    const productContainmentsToggle = document.querySelectorAll(".productContainmentsToggle");
    const productContainmentsContent = document.querySelectorAll(".productContainmentsContent");
    if (productContainmentsToggle && productContainmentsContent) {
      document.addEventListener("click", (event2) => {
        if (event2.target.closest(".productContainmentsToggle")) {
          for (let i2 = 0; i2 < productContainmentsToggle.length; i2++) {
            if (event2.target.closest(".productContainmentsToggle") === productContainmentsToggle[i2]) {
              productContainmentsToggle.forEach((el) => {
                el.classList.add("after:v-scale-x-0");
              });
              productContainmentsContent.forEach((el) => {
                el.classList.add("v-hidden");
              });
              productContainmentsToggle[i2].classList.remove("after:v-scale-x-0");
              productContainmentsContent[i2].classList.remove("v-hidden");
              console.log(i2);
            }
          }
        }
      });
    }
    const megamenu = document.getElementById("megamenu");
    const megamenuBg = document.getElementById("megamenuBg");
    if (megamenu && megamenuBg) {
      const AccessibleNav = document.getElementById("AccessibleNav");
      const menuEls = AccessibleNav.querySelectorAll(".site-nav__item");
      const megamenuItems = document.querySelectorAll("[data-menuorder]");
      const megamenuEls = document.querySelectorAll(".megamenuEl");
      menuEls.forEach((li) => {
        li.addEventListener("mouseenter", (e2) => {
          let menuElIndex = 0;
          for (let i2 = 0; i2 < menuEls.length; i2++) {
            if (e2.target === menuEls[i2]) {
              menuElIndex = i2;
            }
          }
          const megamenuItem = document.querySelectorAll(`[data-menuorder="${menuElIndex + 1}"]`);
          if (megamenuItem.length) {
            megamenu.classList.add("v-pointer-events-auto", "v-opacity-100");
            megamenu.classList.remove("v-opacity-0");
            megamenuBg.classList.remove("v-opacity-0");
            megamenuBg.classList.add("v-opacity-30");
            megamenuItems.forEach((el) => {
              el.classList.add("v-h-0");
              el.classList.remove("v-h-auto");
            });
            megamenuItem[0].classList.add("v-h-auto");
            megamenuItem[0].classList.remove("v-h-0");
            const megamenuItemEls = megamenuItem[0].querySelectorAll(".megamenuEl");
            megamenuItemEls.forEach((el) => {
              el.classList.remove("v-opacity-0", "v-translate-y-1");
            });
          } else {
            megamenu.classList.remove("v-pointer-events-auto", "v-opacity-100");
            megamenu.classList.add("v-opacity-0");
            megamenuBg.classList.remove("v-opacity-30");
            megamenuBg.classList.add("v-opacity-0");
            megamenuItems.forEach((el) => {
              el.classList.add("v-h-0");
              el.classList.remove("v-h-auto");
            });
            megamenuEls.forEach((el) => {
              el.classList.add("v-opacity-0", "v-translate-y-1");
            });
          }
        });
      });
      megamenu.addEventListener("mouseleave", () => {
        megamenu.classList.remove("v-pointer-events-auto", "v-opacity-100");
        megamenu.classList.add("v-opacity-0");
        megamenuBg.classList.remove("v-opacity-30");
        megamenuBg.classList.add("v-opacity-0");
        megamenuItems.forEach((el) => {
          el.classList.add("v-h-0");
          el.classList.remove("v-h-auto");
        });
        megamenuEls.forEach((el) => {
          el.classList.add("v-opacity-0", "v-translate-y-1");
        });
      });
    }
    const headerSearch = document.getElementById("headerSearch");
    const headerSearchForm = headerSearch.parentNode.querySelectorAll(".search-bar--header")[0];
    if (headerSearch) {
      headerSearch.addEventListener("click", () => {
        headerSearchForm.classList.remove("v-opacity-0", "v-pointer-events-none", "-v-translate-x-4");
      });
      headerSearchForm.addEventListener("focusout", () => {
        headerSearchForm.classList.add("v-opacity-0", "v-pointer-events-none", "-v-translate-x-4");
      });
    }
    document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(function(link) {
      link.addEventListener("click", function(event2) {
        if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
          var target = document.querySelector(this.hash);
          target = target ? target : document.querySelector("[name=" + this.hash.slice(1) + "]");
          if (target) {
            event2.preventDefault();
            window.scrollTo({
              top: target.offsetTop,
              behavior: "smooth"
            });
          }
        }
      });
    });
    observeIntersection(
      ".fadeIn",
      (e2, intersected) => {
        if (intersected) {
          if (!e2.target.classList.contains("vis")) {
            e2.target.classList.add("vis");
          }
        }
      },
      true
    );
    observeIntersection(
      ".fadeInRow",
      (e2, intersected) => {
        if (intersected) {
          const objects = e2.target.querySelectorAll(
            ":scope > div,:scope > li,:scope > p"
          );
          if (objects) {
            objects.forEach((el, index) => {
              if (!el.classList.contains("vis")) {
                setTimeout(() => {
                  el.classList.add("vis");
                }, 150 * index);
              }
            });
          }
        }
      },
      true
    );
    fadeInInit();
    document.addEventListener("shopify:section:load", () => {
      fadeInInit();
    });
    const rellaxInis = [];
    observeIntersection(
      ".rellax",
      (e2, intersected) => {
        if (intersected && windowWidth > 960) {
          const findIni = rellaxInis.find((ini) => ini[0] === e2.target);
          if (!findIni) {
            const rellaxIni = new import_rellax.default(e2.target, {
              center: true
            });
            rellaxInis.push([e2.target, rellaxIni]);
          }
        } else {
          const findIni = rellaxInis.find((ini) => ini[0] === e2.target);
          if (findIni) {
            const findIniIndex = rellaxInis.indexOf(findIni);
            findIni[1].destroy();
            rellaxInis.splice(findIniIndex, 1);
          }
        }
      },
      false,
      0,
      void 0,
      "40% 0% 40% 0%"
    );
    xt.bind("[data-fancybox]", {
      on: {
        done: () => {
          const headerVideo = document.getElementById("headerVideo");
          if (headerVideo) {
            headerVideo.querySelectorAll("video")[0].play();
          }
        },
        close: () => {
          const headerVideo = document.getElementById("headerVideo");
          if (headerVideo) {
            headerVideo.querySelectorAll("video")[0].pause();
          }
        }
      }
    });
  });
  var endOfResize = "";
  var windowWidth = window.innerWidth;
  window.onresize = () => {
    clearTimeout(endOfResize);
    endOfResize = setTimeout(() => {
      windowWidth = window.innerWidth;
      windowHeight = window.innerHeight;
    }, 250);
  };
  var fadeInInit = () => {
    observeIntersection(
      ".fadeIn",
      (e2, intersected) => {
        if (intersected) {
          if (!e2.target.classList.contains("vis")) {
            e2.target.classList.add("vis");
          }
        }
      },
      true
    );
    observeIntersection(
      ".fadeInRow",
      (e2, intersected) => {
        if (intersected) {
          const objects = e2.target.querySelectorAll(
            ":scope > div,:scope > li,:scope > p"
          );
          if (objects) {
            objects.forEach((el, index) => {
              if (!el.classList.contains("vis")) {
                setTimeout(() => {
                  el.classList.add("vis");
                }, 150 * index);
              }
            });
          }
        }
      },
      true
    );
  };
})();
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
